import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Decimal: any;
  Json: any;
  NaiveDateTime: any;
  UUID4: any;
};

export type Account = {
  __typename?: 'Account';
  appId?: Maybe<Scalars['UUID4']>;
  credits: Array<Credit>;
  id?: Maybe<Scalars['UUID4']>;
  invoicing?: Maybe<Invoicing>;
  managedAddressesOnly?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  sapLink?: Maybe<SapLink>;
  submittedOrders?: Maybe<SubmittedOrderPayload>;
  tags?: Maybe<Array<Scalars['String']>>;
  type: Scalars['String'];
};


export type AccountCreditsArgs = {
  search?: InputMaybe<AccountCreditsSearchInput>;
};


export type AccountSubmittedOrdersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export enum AccountCreditStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Inactive = 'INACTIVE'
}

export enum AccountCreditType {
  Allocation = 'ALLOCATION',
  Prepaid = 'PREPAID'
}

export type AccountCreditsSearchInput = {
  frozen?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Array<InputMaybe<AccountCreditStatus>>>;
  type?: InputMaybe<AccountCreditType>;
};

export type AccountVerificationLocalization = {
  __typename?: 'AccountVerificationLocalization';
  body: Scalars['String'];
  buttonText: Scalars['String'];
  contactSupportText: Scalars['String'];
  emailSentText: Scalars['String'];
  heading: Scalars['String'];
  invalidLinkText: Scalars['String'];
  tokenExpiredText: Scalars['String'];
  verifySuccessText: Scalars['String'];
};

/**
 * Account that the user is currently logged into.
 *
 * This will only exist if the user belongs to an account.
 */
export type ActiveAccount = {
  __typename?: 'ActiveAccount';
  id: Scalars['UUID4'];
  isInvoiced?: Maybe<Scalars['Boolean']>;
  managedAddressesOnly?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  type: Scalars['String'];
};

export type AddOrderSubscriptionItemInput = {
  analyticsDetails?: InputMaybe<Scalars['Json']>;
  customizations?: InputMaybe<Scalars['Json']>;
  itemId: Scalars['UUID4'];
  quantity: Scalars['Int'];
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['UUID4'];
  isDefault?: Maybe<Scalars['Boolean']>;
  isRemovable?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  specialInstructions?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  user: User;
  zip: Scalars['String'];
};

export type AddressConfig = {
  __typename?: 'AddressConfig';
  addressNickname?: Maybe<Scalars['Boolean']>;
  addressSpecialInstructions?: Maybe<Scalars['Boolean']>;
  companyName?: Maybe<Scalars['Boolean']>;
  countriesAllowed: Array<CountriesAllowed>;
  isStateRequired?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  phoneNumberCountryCodesAllowed?: Maybe<Array<Maybe<PhoneNumberCountryCodesAllowed>>>;
  requireValidation: ValidationRequirement;
  statesConfig: Array<StatesConfig>;
  taxId?: Maybe<Scalars['Boolean']>;
};

export type AddressVerificationLocalization = {
  __typename?: 'AddressVerificationLocalization';
  addressErrorBoldText: Scalars['String'];
  addressErrorText: Scalars['String'];
  editManuallyText: Scalars['String'];
  editOnlyText: Scalars['String'];
  editOrSuggestionText: Scalars['String'];
  enteredAddressText: Scalars['String'];
  invalidZipCodeText: Scalars['String'];
  keepEnteredButtonText: Scalars['String'];
  reviewAddressText: Scalars['String'];
  suggestedAddressText: Scalars['String'];
  titleText: Scalars['String'];
  useSuggestedButtonText: Scalars['String'];
  zipErrorBoldText: Scalars['String'];
  zipErrorText: Scalars['String'];
};

export type AdvancedItemSearchResult = {
  __typename?: 'AdvancedItemSearchResult';
  item: Item;
};

export type AllocatedCreditInput = {
  /** allocated credit line ID */
  id: Scalars['UUID4'];
};

/** List of allowed payment methods. */
export enum AllowedPaymentMethod {
  AllocatedCredit = 'ALLOCATED_CREDIT',
  ApplePay = 'APPLE_PAY',
  Blik = 'BLIK',
  CreditCard = 'CREDIT_CARD',
  FreeOfCharge = 'FREE_OF_CHARGE',
  Invoice = 'INVOICE',
  P24 = 'P24',
  PaymentIntent = 'PAYMENT_INTENT',
  Paypal = 'PAYPAL'
}

export type AllowedState = {
  __typename?: 'AllowedState';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AnalyticsConfig = {
  __typename?: 'AnalyticsConfig';
  gtm?: Maybe<GtmConfig>;
  projectId?: Maybe<Scalars['String']>;
  writeKey?: Maybe<Scalars['String']>;
};

export type ApplePayCard = {
  __typename?: 'ApplePayCard';
  billingAddress?: Maybe<BraintreeAddress>;
  bin: Scalars['String'];
  cardType: Scalars['String'];
  cardholderName: Scalars['String'];
  countryOfIssuance: Scalars['String'];
  createdAt: Scalars['String'];
  customerId: Scalars['String'];
  default: Scalars['Boolean'];
  expirationMonth: Scalars['String'];
  expirationYear: Scalars['String'];
  expired: Scalars['Boolean'];
  imageUrl: Scalars['String'];
  issuingBank: Scalars['String'];
  last4: Scalars['String'];
  paymentInstrumentName: Scalars['String'];
  productId: Scalars['String'];
  sourceDescription: Scalars['String'];
  subscriptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  token: Scalars['String'];
  updatedAt: Scalars['String'];
};

/** Input for mutation to save apple pay payment information */
export type ApplePayInput = {
  unused?: InputMaybe<Scalars['Boolean']>;
};

/**
 * The `available_payment_methods` object contains all the payment methods
 * available to the user.
 *
 * The field `allowed_payment_methods` is a list of all the payment methods
 * that the user has available to them. If the user does not have access to
 * a specific payment method then that field will be `null`.
 */
export type AvailablePaymentMethods = {
  __typename?: 'AvailablePaymentMethods';
  allocatedCredit?: Maybe<Credit>;
  allowedPaymentMethods: Array<AllowedPaymentMethod>;
  creditCard?: Maybe<PaymentMethodCreditCard>;
  paypal?: Maybe<PaymentMethodPaypal>;
};

export type BasicBehaviour = {
  __typename?: 'BasicBehaviour';
  name: BehaviourEnum;
};

export type Bazaarvoice = {
  __typename?: 'Bazaarvoice';
  encryptedEmail?: Maybe<Scalars['String']>;
  encryptionKeyId?: Maybe<Scalars['String']>;
};

/** Behaviour which may or may not have attributes */
export type Behaviour = BasicBehaviour | BogoBehaviour | DynamicBundlesBehaviour | TieredBehaviour;

export enum BehaviourEnum {
  /** Basic discount logic, discounts all matching items by configured amount. */
  Basic = 'BASIC',
  /** Buy one (or many) get one (or many) at the specified percent off */
  Bogo = 'BOGO',
  /** Buy one (or many) get one (or many) at the specified percent off with specific triggering items */
  BogoAdvanced = 'BOGO_ADVANCED',
  /** Dynamic Bundles discount logic, discounts matching items designated with the campaign_id */
  DynamicBundles = 'DYNAMIC_BUNDLES',
  /** Tiered discount logic, discounts matching items according to a tier structure. */
  Tiered = 'TIERED'
}

export type BillingAddress = {
  __typename?: 'BillingAddress';
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type BillingAddressInput = {
  city: Scalars['String'];
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type BogoAttributes = {
  __typename?: 'BogoAttributes';
  applyAmount: Scalars['Int'];
  triggerPoint: Scalars['Int'];
};

export type BogoBehaviour = {
  __typename?: 'BogoBehaviour';
  attributes: BogoAttributes;
  name: BehaviourEnum;
};

export type BotProtection = {
  __typename?: 'BotProtection';
  active: Scalars['Boolean'];
  provider?: Maybe<BotProtectionProvider>;
  siteKey?: Maybe<BotProtectionSiteKey>;
};

export enum BotProtectionProvider {
  GoogleRecaptcha = 'GOOGLE_RECAPTCHA'
}

export type BotProtectionSiteKey = {
  __typename?: 'BotProtectionSiteKey';
  android: Scalars['String'];
  ios: Scalars['String'];
  web: Scalars['String'];
};

export type BraintreeAddress = {
  __typename?: 'BraintreeAddress';
  company?: Maybe<Scalars['String']>;
  countryCodeAlpha2?: Maybe<Scalars['String']>;
  countryCodeAlpha3?: Maybe<Scalars['String']>;
  countryCodeNumeric?: Maybe<Scalars['String']>;
  countryName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  extendedAddress?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  locality?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type BrandConfig = {
  __typename?: 'BrandConfig';
  audience: Scalars['String'];
  cdnHost?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  contactUrl?: Maybe<Scalars['String']>;
  copyright: Scalars['String'];
  customCss?: Maybe<Scalars['String']>;
  customTexts: Array<CustomText>;
  customizations: BrandConfigCustomizations;
  email?: Maybe<Scalars['String']>;
  logoUrl: Scalars['String'];
  optInTextLocalized: Scalars['String'];
  supportEmail?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  trackingFonts?: Maybe<Array<Maybe<BrandConfigTrackingFonts>>>;
  yearsAgeGate?: Maybe<Scalars['Int']>;
};

export type BrandConfigCustomizations = {
  __typename?: 'BrandConfigCustomizations';
  account?: Maybe<BrandConfigCustomizationsAccount>;
  contacts: Array<BrandConfigCustomizationsContact>;
  css: Array<BrandConfigCustomizationsCss>;
  fonts: Array<BrandConfigCustomizationsFont>;
  images: Array<BrandConfigCustomizationsImage>;
  links: Array<BrandConfigCustomizationsLink>;
};

export type BrandConfigCustomizationsAccount = {
  __typename?: 'BrandConfigCustomizationsAccount';
  profilePageTitle?: Maybe<Scalars['String']>;
  signinPageTitle?: Maybe<Scalars['String']>;
  signupPageTitle?: Maybe<Scalars['String']>;
  valueprops: Array<BrandConfigCustomizationsAccountValueprops>;
};

export type BrandConfigCustomizationsAccountValueprops = {
  __typename?: 'BrandConfigCustomizationsAccountValueprops';
  imgUrl?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type BrandConfigCustomizationsContact = {
  __typename?: 'BrandConfigCustomizationsContact';
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  showCountry?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  zip?: Maybe<Scalars['String']>;
};

export type BrandConfigCustomizationsCss = {
  __typename?: 'BrandConfigCustomizationsCss';
  overrides: Array<BrandConfigCustomizationsCssOverride>;
  selector: Scalars['String'];
};

export type BrandConfigCustomizationsCssOverride = {
  __typename?: 'BrandConfigCustomizationsCssOverride';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type BrandConfigCustomizationsFont = {
  __typename?: 'BrandConfigCustomizationsFont';
  meta?: Maybe<Array<BrandConfigCustomizationsFontMeta>>;
  name: Scalars['String'];
  style?: Maybe<Scalars['String']>;
  urls: Array<BrandConfigCustomizationsFontSources>;
  weight?: Maybe<Scalars['String']>;
};

export type BrandConfigCustomizationsFontMeta = {
  __typename?: 'BrandConfigCustomizationsFontMeta';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type BrandConfigCustomizationsFontSources = {
  __typename?: 'BrandConfigCustomizationsFontSources';
  format?: Maybe<Scalars['String']>;
  local?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type BrandConfigCustomizationsImage = {
  __typename?: 'BrandConfigCustomizationsImage';
  alt?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  src: Scalars['String'];
};

export type BrandConfigCustomizationsLink = {
  __typename?: 'BrandConfigCustomizationsLink';
  location: Scalars['String'];
  newTab: Scalars['Boolean'];
  position: Scalars['Int'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type BrandConfigTrackingFonts = {
  __typename?: 'BrandConfigTrackingFonts';
  font: Scalars['String'];
  isTrackingRequired: Scalars['Boolean'];
  resource: Scalars['String'];
};

export type BundleComponent = {
  __typename?: 'BundleComponent';
  componentPriceItems?: Maybe<Array<Maybe<DynamicBundleItem>>>;
  imgUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  qtyType: Scalars['String'];
  requiredQty: Scalars['Int'];
  subscriptionOption?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type BundleItem = {
  __typename?: 'BundleItem';
  imgUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/**
 * DynamicBundle are composed of items (CartItem or LineItem) which contain DynamicBundle
 * metadata in a cart. A BundleLineItem is a convenience struct that will create one item
 * that is an accumulation of all the items which are part of a DynamicBundle.
 */
export type BundleLineItem = {
  __typename?: 'BundleLineItem';
  /** components of the bundle other than the primary component */
  bundleComponents: Array<Maybe<BundleComponent>>;
  /** The id of the DynamicBundle */
  bundleId: Scalars['UUID4'];
  /** The cart reference of the DynamicBundle */
  cartBundleReference: Scalars['Int'];
  /** Will contain information of the discount for the DynamicBundle */
  discounts: Array<LineItemDiscount>;
  /** The DynamicBundle the items belong to */
  dynamicBundle: DynamicBundle;
  /** A list of items that are NOT associated with the primary component */
  dynamicBundleItems?: Maybe<Array<DynamicBundleItem>>;
  /** This is the image from the primary component */
  imgUrl?: Maybe<Scalars['String']>;
  /** aggregated gtin item notifications */
  itemNotifications: Array<Scalars['String']>;
  /** This will always the same as subtotal because DynamicBundles are quantity of 1 */
  perUnitPrice: Scalars['Int'];
  /** A list of items that are associated with the primary component */
  primaryBundleItems?: Maybe<Array<DynamicBundleItem>>;
  /** The primary component of the DynamicBundle */
  primaryComponent: BundleComponent;
  /** This is the quantity of all the items that are part of the DynamicBundle */
  quantity: Scalars['Int'];
  /** This is the cumulative strikethrough price of all the items in the DynamicBundle */
  strikethroughUnitPrice?: Maybe<Scalars['Int']>;
  /** This is the total of the items after the discount for the DynamicBundle is applied */
  subtotal: Scalars['Int'];
  /** The title of the primary component for the DynamicBundle */
  title: Scalars['String'];
};

export type Capabilities = {
  __typename?: 'Capabilities';
  signUp: CapabilitiesSignUp;
  termsAndConditions?: Maybe<CapabilitiesTermsAndConditions>;
};

/**
 * The sign up capability informs consumers of the API if the Tenant
 * allows users to sign up via the Secure Portal.
 */
export type CapabilitiesSignUp = {
  __typename?: 'CapabilitiesSignUp';
  enabled: Scalars['Boolean'];
};

/** The capability to request accepting most recent version of T&C by user. */
export type CapabilitiesTermsAndConditions = {
  __typename?: 'CapabilitiesTermsAndConditions';
  lastVersionUpdatedAt?: Maybe<Scalars['DateTime']>;
};

/** A list of valid credit card types. */
export type CardType = {
  __typename?: 'CardType';
  brandImgUrl: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type Cart = {
  __typename?: 'Cart';
  appId: Scalars['UUID4'];
  /**
   * If the Cart contains any Dynamic Bundles will hold top level definitions.
   * This will contain an array of maps which contain necessary DynamicBundle
   * information such as the DynamicBundle id and cart_bundle_reference that will
   * help identify which items belong to which bundle.
   */
  dynamicBundles?: Maybe<Scalars['Json']>;
  id: Scalars['UUID4'];
  items?: Maybe<Array<Maybe<CartItemsAndBundleItems>>>;
  loyaltyData?: Maybe<LoyaltyData>;
  tenantId: Scalars['UUID4'];
  user?: Maybe<User>;
};

/** This will contain either BundleLineItems or CartItems */
export type CartItem = {
  __typename?: 'CartItem';
  analyticsDetails?: Maybe<Scalars['Json']>;
  customizations?: Maybe<Array<Customization>>;
  discounts: Array<LineItemDiscount>;
  /**
   * if the CartItem is part of a DynamicBundle this is a map of DynamicBundle metadata such as the
   * cart_bundle_reference which identifies which bundle this item belongs to
   */
  dynamicBundle?: Maybe<Scalars['Json']>;
  id: Scalars['UUID4'];
  item: Item;
  /** The discounted price of the item as an individual unit (rounded up, except for promo-code discounts, which are not adjusted). */
  perUnitPrice: Scalars['Int'];
  quantity: Scalars['Int'];
  /** The original price of the item as an individual unit (either the compare_at_price or or non-discounted price). */
  strikethroughUnitPrice?: Maybe<Scalars['Int']>;
  subscriptionIntervalInDays?: Maybe<Scalars['Int']>;
  /** calculated by subtracting the discount_total from the items base_price * quantity (except for promo-code discounts, which are not included) */
  subtotal: Scalars['Int'];
};

export type CartItemsAndBundleItems = BundleLineItem | CartItem;

export type ChangeUserPasswordInput = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
};

export type Checkout = {
  __typename?: 'Checkout';
  paymentOptions?: Maybe<TenantPaymentOptions>;
  shippingOptions?: Maybe<TenantShippingOptions>;
  showCouponCodeCta?: Maybe<Scalars['Boolean']>;
  vatInclusivePricing?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['String']>;
};

export type CheckoutBreadcrumbsLocalization = {
  __typename?: 'CheckoutBreadcrumbsLocalization';
  address: Scalars['String'];
  payment: Scalars['String'];
  review: Scalars['String'];
  shipping: Scalars['String'];
};

export type CheckoutCouponCodeLocalizations = {
  __typename?: 'CheckoutCouponCodeLocalizations';
  addCouponButtonText: Scalars['String'];
  applyCouponButtonText: Scalars['String'];
  cancelCouponButtonText: Scalars['String'];
  couponCodeLabel: Scalars['String'];
  couponLabel: Scalars['String'];
  couponPlaceholderText: Scalars['String'];
  editCouponButtonText: Scalars['String'];
  removeCouponButtonText: Scalars['String'];
};

export type CheckoutErrorsLocalizations = {
  __typename?: 'CheckoutErrorsLocalizations';
  discount?: Maybe<DiscountLocalizations>;
  genericErrorMsg: Scalars['String'];
  guestCartContainsSubscription?: Maybe<GuestCartContainsSubscriptionLocalizations>;
  insufficientLoyaltyBalance?: Maybe<InsufficientLoyaltyBalanceLocalizations>;
  invalidGiftCard?: Maybe<InvalidGiftCardLocalizations>;
  invalidLoyaltyReward?: Maybe<InvalidLoyaltyRewardLocalizations>;
  itemUnavailable?: Maybe<ItemUnavailableLocalizations>;
  lowStock?: Maybe<LowStockLocalizations>;
  minimumPurchaseAmount: Scalars['String'];
  minimumPurchaseQuantity: Scalars['String'];
  outOfStock?: Maybe<OutOfStockLocalizations>;
  paymentFailureErrorText: Scalars['String'];
  paymentNotAccepted: Scalars['String'];
  purchaseQtyLimit?: Maybe<PurchaseQtyLimitLocalizations>;
  unableToUsePoBox: Scalars['String'];
  unverifiedEmail: Scalars['String'];
  zipCodeRestriction?: Maybe<ZipCodeRestrictionLocalizations>;
};

export type CheckoutGiftCardLocalizations = {
  __typename?: 'CheckoutGiftCardLocalizations';
  addCouponGiftButtonText: Scalars['String'];
  addGiftButtonText: Scalars['String'];
  giftCardEndingIn: Scalars['String'];
  giftNumberLabel: Scalars['String'];
  giftNumberPlaceholderText: Scalars['String'];
  giftPinLabel: Scalars['String'];
  giftPinPlaceholderText: Scalars['String'];
};

export type CheckoutGiftFormLocalizations = {
  __typename?: 'CheckoutGiftFormLocalizations';
  emailFieldLabel: Scalars['String'];
  gifteeFieldLabel: Scalars['String'];
  infoText: Scalars['String'];
  messageFieldLabel: Scalars['String'];
  sendAsGiftText: Scalars['String'];
  shippingAddressHeadingText: Scalars['String'];
};

/**
 * Returns a map of all checkout elements and their translations.
 *
 * Example:
 *     ```
 *     query {
 *       localization {
 *         checkout {
 *           breadcrumbs {
 *             shipping
 *           }
 *         }
 *       }
 *     }
 *     ```
 */
export type CheckoutLocalization = {
  __typename?: 'CheckoutLocalization';
  breadcrumbs?: Maybe<CheckoutBreadcrumbsLocalization>;
  couponCode?: Maybe<CheckoutCouponCodeLocalizations>;
  errors?: Maybe<CheckoutErrorsLocalizations>;
  giftCard?: Maybe<CheckoutGiftCardLocalizations>;
  giftForm?: Maybe<CheckoutGiftFormLocalizations>;
  orderDetails?: Maybe<CheckoutOrderDetailsLocalizations>;
  orderStatusPage?: Maybe<CheckoutOrderStatusPageLocalizations>;
  orderSummary?: Maybe<CheckoutOrderSummaryLocalizations>;
  pageTitlesInHead?: Maybe<CheckoutPageTitlesLocalization>;
  paymentStep?: Maybe<CheckoutPaymentStepLocalizations>;
  rdd?: Maybe<CheckoutRddLocalizations>;
  reviewStep?: Maybe<CheckoutReviewStepLocalizations>;
  shippingMethodStep?: Maybe<CheckoutShippingMethodStepLocalizations>;
  shippingStep?: Maybe<CheckoutShippingStepLocalizations>;
};

export type CheckoutOrderDetailsLocalizations = {
  __typename?: 'CheckoutOrderDetailsLocalizations';
  billingSameAsShippingText: Scalars['String'];
  cardholderNameText: Scalars['String'];
  expiresText: Scalars['String'];
  invoiceTermsText: Scalars['String'];
  invoiceText: Scalars['String'];
  poNumberText: Scalars['String'];
  shippingMethodText: Scalars['String'];
};

export type CheckoutOrderStatusPageLocalizations = {
  __typename?: 'CheckoutOrderStatusPageLocalizations';
  continueShoppingButtonText: Scalars['String'];
  headingText: Scalars['String'];
  notFoundMsg: Scalars['String'];
  orderConfirmationShipmentText: Scalars['String'];
  orderDateText: Scalars['String'];
  orderDetailsHeadingText: Scalars['String'];
  orderDetailsNote: Scalars['String'];
  orderDetailsText: Scalars['String'];
  paymentHeadingText: Scalars['String'];
  printButtonText: Scalars['String'];
  shippingHeadingText: Scalars['String'];
};

export type CheckoutOrderSummaryLocalizations = {
  __typename?: 'CheckoutOrderSummaryLocalizations';
  bulkDiscountText: Scalars['String'];
  bundleDiscountText: Scalars['String'];
  bundleItemDefaultText: Scalars['String'];
  cartHeadingText: Scalars['String'];
  freeShipLabel: Scalars['String'];
  itemPlural: Scalars['String'];
  itemSingular: Scalars['String'];
  regulatoryTaxLabel: Scalars['String'];
  salesTaxLabel: Scalars['String'];
  shippingLabel: Scalars['String'];
  subtotalLabel: Scalars['String'];
  totalLabel: Scalars['String'];
  whatsIncludedText: Scalars['String'];
  yourOrderText: Scalars['String'];
};

export type CheckoutPageTitlesLocalization = {
  __typename?: 'CheckoutPageTitlesLocalization';
  checkout: Scalars['String'];
  status: Scalars['String'];
};

export type CheckoutPaymentStepLocalizations = {
  __typename?: 'CheckoutPaymentStepLocalizations';
  addCardHeadingText: Scalars['String'];
  addPaymentButtonText: Scalars['String'];
  addPaymentHeadingText: Scalars['String'];
  billingAddressHeadingText: Scalars['String'];
  billingSameAsShippingText: Scalars['String'];
  continueToReviewButtonText: Scalars['String'];
  giftCardCoversFullAmountDescription: Scalars['String'];
  giftCardCoversFullAmountTitle: Scalars['String'];
  headingText: Scalars['String'];
  sectionHeadingText: Scalars['String'];
  shippingAddressHeadingText: Scalars['String'];
};

export type CheckoutRddLocalizations = {
  __typename?: 'CheckoutRddLocalizations';
  changeDateText: Scalars['String'];
  headingText: Scalars['String'];
  needOrderSoonerText: Scalars['String'];
  noteText: Scalars['String'];
  selectDateText: Scalars['String'];
  yourRequestedDateText: Scalars['String'];
};

export type CheckoutReviewStepLocalizations = {
  __typename?: 'CheckoutReviewStepLocalizations';
  agreeToTermsText: Scalars['String'];
  editButtonText: Scalars['String'];
  emailNote: Scalars['String'];
  giftEmailNote: Scalars['String'];
  giftMessageNote: Scalars['String'];
  giftShippingHeadingText: Scalars['String'];
  headingText: Scalars['String'];
  paymentHeadingText: Scalars['String'];
  shippingHeadingText: Scalars['String'];
  submitOrderButtonText: Scalars['String'];
};

export type CheckoutSession = {
  __typename?: 'CheckoutSession';
  activeAccount?: Maybe<ActiveAccount>;
  appId: Scalars['UUID4'];
  availablePaymentMethods: AvailablePaymentMethods;
  availableShippingMethods?: Maybe<Array<ShippingMethod>>;
  cart?: Maybe<Cart>;
  contactInfo?: Maybe<ContactInfo>;
  customerPo?: Maybe<Scalars['String']>;
  giftCards?: Maybe<Array<Maybe<EmbeddedGiftCard>>>;
  giftInfo?: Maybe<GiftInfo>;
  hasGasExchangeItems: Scalars['Boolean'];
  hasSubscriptionItems: Scalars['Boolean'];
  id: Scalars['UUID4'];
  orderId?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  price: Price;
  requestedDeliveryDate?: Maybe<Scalars['String']>;
  shippingAddresses: Array<SavedShippingAddress>;
  shippingMethodCode?: Maybe<Scalars['String']>;
  shippingMethodConfig?: Maybe<ShippingMethodConfig>;
  shippingMethodTitle?: Maybe<Scalars['String']>;
  stage: SessionStage;
  submissionUid: Scalars['UUID4'];
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['UUID4'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID4']>;
};

export type CheckoutShippingMethodStepLocalizations = {
  __typename?: 'CheckoutShippingMethodStepLocalizations';
  freeText: Scalars['String'];
  headingText: Scalars['String'];
  selectShippingMethodText: Scalars['String'];
};

export type CheckoutShippingStepLocalizations = {
  __typename?: 'CheckoutShippingStepLocalizations';
  addAddressButtonText: Scalars['String'];
  addAddressHeadingText: Scalars['String'];
  additionalPhoneNumberLabel: Scalars['String'];
  addressHeadingText: Scalars['String'];
  contactNoteText: Scalars['String'];
  continueToPaymentButtonText: Scalars['String'];
  continueToShippingMethodButtonText: Scalars['String'];
  savedAddressHeadingText: Scalars['String'];
  shipAlertText: Scalars['String'];
  shippingHeadingText: Scalars['String'];
};

export type Component = {
  __typename?: 'Component';
  discount?: Maybe<Discount>;
  id: Scalars['UUID4'];
  items?: Maybe<Array<Item>>;
  name: Scalars['String'];
  qtyType: Scalars['String'];
  requiredQty: Scalars['Int'];
  subscriptionOption: SubscriptionOption;
};

export type ComponentsLocalization = {
  __typename?: 'ComponentsLocalization';
  addressVerification?: Maybe<AddressVerificationLocalization>;
  customNotFound?: Maybe<CustomNotFoundLocalization>;
  errorModal?: Maybe<ErrorModalLocalization>;
  exchangeReturnByDate?: Maybe<ExchangeReturnByDateLocalization>;
  footer?: Maybe<FooterLocalization>;
  orderProcessing?: Maybe<OrderProcessing>;
  price?: Maybe<PriceLocalization>;
};

export type ContactConfig = {
  __typename?: 'ContactConfig';
  shippingAddressConfig: AddressConfig;
};

/** User's contact info needed during checkout. */
export type ContactInfo = {
  __typename?: 'ContactInfo';
  bazaarvoice?: Maybe<Bazaarvoice>;
  email?: Maybe<Scalars['String']>;
  emailOptIn?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  shippingAddress?: Maybe<ShippingAddress>;
  shippingMethod?: Maybe<ShippingMethod>;
};

export type CountriesAllowed = {
  __typename?: 'CountriesAllowed';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CreatePaymentMethodInput = {
  default?: InputMaybe<Scalars['Boolean']>;
  nonce: Scalars['String'];
};

export type CreateRegistrationRecordInput = {
  customData?: InputMaybe<Scalars['Json']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  gtin: Scalars['String'];
  purchaseDate: Scalars['Date'];
  purchaseLocation?: InputMaybe<Scalars['String']>;
  utmData?: InputMaybe<UtmDataInput>;
};

/**
 * The `Credit` object is used to represent a credit line on an account.
 *
 * This could apply to an Allocation or Invoice credit line depending on the
 * credit type.
 */
export type Credit = {
  __typename?: 'Credit';
  activeFrom: Scalars['Date'];
  activeUntil?: Maybe<Scalars['Date']>;
  availableAmount: Scalars['Int'];
  id: Scalars['UUID4'];
  spentAmount: Scalars['Int'];
  status: Scalars['String'];
  type: Scalars['String'];
};

/** Credit card saved by the user. */
export type CreditCard = {
  __typename?: 'CreditCard';
  billingAddress: CreditCardBillingAddress;
  cardType: CreditCardType;
  cardholderName: Scalars['String'];
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  isDefault: Scalars['Boolean'];
  isRemovable?: Maybe<Scalars['Boolean']>;
  lastFour: Scalars['String'];
  /** Token representing payment method. */
  token: Scalars['String'];
};

/** Billing address associated with a Credit Card. */
export type CreditCardBillingAddress = {
  __typename?: 'CreditCardBillingAddress';
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
};

/** Input for mutation to save credit card payment information */
export type CreditCardInput = {
  billingAddress?: InputMaybe<BillingAddressInput>;
  isBillingEqualShipping: Scalars['Boolean'];
  saveCardForLater: Scalars['Boolean'];
};

export type CreditCardTooltipLocalization = {
  __typename?: 'CreditCardTooltipLocalization';
  cardsWith3DigitsNote: Scalars['String'];
  cardsWith3DigitsText: Scalars['String'];
  cardsWith4DigitsNote: Scalars['String'];
  cardsWith4DigitsText: Scalars['String'];
  cvv3DigitAlt: Scalars['String'];
  cvv4DigitAlt: Scalars['String'];
  headingText: Scalars['String'];
};

/** Enum for the different types of payment methods. */
export enum CreditCardType {
  AmericanExpress = 'AMERICAN_EXPRESS',
  Amex = 'AMEX',
  Discover = 'DISCOVER',
  Jcb = 'JCB',
  Mastercard = 'MASTERCARD',
  Unionpay = 'UNIONPAY',
  Visa = 'VISA'
}

export type CustomNotFoundLocalization = {
  __typename?: 'CustomNotFoundLocalization';
  cartButtonText: Scalars['String'];
  headingText: Scalars['String'];
  homeButtonText: Scalars['String'];
  subHeadingText: Scalars['String'];
};

export type CustomText = {
  __typename?: 'CustomText';
  body: Array<Scalars['String']>;
  links: Array<CustomTextLink>;
  location: Scalars['String'];
  position?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
};

export type CustomTextLink = {
  __typename?: 'CustomTextLink';
  displayValue: Scalars['String'];
  key: Scalars['String'];
  linkValue: Scalars['String'];
  type: Scalars['String'];
};

/** Used for item customizations maps */
export type Customization = GatoradeIdBottle | GatoradeTowel | LegacyCustomization;

export type DeleteCreditCardInput = {
  token: Scalars['String'];
};

export type Discount = {
  __typename?: 'Discount';
  activeFrom: Scalars['DateTime'];
  activeUntil?: Maybe<Scalars['DateTime']>;
  amount?: Maybe<Scalars['Int']>;
  appId?: Maybe<Scalars['UUID4']>;
  behaviour: Behaviour;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID4'];
  isPercent?: Maybe<Scalars['Boolean']>;
  isPromoCodeRequired?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  promoCode?: Maybe<Scalars['String']>;
  type?: Maybe<DiscountType>;
  typeDependentValue?: Maybe<Scalars['String']>;
  usage?: Maybe<Scalars['Int']>;
};

export enum DiscountCategory {
  Basic = 'BASIC',
  DynamicBundle = 'DYNAMIC_BUNDLE',
  Subscription = 'SUBSCRIPTION',
  Tiered = 'TIERED'
}

export type DiscountInput = {
  promoCode?: InputMaybe<Scalars['String']>;
};

export type DiscountLocalizations = {
  __typename?: 'DiscountLocalizations';
  discountCannotApplyToSubscription: Scalars['String'];
  discountExceedsSubtotal: Scalars['String'];
  discountHeadingText: Scalars['String'];
  discountNotFound: Scalars['String'];
  discountNoteText: Scalars['String'];
  discountPromoCodeRequiresEmail: Scalars['String'];
  discountPromoCodeRequiresEmailOrLogin: Scalars['String'];
  discountTooLarge: Scalars['String'];
};

export enum DiscountType {
  Flat = 'FLAT',
  Percent = 'PERCENT'
}

export type DynamicBundle = {
  __typename?: 'DynamicBundle';
  appId: Scalars['UUID4'];
  components?: Maybe<Array<Component>>;
  discount?: Maybe<Discount>;
  discountPrice: Scalars['Int'];
  id: Scalars['UUID4'];
  inventoryQty?: Maybe<Scalars['Int']>;
  minRetailPrice: Scalars['Int'];
  name: Scalars['String'];
  primaryComponent: Component;
  tag: Scalars['String'];
};

export type DynamicBundleItem = {
  __typename?: 'DynamicBundleItem';
  analyticsDetails?: Maybe<Scalars['Json']>;
  /** A list of customizations the item associated contains */
  customizations?: Maybe<Array<Customization>>;
  discounts?: Maybe<Array<LineItemDiscount>>;
  item: Item;
  itemId: Scalars['UUID4'];
  quantity: Scalars['Int'];
  subscriptionIntervalInDays?: Maybe<Scalars['Int']>;
};

export type DynamicBundlesBehaviour = {
  __typename?: 'DynamicBundlesBehaviour';
  name: BehaviourEnum;
};

export type EmailOptInLocalization = {
  __typename?: 'EmailOptInLocalization';
  body: Scalars['String'];
  defaultLabelText: Scalars['String'];
  privacyPolicyLinkText: Scalars['String'];
  termsOfUseLinkText: Scalars['String'];
};

export type EmbeddedCategory = {
  __typename?: 'EmbeddedCategory';
  level1?: Maybe<Scalars['String']>;
  level2?: Maybe<Scalars['String']>;
  level3?: Maybe<Scalars['String']>;
};

export type EmbeddedDiscount = {
  __typename?: 'EmbeddedDiscount';
  amount?: Maybe<Scalars['Int']>;
  isPercent?: Maybe<Scalars['Boolean']>;
};

export type EmbeddedGiftCard = {
  __typename?: 'EmbeddedGiftCard';
  amount: Scalars['Int'];
  appliedAmount: Scalars['Int'];
  giftCardId: Scalars['String'];
  last4: Scalars['String'];
  requestReference: Scalars['String'];
  transactionId: Scalars['String'];
  type: Scalars['String'];
};

export type EmbeddedItem = {
  __typename?: 'EmbeddedItem';
  awaitingImportCorrection?: Maybe<Scalars['Boolean']>;
  brandName?: Maybe<Scalars['String']>;
  bundleOnly?: Maybe<Scalars['Boolean']>;
  categories?: Maybe<EmbeddedCategory>;
  color?: Maybe<Scalars['String']>;
  compareAtPrice?: Maybe<Scalars['Int']>;
  containerType?: Maybe<Scalars['String']>;
  countryCity?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  designerBio?: Maybe<Scalars['String']>;
  dimensionUnits?: Maybe<Scalars['String']>;
  dimensions?: Maybe<Scalars['String']>;
  fluidOzPerPack?: Maybe<Scalars['Decimal']>;
  gasExchangeInfo?: Maybe<EmbeddedItemGasExchangeInfo>;
  height?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID4']>;
  imgUrl?: Maybe<Scalars['String']>;
  importId?: Maybe<Scalars['UUID4']>;
  inventoryQty?: Maybe<Scalars['Int']>;
  isApproved?: Maybe<Scalars['Boolean']>;
  isDairyFree?: Maybe<Scalars['Boolean']>;
  isFairTrade?: Maybe<Scalars['Boolean']>;
  isGlutenFree?: Maybe<Scalars['Boolean']>;
  isGmoFree?: Maybe<Scalars['Boolean']>;
  isKosher?: Maybe<Scalars['Boolean']>;
  isOrganic?: Maybe<Scalars['String']>;
  isOutOfStock?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  isVegan?: Maybe<Scalars['Boolean']>;
  isWheatFree?: Maybe<Scalars['Boolean']>;
  isYeastFree?: Maybe<Scalars['Boolean']>;
  isbn?: Maybe<Scalars['String']>;
  length?: Maybe<Scalars['String']>;
  material?: Maybe<Scalars['String']>;
  meltRisk?: Maybe<Scalars['Boolean']>;
  minOrderQty?: Maybe<Scalars['Int']>;
  onMarketplace?: Maybe<Scalars['Boolean']>;
  pointsPrice?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  primaryCategoryPriority?: Maybe<Scalars['Int']>;
  productPacks?: Maybe<Scalars['Int']>;
  productsPerPack?: Maybe<Scalars['Int']>;
  returnsPolicy?: Maybe<Scalars['String']>;
  secondaryCategoryPriority?: Maybe<Scalars['Int']>;
  shippingInfo?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  slugHash?: Maybe<Scalars['String']>;
  subscriptionMetadata?: Maybe<EmbeddedItemSubscriptionMetadata>;
  subscriptionOnly?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Scalars['String']>;
  taxCodeId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  upc?: Maybe<Scalars['String']>;
  vendorId?: Maybe<Scalars['UUID4']>;
  virtual?: Maybe<Scalars['Boolean']>;
  weightOz?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['String']>;
};

export type EmbeddedItemGasExchangeInfo = {
  __typename?: 'EmbeddedItemGasExchangeInfo';
  enabled: Scalars['Boolean'];
  missingCylinder?: Maybe<Item>;
  missingCylinderId?: Maybe<Scalars['UUID4']>;
};

export type EmbeddedItemSubscriptionMetadata = {
  __typename?: 'EmbeddedItemSubscriptionMetadata';
  discount?: Maybe<EmbeddedDiscount>;
  isSubscribable: Scalars['Boolean'];
  subscriptionPrice?: Maybe<Scalars['Int']>;
};

export type ErrorModalLocalization = {
  __typename?: 'ErrorModalLocalization';
  errorHeadingText: Scalars['String'];
  okText: Scalars['String'];
  visitOurLinkForAssistanceText: Scalars['String'];
};

export type ExchangeReturnByDateLocalization = {
  __typename?: 'ExchangeReturnByDateLocalization';
  exchangeText: Scalars['String'];
  returnByText: Scalars['String'];
};

export type ExtendDueDateInput = {
  id: Scalars['UUID4'];
};

export type FindAddressInput = {
  container?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};

export type FooterLocalization = {
  __typename?: 'FooterLocalization';
  allRightsReserved: Scalars['String'];
};

export type FormsAccountLocalization = {
  __typename?: 'FormsAccountLocalization';
  firstNameLabel: Scalars['String'];
  lastNameLabel: Scalars['String'];
};

export type FormsAddressLocalization = {
  __typename?: 'FormsAddressLocalization';
  autocompletePlaceholderText: Scalars['String'];
  cardholderNameLabel: Scalars['String'];
  cityLabel: Scalars['String'];
  companyLabel: Scalars['String'];
  countryLabel: Scalars['String'];
  emailLabel: Scalars['String'];
  firstNameLabel: Scalars['String'];
  isDefaultLabel: Scalars['String'];
  lastNameLabel: Scalars['String'];
  line1Label: Scalars['String'];
  line2Label: Scalars['String'];
  manuallyEnterAddressText: Scalars['String'];
  nicknameLabel: Scalars['String'];
  phoneLabel: Scalars['String'];
  phoneNumberLabel: Scalars['String'];
  regionText: Scalars['String'];
  requiredFieldsText: Scalars['String'];
  requiredText: Scalars['String'];
  specialInstructionsLabel: Scalars['String'];
  stateLabel: Scalars['String'];
  taxIdLabel: Scalars['String'];
  zipLabel: Scalars['String'];
};

export type FormsCreditCardLocalization = {
  __typename?: 'FormsCreditCardLocalization';
  cardNumberLabel: Scalars['String'];
  cardSavedForGasExchangeNote: Scalars['String'];
  cardSavedForSubsNote: Scalars['String'];
  cardholderNameLabel: Scalars['String'];
  cvvLabel: Scalars['String'];
  cvvTooltip?: Maybe<CreditCardTooltipLocalization>;
  expirationDateLabel: Scalars['String'];
  saveCardForLaterText: Scalars['String'];
  securityNote: Scalars['String'];
};

export type FormsForgotPasswordLocalization = {
  __typename?: 'FormsForgotPasswordLocalization';
  backToLoginText: Scalars['String'];
  contactLinkContentText: Scalars['String'];
  contactLinkText: Scalars['String'];
  emailLabelText: Scalars['String'];
  formDescriptionText: Scalars['String'];
  headingText: Scalars['String'];
  submitButtonText: Scalars['String'];
  submittedText: Scalars['String'];
};

export type FormsLocalization = {
  __typename?: 'FormsLocalization';
  account?: Maybe<FormsAccountLocalization>;
  address?: Maybe<FormsAddressLocalization>;
  creditCard?: Maybe<FormsCreditCardLocalization>;
  forgotPassword?: Maybe<FormsForgotPasswordLocalization>;
  resetPassword?: Maybe<FormsResetPasswordLocalization>;
  signIn?: Maybe<FormsSignInLocalization>;
  signup?: Maybe<FormsSignupLocalization>;
  tos?: Maybe<FormsTosLocalization>;
  validation?: Maybe<FormsValidationLocalization>;
};

export type FormsResetPasswordLocalization = {
  __typename?: 'FormsResetPasswordLocalization';
  contactLinkContentText: Scalars['String'];
  contactLinkText: Scalars['String'];
  headingText: Scalars['String'];
  passwordInputLabelText: Scalars['String'];
  requestNewLinkContentText: Scalars['String'];
  requestNewLinkText: Scalars['String'];
  resetTokenDefaultErrorText: Scalars['String'];
  resetTokenExpiredErrorText: Scalars['String'];
  resetTokenIdErrorText: Scalars['String'];
  resetTokenMismatchErrorText: Scalars['String'];
  resetTokenNotFoundErrorText: Scalars['String'];
  resetTokenUnableToDecodeErrorText: Scalars['String'];
  submitText: Scalars['String'];
};

export type FormsSignInLocalization = {
  __typename?: 'FormsSignInLocalization';
  accountLockedErrorText: Scalars['String'];
  emailInputPlaceholderText: Scalars['String'];
  forgotPasswordButtonText: Scalars['String'];
  genericErrorText: Scalars['String'];
  headingDefaultText: Scalars['String'];
  headingText: Scalars['String'];
  loginButtonText: Scalars['String'];
  passwordInputPlaceholderText: Scalars['String'];
  signUpButtonText: Scalars['String'];
  signUpDefaultHeadingText: Scalars['String'];
  signUpHeadingText: Scalars['String'];
};

export type FormsSignupLocalization = {
  __typename?: 'FormsSignupLocalization';
  accountLogoAltText: Scalars['String'];
  ageRequirementErrorText: Scalars['String'];
  birthdayLabelText: Scalars['String'];
  createAccountPageHeadingText: Scalars['String'];
  dayLabelText: Scalars['String'];
  emailLabelText: Scalars['String'];
  emailOptIn?: Maybe<EmailOptInLocalization>;
  emailPlaceholderText: Scalars['String'];
  errorResetPasswordLinkText: Scalars['String'];
  errorText: Scalars['String'];
  firstNameLabelText: Scalars['String'];
  firstNamePlaceholderText: Scalars['String'];
  headingText: Scalars['String'];
  lastNameLabelText: Scalars['String'];
  lastNamePlaceholderText: Scalars['String'];
  monthLabelText: Scalars['String'];
  passwordLabelText: Scalars['String'];
  passwordPlaceholderText: Scalars['String'];
  submitText: Scalars['String'];
  yearLabelText: Scalars['String'];
};

export type FormsTosLocalization = {
  __typename?: 'FormsTosLocalization';
  body: Scalars['String'];
  errorText: Scalars['String'];
  tosLinkText: Scalars['String'];
};

export type FormsValidationLocalization = {
  __typename?: 'FormsValidationLocalization';
  companyRequiredWithTaxIdErrorText: Scalars['String'];
  dayRequiredErrorText: Scalars['String'];
  emailRequiredErrorText: Scalars['String'];
  fieldRequiredErrorText: Scalars['String'];
  invalidDateErrorText: Scalars['String'];
  invalidPasswordErrorText: Scalars['String'];
  invalidPhoneErrorText: Scalars['String'];
  invalidTaxIdErrorText: Scalars['String'];
  invalidTaxIdLengthErrorText: Scalars['String'];
  monthRequiredErrorText: Scalars['String'];
  newPasswordRequiredErrorText: Scalars['String'];
  passwordRequiredErrorText: Scalars['String'];
  requiredErrorText: Scalars['String'];
  signupPasswordRequiredErrorText: Scalars['String'];
  taxIdRequiredWithCompanyErrorText: Scalars['String'];
  wrongEmailErrorText: Scalars['String'];
  yearRequiredErrorText: Scalars['String'];
};

export type FoundAddress = {
  __typename?: 'FoundAddress';
  description?: Maybe<Scalars['String']>;
  highlight?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type FoundItems = {
  __typename?: 'FoundItems';
  items?: Maybe<Array<FoundAddress>>;
};

export type Fulfillment = {
  __typename?: 'Fulfillment';
  externalFulfillmentId?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  insertedAt?: Maybe<Scalars['DateTime']>;
  items: Array<FulfillmentItem>;
  orderId?: Maybe<Scalars['UUID4']>;
  status?: Maybe<StatusLabels>;
  taxServiceUpdatedAt?: Maybe<Scalars['NaiveDateTime']>;
  tracking?: Maybe<TrackingNumber>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  warehouseCode?: Maybe<Scalars['String']>;
};

export type FulfillmentItem = {
  __typename?: 'FulfillmentItem';
  insertedAt: Scalars['DateTime'];
  item?: Maybe<Item>;
  quantity?: Maybe<Scalars['Int']>;
  subscriptionIntervalInDays?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type GasExchangeRecord = {
  __typename?: 'GasExchangeRecord';
  deadlineIsExtendable?: Maybe<Scalars['Boolean']>;
  dueDate?: Maybe<Scalars['Date']>;
  gasExchangeReturns: Array<GasExchangeReturn>;
  holdCharge?: Maybe<Scalars['Boolean']>;
  holdChargeReason?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  initialDueDate?: Maybe<Scalars['Date']>;
  lastChargeAttemptAt?: Maybe<Scalars['Date']>;
  lastGasExchangeReturn?: Maybe<GasExchangeReturn>;
  lineItem: LineItem;
  missingOrder?: Maybe<SubmittedOrder>;
  noOfDaysTillDueDate?: Maybe<Scalars['Int']>;
  order: SubmittedOrder;
  priceItem: PriceItem;
  qty?: Maybe<Scalars['Int']>;
  returnedQty?: Maybe<Scalars['Int']>;
  status?: Maybe<GasExchangeRecordStatusType>;
  warnUserAboutDepositFees?: Maybe<Scalars['Boolean']>;
};

export type GasExchangeRecordPayload = {
  __typename?: 'GasExchangeRecordPayload';
  gasExchangeRecords: Array<GasExchangeRecord>;
  pagination: PaginationData;
};

export enum GasExchangeRecordStatusType {
  Active = 'ACTIVE',
  Closed = 'CLOSED'
}

export enum GasExchangeRecordsStatus {
  Active = 'ACTIVE',
  All = 'ALL',
  Closed = 'CLOSED'
}

export type GasExchangeReturn = {
  __typename?: 'GasExchangeReturn';
  appliedQuantity?: Maybe<Scalars['Int']>;
  returnDate?: Maybe<Scalars['Date']>;
  returnedQuantity?: Maybe<Scalars['Int']>;
};

export type GatoradeIdBottle = {
  __typename?: 'GatoradeIdBottle';
  bottleLidFeatureText?: Maybe<Scalars['String']>;
  /** Values: 'blank', 'diy_strip', or 'text' */
  bottleLidFeatureType?: Maybe<Scalars['String']>;
  bottleLidFontColor?: Maybe<Scalars['String']>;
  bottleLidFontColorValue?: Maybe<Scalars['String']>;
  bottleLidFontType?: Maybe<Scalars['String']>;
  bottleLidLogo?: Maybe<Scalars['String']>;
  bottleLidLogoImage?: Maybe<Scalars['String']>;
  bottleLidNumber?: Maybe<Scalars['String']>;
  /** Values: 'logo' or 'number' */
  bottleLidNumberType?: Maybe<Scalars['String']>;
  bottleLidPattern?: Maybe<Scalars['String']>;
  bottleLidPrimaryColor?: Maybe<Scalars['String']>;
  bottleLidPrintFileUrl?: Maybe<Scalars['String']>;
  bottleLidSecondaryColor?: Maybe<Scalars['String']>;
  bottleLidStrokeColor?: Maybe<Scalars['String']>;
  bottleLidStrokeColorValue?: Maybe<Scalars['String']>;
  bottleLidStrokeWeight?: Maybe<Scalars['String']>;
  bottleLidThumbnailImage?: Maybe<Scalars['String']>;
  bottleSideFeatureLogo?: Maybe<Scalars['String']>;
  bottleSideFeatureText?: Maybe<Scalars['String']>;
  /** Values: 'text' or 'logo' */
  bottleSideFeatureType?: Maybe<Scalars['String']>;
  bottleSideFontColor?: Maybe<Scalars['String']>;
  bottleSideFontColorValue?: Maybe<Scalars['String']>;
  bottleSideFontType?: Maybe<Scalars['String']>;
  bottleSideLogoUrl?: Maybe<Scalars['String']>;
  bottleSideMascotAccentColor?: Maybe<Scalars['String']>;
  bottleSideMascotAccentColorValue?: Maybe<Scalars['String']>;
  bottleSideMascotBaseColor?: Maybe<Scalars['String']>;
  bottleSideMascotBaseColorValue?: Maybe<Scalars['String']>;
  bottleSideMascotName?: Maybe<Scalars['String']>;
  bottleSideMascotNonCustomColor?: Maybe<Scalars['String']>;
  bottleSideMascotNonCustomColorValue?: Maybe<Scalars['String']>;
  bottleSidePattern?: Maybe<Scalars['String']>;
  bottleSidePatternImage?: Maybe<Scalars['String']>;
  bottleSidePrimaryColor?: Maybe<Scalars['String']>;
  bottleSidePrimaryColorValue?: Maybe<Scalars['String']>;
  bottleSidePrintFileUrl?: Maybe<Scalars['String']>;
  bottleSideSecondaryColor?: Maybe<Scalars['String']>;
  bottleSideSecondaryColorValue?: Maybe<Scalars['String']>;
  bottleSideStrokeColor?: Maybe<Scalars['String']>;
  bottleSideStrokeColorValue?: Maybe<Scalars['String']>;
  bottleSideStrokeWeight?: Maybe<Scalars['String']>;
  bottleSideThumbnailImage?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  enhancerVariantGtin?: Maybe<Scalars['String']>;
};

export type GatoradeTowel = {
  __typename?: 'GatoradeTowel';
  text?: Maybe<Scalars['String']>;
  towelFeatureLogo?: Maybe<Scalars['String']>;
  towelFeatureText?: Maybe<Scalars['String']>;
  /** Values: 'text' or 'logo' */
  towelFeatureType?: Maybe<Scalars['String']>;
  towelFontColor?: Maybe<Scalars['String']>;
  towelFontColorValue?: Maybe<Scalars['String']>;
  towelFontType?: Maybe<Scalars['String']>;
  towelLogoUrl?: Maybe<Scalars['String']>;
  towelMascotAccentColor?: Maybe<Scalars['String']>;
  towelMascotAccentColorValue?: Maybe<Scalars['String']>;
  towelMascotBaseColor?: Maybe<Scalars['String']>;
  towelMascotBaseColorValue?: Maybe<Scalars['String']>;
  towelMascotName?: Maybe<Scalars['String']>;
  towelMascotNonCustomColor?: Maybe<Scalars['String']>;
  towelMascotNonCustomColorValue?: Maybe<Scalars['String']>;
  towelPattern?: Maybe<Scalars['String']>;
  towelPatternImage?: Maybe<Scalars['String']>;
  towelPrimaryColor?: Maybe<Scalars['String']>;
  towelPrimaryColorValue?: Maybe<Scalars['String']>;
  towelPrintFileUrl?: Maybe<Scalars['String']>;
  towelSecondaryColor?: Maybe<Scalars['String']>;
  towelSecondaryColorValue?: Maybe<Scalars['String']>;
  towelStrokeColor?: Maybe<Scalars['String']>;
  towelStrokeColorValue?: Maybe<Scalars['String']>;
  towelStrokeWeight?: Maybe<Scalars['String']>;
  towelTextLogoState?: Maybe<Scalars['String']>;
  towelThumbnailImage?: Maybe<Scalars['String']>;
};

export type GiftCardConfig = {
  __typename?: 'GiftCardConfig';
  giftCardsEnabled?: Maybe<Scalars['Boolean']>;
};

export type GiftCardInput = {
  cardNumber: Scalars['String'];
  pin: Scalars['String'];
};

export type GiftConfig = {
  __typename?: 'GiftConfig';
  giftEmailConfig?: Maybe<GiftEmailConfig>;
  giftingEnabled?: Maybe<Scalars['Boolean']>;
};

export type GiftEmailConfig = {
  __typename?: 'GiftEmailConfig';
  centralImageUrl?: Maybe<Scalars['String']>;
  footerCopy?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
};

export type GiftInfo = {
  __typename?: 'GiftInfo';
  gifteeEmail?: Maybe<Scalars['String']>;
  gifteeMessage?: Maybe<Scalars['String']>;
  giftorName?: Maybe<Scalars['String']>;
};

/** Input for mutation to update the shipping address on the checkout session.  Address fields required for an address are all required */
export type GiftInfoInput = {
  gifteeEmail?: InputMaybe<Scalars['String']>;
  gifteeMessage?: InputMaybe<Scalars['String']>;
  giftorName?: InputMaybe<Scalars['String']>;
};

export type GtmConfig = {
  __typename?: 'GtmConfig';
  auth?: Maybe<Scalars['String']>;
  containerId?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['String']>;
};

export type GuestCartContainsSubscriptionLocalizations = {
  __typename?: 'GuestCartContainsSubscriptionLocalizations';
  cartText: Scalars['String'];
  itemHeadingText: Scalars['String'];
  itemNoteText: Scalars['String'];
};

export type InsufficientLoyaltyBalanceLocalizations = {
  __typename?: 'InsufficientLoyaltyBalanceLocalizations';
  itemHeadingText: Scalars['String'];
  itemNoteText: Scalars['String'];
};

export type InvalidGiftCardLocalizations = {
  __typename?: 'InvalidGiftCardLocalizations';
  itemHeadingText: Scalars['String'];
  itemNoteText: Scalars['String'];
};

export type InvalidLoyaltyRewardLocalizations = {
  __typename?: 'InvalidLoyaltyRewardLocalizations';
  itemHeadingText: Scalars['String'];
  itemNoteText: Scalars['String'];
};

export type InvoiceInput = {
  unused?: InputMaybe<Scalars['Boolean']>;
};

export type InvoicedAddress = {
  __typename?: 'InvoicedAddress';
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  lastName?: Maybe<Scalars['String']>;
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type Invoicing = {
  __typename?: 'Invoicing';
  addresses: Array<InvoicedAddress>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type IsAddressValidForTaxInput = {
  city: Scalars['String'];
  countryCode: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type IsAddressValidForTaxPayload = {
  __typename?: 'IsAddressValidForTaxPayload';
  isValid?: Maybe<Scalars['Boolean']>;
};

export type Item = {
  __typename?: 'Item';
  brandName?: Maybe<Scalars['String']>;
  bundleOnly?: Maybe<Scalars['Boolean']>;
  compareAtPrice: Scalars['Int'];
  discounts?: Maybe<Array<Maybe<Discount>>>;
  gasExchangeInfo?: Maybe<ItemGasExchangeInfo>;
  gtin: Scalars['String'];
  id: Scalars['UUID4'];
  imgUrl?: Maybe<Scalars['String']>;
  inventoryQty?: Maybe<Scalars['Int']>;
  isOutOfStock?: Maybe<Scalars['Boolean']>;
  itemLinks?: Maybe<Array<Maybe<ItemLink>>>;
  itemNotifications: Array<Scalars['String']>;
  minOrderQty?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  purchaseQtyLimit?: Maybe<Scalars['Int']>;
  registrationInfo?: Maybe<RegistrationInfo>;
  slug?: Maybe<Scalars['String']>;
  /** @deprecated This field will no longer return any sub_items */
  subItems?: Maybe<Array<Maybe<BundleItem>>>;
  subscriptionOnly?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  virtual?: Maybe<Scalars['Boolean']>;
};

export type ItemGasExchangeInfo = {
  __typename?: 'ItemGasExchangeInfo';
  enabled: Scalars['Boolean'];
  missingCylinder?: Maybe<Item>;
  missingCylinderId?: Maybe<Scalars['UUID4']>;
};

export type ItemLink = {
  __typename?: 'ItemLink';
  type: ItemLinkType;
  url: Scalars['String'];
};

export enum ItemLinkType {
  CylinderPdp = 'CYLINDER_PDP',
  UserManual = 'USER_MANUAL'
}

export type ItemUnavailableLocalizations = {
  __typename?: 'ItemUnavailableLocalizations';
  cartText: Scalars['String'];
  itemHeadingText: Scalars['String'];
  itemNoteText: Scalars['String'];
};

export type LegacyCustomization = {
  __typename?: 'LegacyCustomization';
  bottleCode?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  patternId?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  thumbnailImage?: Maybe<Scalars['String']>;
};

/** All price information related to an individual item. */
export type LineItem = {
  __typename?: 'LineItem';
  /** Item in it's current state (may differ from the embedded item) */
  currentItem?: Maybe<Item>;
  /** Any customizations made to the item. */
  customizations?: Maybe<Array<Customization>>;
  discounts: Array<LineItemDiscount>;
  gtin: Scalars['String'];
  /** image url */
  imgUrl?: Maybe<Scalars['String']>;
  /** Item as it was when purchased */
  item?: Maybe<EmbeddedItem>;
  /** ID of the item. */
  itemId: Scalars['UUID4'];
  /** field populated with existing notifications for a gtin */
  itemNotifications: Array<Scalars['String']>;
  /** The discounted price of the item as an individual unit (rounded up, except for promo-code discounts, which are not adjusted). */
  perUnitPrice: Scalars['Int'];
  /** The quantity of the item in the order. */
  quantity: Scalars['Int'];
  /** The original price of the item as an individual unit (either the compare_at_price or or non-discounted price). */
  strikethroughUnitPrice?: Maybe<Scalars['Int']>;
  subscription?: Maybe<SubscriptionMetadata>;
  subscriptionIntervalInDays?: Maybe<Scalars['Int']>;
  /** calculated by subtracting the discount_total from the items base_price * quantity (except for promo-code discounts, which are not included) */
  subtotal: Scalars['Int'];
  title: Scalars['String'];
};

/** Discount information as it applies to the individual line item */
export type LineItemDiscount = {
  __typename?: 'LineItemDiscount';
  amount: Scalars['Int'];
  category: DiscountCategory;
  discountId: Scalars['UUID4'];
  name?: Maybe<Scalars['String']>;
  type: DiscountType;
};

export type Localization = {
  __typename?: 'Localization';
  checkout?: Maybe<CheckoutLocalization>;
  components?: Maybe<ComponentsLocalization>;
  currentLocale: Scalars['String'];
  defaultLocale: Scalars['String'];
  forms?: Maybe<FormsLocalization>;
  /** @deprecated `locale` has been deprecated in favor of `defaultLocale` */
  locale: Scalars['String'];
  portal?: Maybe<PortalLocalization>;
};

export type LoginUserInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LowStockLocalizations = {
  __typename?: 'LowStockLocalizations';
  cartText: Scalars['String'];
  itemHeadingText: Scalars['String'];
  itemNoteText: Scalars['String'];
};

export type LoyaltyConfig = {
  __typename?: 'LoyaltyConfig';
  loyaltyProgramActive: Scalars['Boolean'];
};

/** loyalty data aggregation at Cart and Price level. Will contain total points redeemed, total amount of dollars, and points earned */
export type LoyaltyData = {
  __typename?: 'LoyaltyData';
  totalAmount: Scalars['Int'];
  totalEarnedPoints: Scalars['Int'];
  totalPoints: Scalars['Int'];
};

export type OptsInput = {
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<SearchInput>;
};

export type OrderProcessing = {
  __typename?: 'OrderProcessing';
  headingText: Scalars['String'];
  subHeadingText: Scalars['String'];
};

export type OrderSubscription = {
  __typename?: 'OrderSubscription';
  address: Address;
  id: Scalars['UUID4'];
  initialOrderDate?: Maybe<Scalars['DateTime']>;
  insertedAt: Scalars['DateTime'];
  intervalInDays: Scalars['Int'];
  isTemporary?: Maybe<Scalars['Boolean']>;
  lastOrderAttempt?: Maybe<Scalars['DateTime']>;
  lastSuccessfulOrderDate: Scalars['Date'];
  nextOrderCreationDates: Array<Maybe<Scalars['Date']>>;
  orderSubscriptionItems: Array<OrderSubscriptionItem>;
  originatingOrder?: Maybe<SubmittedOrder>;
  paymentInfo?: Maybe<PaymentInfo>;
  price: Price;
  sourceSubscriptionId?: Maybe<Scalars['UUID4']>;
  status: OrderSubscriptionStatusNames;
  statusReason?: Maybe<Scalars['String']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  tenant: Tenant;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: User;
};

export type OrderSubscriptionItem = {
  __typename?: 'OrderSubscriptionItem';
  analyticsDetails?: Maybe<Scalars['Json']>;
  /** Item in its current state */
  currentItem?: Maybe<Item>;
  customizations?: Maybe<Scalars['Json']>;
  id: Scalars['UUID4'];
  /** Item as it was when purchased */
  item?: Maybe<EmbeddedItem>;
  orderSubscription: OrderSubscription;
  price: Scalars['Int'];
  quantity: Scalars['Int'];
  sourceSubscriptionItemId?: Maybe<Scalars['UUID4']>;
};

export enum OrderSubscriptionRelationshipNames {
  /** Order that was a direct result of a subscription execution */
  Child = 'CHILD',
  /** Order with no relationship to any subscriptions */
  None = 'NONE',
  /** Order that resulted in subscriptions being made (priceItem had > 0 subscription_interval_in_days values) */
  Parent = 'PARENT'
}

export enum OrderSubscriptionStatusNames {
  /** Subscription is active and in valid state to fulfill */
  Active = 'ACTIVE',
  /** Subscription is canceled for reason stated in `status_reason` */
  Canceled = 'CANCELED',
  /** Subscription is paused for reason stated in `status_reason` */
  Paused = 'PAUSED'
}

export type OutOfStockLocalizations = {
  __typename?: 'OutOfStockLocalizations';
  cartText: Scalars['String'];
  itemHeadingText: Scalars['String'];
  itemNoteText: Scalars['String'];
};

export type PaginationData = {
  __typename?: 'PaginationData';
  count: Scalars['Int'];
  page: Scalars['Int'];
  total: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type PaginationInput = {
  limit: Scalars['Int'];
  page: Scalars['Int'];
};

export type PasswordRequirement = {
  __typename?: 'PasswordRequirement';
  msg: Scalars['String'];
  satisfied: Scalars['Boolean'];
};

export type PasswordRequirementDoubleCondition = {
  __typename?: 'PasswordRequirementDoubleCondition';
  bodyText: Scalars['String'];
  boldText1: Scalars['String'];
  boldText2: Scalars['String'];
};

export type PasswordRequirementSingleCondition = {
  __typename?: 'PasswordRequirementSingleCondition';
  bodyText: Scalars['String'];
  boldText: Scalars['String'];
};

/** User's payment details needed during checkout. */
export type Payment = {
  __typename?: 'Payment';
  billingAddress?: Maybe<BillingAddress>;
  clientConfirmationToken?: Maybe<Scalars['String']>;
  isBillingEqualShipping?: Maybe<Scalars['Boolean']>;
  lastErrorCode?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<AllowedPaymentMethod>;
  paymentMethodId?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type PaymentClientTokenPayload = {
  __typename?: 'PaymentClientTokenPayload';
  token: Scalars['String'];
};

export type PaymentConfig = {
  __typename?: 'PaymentConfig';
  availablePaymentMethods?: Maybe<Array<Scalars['String']>>;
  billingAddressConfig: AddressConfig;
  descriptor?: Maybe<Scalars['String']>;
  paymentTypes: Array<PaymentType>;
  processor?: Maybe<PaymentProcessor>;
  publicPaymentToken?: Maybe<Scalars['String']>;
};

export type PaymentInfo = {
  __typename?: 'PaymentInfo';
  cardExpirationDate?: Maybe<Scalars['String']>;
  cardExpiryMonth?: Maybe<Scalars['String']>;
  cardExpiryYear?: Maybe<Scalars['String']>;
  cardType?: Maybe<PaymentInfoCardType>;
  cardholderName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<PaymentInfoPaymentMethod>;
  paymentToken?: Maybe<Scalars['String']>;
  uniqueNumberIdentifier?: Maybe<Scalars['String']>;
};

/** Enum for the different types of cards in the payment_info */
export enum PaymentInfoCardType {
  AmericanExpress = 'AMERICAN_EXPRESS',
  Discover = 'DISCOVER',
  Jcb = 'JCB',
  Mastercard = 'MASTERCARD',
  Visa = 'VISA'
}

/** List of payment methods on PaymentInfo. */
export enum PaymentInfoPaymentMethod {
  AllocatedCredit = 'ALLOCATED_CREDIT',
  ApplePayCard = 'APPLE_PAY_CARD',
  Blik = 'BLIK',
  CreditCard = 'CREDIT_CARD',
  P24 = 'P24',
  PaypalAccount = 'PAYPAL_ACCOUNT'
}

/** object for holding a single default payment method */
export type PaymentMethod = ApplePayCard | CreditCard | PaypalAccount;

/** A list of credit cards saved by the user and a list of valid credit card types. */
export type PaymentMethodCreditCard = {
  __typename?: 'PaymentMethodCreditCard';
  savedCards: Array<CreditCard>;
  validCardTypes: Array<CardType>;
};

export enum PaymentMethodEnum {
  CreditCard = 'CREDIT_CARD',
  Paypal = 'PAYPAL'
}

/** A list of paypal accounts saved by the user. */
export type PaymentMethodPaypal = {
  __typename?: 'PaymentMethodPaypal';
  savedAccounts: Array<PaypalAccount>;
  validCardTypes: Array<CardType>;
};

/** object defined to hold the different payment methods */
export type PaymentMethods = {
  __typename?: 'PaymentMethods';
  applePayCards: Array<ApplePayCard>;
  creditCards: Array<CreditCard>;
  default?: Maybe<PaymentMethod>;
  paypalAccounts: Array<PaypalAccount>;
};

export type PaymentOptionsInput = {
  default?: InputMaybe<Scalars['Boolean']>;
  nonce?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
  token?: InputMaybe<Scalars['String']>;
};

export enum PaymentProcessor {
  Braintree = 'braintree',
  Stripe = 'stripe'
}

export type PaymentRequest = {
  __typename?: 'PaymentRequest';
  billingAddress?: Maybe<BillingAddress>;
  isBillingEqualShipping?: Maybe<Scalars['Boolean']>;
  paymentMethod?: Maybe<AllowedPaymentMethod>;
};

export type PaymentType = {
  __typename?: 'PaymentType';
  brandImgUrl: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** Paypal account saved by the user. */
export type PaypalAccount = {
  __typename?: 'PaypalAccount';
  email: Scalars['String'];
  isDefault: Scalars['Boolean'];
  isRemovable?: Maybe<Scalars['Boolean']>;
  /** Token representing payment method. */
  token: Scalars['String'];
};

/** Input for mutation to save paypal payment information */
export type PaypalInput = {
  token?: InputMaybe<Scalars['String']>;
};

export type PhoneNumberCountryCodesAllowed = {
  __typename?: 'PhoneNumberCountryCodesAllowed';
  code: Scalars['String'];
  country: Scalars['String'];
  length: Scalars['Int'];
};

export type PortalAccountPageLocalization = {
  __typename?: 'PortalAccountPageLocalization';
  activeAccountHeadingText: Scalars['String'];
  addressesHeadingText: Scalars['String'];
  defaultTitleText: Scalars['String'];
  emailHeadingText: Scalars['String'];
  nameHeadingText: Scalars['String'];
  nameUpdateButtonText: Scalars['String'];
  nameUpdateCancelButtonText: Scalars['String'];
  nameUpdateSubmitButtonText: Scalars['String'];
  passwordChangeButtonText: Scalars['String'];
  passwordHeadingText: Scalars['String'];
  paymentsHeadingText: Scalars['String'];
};

export type PortalAddressLocalization = {
  __typename?: 'PortalAddressLocalization';
  addHeadingText: Scalars['String'];
  addSubmitButtonText: Scalars['String'];
  cancelButtonText: Scalars['String'];
  editHeadingText: Scalars['String'];
  makeDefaultText: Scalars['String'];
  updateSubmitButtonText: Scalars['String'];
};

export type PortalAltsLocalization = {
  __typename?: 'PortalAltsLocalization';
  accountAltText: Scalars['String'];
  shopLogoAltText: Scalars['String'];
};

export type PortalBreadcrumbsLocalization = {
  __typename?: 'PortalBreadcrumbsLocalization';
  account: Scalars['String'];
  accountDetails: Scalars['String'];
  addAddress: Scalars['String'];
  addPayment: Scalars['String'];
  changePassword: Scalars['String'];
  editAddress: Scalars['String'];
  exchange: Scalars['String'];
  exchangeDetails: Scalars['String'];
  machines: Scalars['String'];
  notFound: Scalars['String'];
  orders: Scalars['String'];
  shippingAddresses: Scalars['String'];
  subscriptions: Scalars['String'];
};

export type PortalCardLocalization = {
  __typename?: 'PortalCardLocalization';
  addAddressLabel: Scalars['String'];
  addPaymentLabel: Scalars['String'];
  allocationText: Scalars['String'];
  creditCardNumberText: Scalars['String'];
  currentLabel: Scalars['String'];
  defaultAddressLabel: Scalars['String'];
  defaultPaymentLabel: Scalars['String'];
  deleteButtonText: Scalars['String'];
  editButtonText: Scalars['String'];
  makeDefaultButtonText: Scalars['String'];
  numRemainingLabel: Scalars['String'];
  selectLabel: Scalars['String'];
  subscriptionAddressButtonText: Scalars['String'];
  viewAllButtonText: Scalars['String'];
};

export type PortalErrorsAddressVerificationLocalization = {
  __typename?: 'PortalErrorsAddressVerificationLocalization';
  checkoutSpecificConfirmSuggestedText: Scalars['String'];
  confirmSuggestedAddressText: Scalars['String'];
  confirmText: Scalars['String'];
  doYouWantToProceedText: Scalars['String'];
  editEnteredAddressText: Scalars['String'];
  editText: Scalars['String'];
  enteredAddressText: Scalars['String'];
  goBackText: Scalars['String'];
  invalidZipCodeText: Scalars['String'];
  keepEnteredAddressText: Scalars['String'];
  notAbleToVerifyShippingAddressText: Scalars['String'];
  recommendChangesText: Scalars['String'];
  shippingAddressText: Scalars['String'];
  suggestedAddressText: Scalars['String'];
  useSuggestedAddressText: Scalars['String'];
  verifyText: Scalars['String'];
};

export type PortalErrorsGeoblockLocalization = {
  __typename?: 'PortalErrorsGeoblockLocalization';
  apiError: Scalars['String'];
  zipBlocked: Scalars['String'];
};

export type PortalErrorsLocalization = {
  __typename?: 'PortalErrorsLocalization';
  addressVerification?: Maybe<PortalErrorsAddressVerificationLocalization>;
  geoBlock?: Maybe<PortalErrorsGeoblockLocalization>;
};

export type PortalExchangeDetailsPageLocalization = {
  __typename?: 'PortalExchangeDetailsPageLocalization';
  avoidDepositFeesWarningTextFractional: Scalars['String'];
  avoidDepositFeesWarningTextMany: Scalars['String'];
  avoidDepositFeesWarningTextPlural: Scalars['String'];
  avoidDepositFeesWarningTextSingular: Scalars['String'];
  daysLeftToReturnHeadingText: Scalars['String'];
  daysLeftToReturnTextPlural: Scalars['String'];
  daysLeftToReturnTextSingular: Scalars['String'];
  depositFeeAddedAlertText: Scalars['String'];
  depositFeeAddedText: Scalars['String'];
  exchangeDetailsText: Scalars['String'];
  expectedReturnDateText: Scalars['String'];
  extendReturnDeadlineText: Scalars['String'];
  missedReturnDateText: Scalars['String'];
  notFoundMsg: Scalars['String'];
  orderDetailsHeadingText: Scalars['String'];
  orderedText: Scalars['String'];
  paymentHeadingText: Scalars['String'];
  returnByText: Scalars['String'];
  returnDateExtendedText: Scalars['String'];
  returnDateText: Scalars['String'];
  returnedOnText: Scalars['String'];
  returnedOutOfTotalText: Scalars['String'];
  returnedText: Scalars['String'];
  shippingHeadingText: Scalars['String'];
  statusText: Scalars['String'];
  yourOrderText: Scalars['String'];
};

export type PortalExchangeListPageLocalization = {
  __typename?: 'PortalExchangeListPageLocalization';
  active: Scalars['String'];
  closed: Scalars['String'];
  cylinderText: Scalars['String'];
  dueInDaysTextPlural: Scalars['String'];
  dueInDaysTextSingular: Scalars['String'];
  gasExchangeListTitle: Scalars['String'];
  gasExchangePageListTitle: Scalars['String'];
  orderDate: Scalars['String'];
  returnByDate: Scalars['String'];
  returnPastDue: Scalars['String'];
  returnedDate: Scalars['String'];
  viewDetails: Scalars['String'];
};

export type PortalHeaderLocalization = {
  __typename?: 'PortalHeaderLocalization';
  signOutLinkText: Scalars['String'];
};

/**
 * Returns a map of all portal (my account) elements and their translations.
 *
 * Example:
 *     ```
 *     query {
 *       localization {
 *         portal {
 *           accountPage {
 *             nameHeadingText
 *           }
 *         }
 *       }
 *     }
 *     ```
 */
export type PortalLocalization = {
  __typename?: 'PortalLocalization';
  accountPage?: Maybe<PortalAccountPageLocalization>;
  accountVerification?: Maybe<AccountVerificationLocalization>;
  address?: Maybe<PortalAddressLocalization>;
  alts?: Maybe<PortalAltsLocalization>;
  breadcrumbs?: Maybe<PortalBreadcrumbsLocalization>;
  card?: Maybe<PortalCardLocalization>;
  errors?: Maybe<PortalErrorsLocalization>;
  exchangeDetailPage?: Maybe<PortalExchangeDetailsPageLocalization>;
  exchangeList?: Maybe<PortalExchangeListPageLocalization>;
  header?: Maybe<PortalHeaderLocalization>;
  machinesPage?: Maybe<PortalMachinesPageLocalization>;
  notAvailable?: Maybe<PortalNotAvailableLocalization>;
  orderDetailPage?: Maybe<PortalOrderDetailPageLocalization>;
  orderSummary?: Maybe<PortalOrderSummaryLocalization>;
  ordersPage?: Maybe<PortalOrdersPageLocalization>;
  pageTitlesInHead?: Maybe<PortalPageTitlesInHeadLocalization>;
  password?: Maybe<PortalPasswordLocalization>;
  payment?: Maybe<PortalPaymentLocalization>;
  subscriptionDetailPage?: Maybe<PortalSubscriptionDetailPageLocalization>;
  subscriptionsPage?: Maybe<PortalSubscriptionsPageLocalization>;
};

export type PortalMachinesPageLocalization = {
  __typename?: 'PortalMachinesPageLocalization';
  addMachinesText: Scalars['String'];
  areYouSureDeleteThisMachineText: Scalars['String'];
  cancelText: Scalars['String'];
  confirmDeletionText: Scalars['String'];
  deleteMachineText: Scalars['String'];
  getGasText: Scalars['String'];
  learnAboutSparklingWaterMakersText: Scalars['String'];
  machineText: Scalars['String'];
  machinesText: Scalars['String'];
  registerYourMachineNowText: Scalars['String'];
  troubleshootingGuideText: Scalars['String'];
  unlockWarrantyText: Scalars['String'];
  userManualText: Scalars['String'];
  warrantyExpiredText: Scalars['String'];
  warrantyExpiresText: Scalars['String'];
  yesDeleteThisMachineText: Scalars['String'];
};

export type PortalNotAvailableLocalization = {
  __typename?: 'PortalNotAvailableLocalization';
  exchanges: Scalars['String'];
  headingText: Scalars['String'];
  linkContentText: Scalars['String'];
  linkText: Scalars['String'];
  naAbbreviationText: Scalars['String'];
  orders: Scalars['String'];
  subscriptions: Scalars['String'];
};

export type PortalOrderDetailPageLocalization = {
  __typename?: 'PortalOrderDetailPageLocalization';
  dateText: Scalars['String'];
  invoiceNote: Scalars['String'];
  notFoundErrorText: Scalars['String'];
  orderIdHeadingText: Scalars['String'];
  orderSummaryHeadingText: Scalars['String'];
  paymentHeadingText: Scalars['String'];
  printButtonText: Scalars['String'];
  questionAboutOrderNumberText: Scalars['String'];
  questionAboutOrderText: Scalars['String'];
  shippingAddressHeadingText: Scalars['String'];
  trackingText: Scalars['String'];
};

export type PortalOrderSummaryLocalization = {
  __typename?: 'PortalOrderSummaryLocalization';
  estimatedFeeLabel: Scalars['String'];
  estimatedTaxLabel: Scalars['String'];
  feeLabel: Scalars['String'];
  freeShipLabel: Scalars['String'];
  shippingLabel: Scalars['String'];
  subtotalLabel: Scalars['String'];
  totalLabel: Scalars['String'];
};

export type PortalOrdersPageLocalization = {
  __typename?: 'PortalOrdersPageLocalization';
  dateHeadingText: Scalars['String'];
  exchangeText: Scalars['String'];
  orderIdHeadingText: Scalars['String'];
  ordersHeadingText: Scalars['String'];
  receiptButtonText: Scalars['String'];
  reorderButtonText: Scalars['String'];
  reorderErrorNote: Scalars['String'];
  shippingAddressHeadingText: Scalars['String'];
  totalHeadingText: Scalars['String'];
};

export type PortalPageTitlesInHeadLocalization = {
  __typename?: 'PortalPageTitlesInHeadLocalization';
  verifyAccount: Scalars['String'];
};

export type PortalPasswordLocalization = {
  __typename?: 'PortalPasswordLocalization';
  backButtonText: Scalars['String'];
  cancelButtonText: Scalars['String'];
  changePasswordCancelButtonText: Scalars['String'];
  changePasswordHeadingText: Scalars['String'];
  changePasswordSubmitButtonText: Scalars['String'];
  checkYourEmailContentText: Scalars['String'];
  checkYourEmailHeadingText: Scalars['String'];
  currentPasswordLabelText: Scalars['String'];
  forgotPasswordHeadingText: Scalars['String'];
  forgotPasswordHeadingWithTenantText: Scalars['String'];
  minCharactersText: PasswordRequirementSingleCondition;
  newPasswordLabelText: Scalars['String'];
  oneSpecialCharText: PasswordRequirementSingleCondition;
  oneUppercaseOneLowercaseAlphaText: PasswordRequirementDoubleCondition;
  passwordUpdatedBannerText: Scalars['String'];
  resetPasswordHeadingText: Scalars['String'];
  resetPasswordHeadingWithTenantText: Scalars['String'];
  twoNumericDigitsText: PasswordRequirementSingleCondition;
  updatePasswordHeadingText: Scalars['String'];
};

export type PortalPaymentLocalization = {
  __typename?: 'PortalPaymentLocalization';
  addHeadingText: Scalars['String'];
  billingSameAsShippingText: Scalars['String'];
  cancelButtonText: Scalars['String'];
  creditCardSelectorText: Scalars['String'];
  makeDefaultText: Scalars['String'];
  paypalSelectorText: Scalars['String'];
  submitButtonText: Scalars['String'];
};

export type PortalSubscriptionDetailPageLocalization = {
  __typename?: 'PortalSubscriptionDetailPageLocalization';
  addressHeadingText: Scalars['String'];
  backButtonText: Scalars['String'];
  cancelHeadingSubText: Scalars['String'];
  cancelHeadingText: Scalars['String'];
  cancelLabel: Scalars['String'];
  cancelSubscriptionButtonText: Scalars['String'];
  canceledText: Scalars['String'];
  closeButtonText: Scalars['String'];
  editAddressButtonText: Scalars['String'];
  editPaymentButtonText: Scalars['String'];
  intervalHeadingText: Scalars['String'];
  intervalText: Scalars['String'];
  manageSubscriptionLabel: Scalars['String'];
  needToStartNewLabel: Scalars['String'];
  nextDeliveryDateHeadingText: Scalars['String'];
  nextShipmentDateText: Scalars['String'];
  noLongerNeedLabel: Scalars['String'];
  orderedAtHeadingText: Scalars['String'];
  otherLabel: Scalars['String'];
  pausedBannerText: Scalars['String'];
  pausedText: Scalars['String'];
  paymentHeadingText: Scalars['String'];
  paymentUpdateButtonText: Scalars['String'];
  paymentUpdateNeededText: Scalars['String'];
  priceNoteText: Scalars['String'];
  reasonForCancelingLabel: Scalars['String'];
  reasonForCancelingPlaceholder: Scalars['String'];
  renameLabel: Scalars['String'];
  resumeLabel: Scalars['String'];
  resumedBannerText: Scalars['String'];
  shippingIssueLabel: Scalars['String'];
  skipHeadingText: Scalars['String'];
  skipLabel: Scalars['String'];
  skipNextShipmentButtonText: Scalars['String'];
  skippedBannerText: Scalars['String'];
  skippedShipmentDateText: Scalars['String'];
  subscriptionNotFoundText: Scalars['String'];
  subscriptionText: Scalars['String'];
};

export type PortalSubscriptionsPageLocalization = {
  __typename?: 'PortalSubscriptionsPageLocalization';
  actionRequiredLabel: Scalars['String'];
  canceledLabel: Scalars['String'];
  headingText: Scalars['String'];
  intervalText: Scalars['String'];
  nextDeliveryDateText: Scalars['String'];
  noSubscriptionsFoundText: Scalars['String'];
  pausedLabel: Scalars['String'];
};

/** Contains relevant information about the price of an order. */
export type Price = {
  __typename?: 'Price';
  /** Same as the discount_amount in promoCodeDiscount */
  discount: Scalars['Int'];
  discounts: Array<Discount>;
  /**
   * If the Price contains any Dynamic Bundles will hold top level definitions.
   * This will contain an array of maps which contain necessary DynamicBundle
   * information such as the DynamicBundle id and cart_bundle_reference that will
   * help identify which items belong to which bundle.
   */
  dynamicBundles?: Maybe<Scalars['Json']>;
  giftCards?: Maybe<Array<Maybe<EmbeddedGiftCard>>>;
  id?: Maybe<Scalars['UUID4']>;
  items: Array<PriceItem>;
  /** This will contain either BundleLineItems or LineItems */
  lineItems: Array<PriceItemsAndBundleItems>;
  loyaltyData?: Maybe<LoyaltyData>;
  promoCodeDiscounts: Array<PromoCodeDiscount>;
  regulatoryTaxTypes: Array<RegulatoryTaxType>;
  /** Shipping cost of the order. */
  shipping: Scalars['Int'];
  /**
   * SubTotal of the order calculated by adding all line item base_prices and deducting
   * non promo code discounts
   */
  subtotal: Scalars['Int'];
  /** Total amount of regulatory tax applied to the order. */
  taxRegulatoryTotal: Scalars['Int'];
  /** Total amount of sales tax applied to the order. */
  taxSalesTotal: Scalars['Int'];
  /** Total of the order calculated by adding all line item totals. */
  total: Scalars['Int'];
};

export type PriceItem = {
  __typename?: 'PriceItem';
  basePrice?: Maybe<Scalars['Int']>;
  compareAtPrice?: Maybe<Scalars['Int']>;
  /** Item in it's current state (may differ from embedded item) */
  currentItem?: Maybe<Item>;
  customizations?: Maybe<Scalars['Json']>;
  discountAmount?: Maybe<Scalars['Int']>;
  id: Scalars['UUID4'];
  /** Item as it was when purchased */
  item?: Maybe<EmbeddedItem>;
  itemId?: Maybe<Scalars['UUID4']>;
  price?: Maybe<Price>;
  quantity?: Maybe<Scalars['Int']>;
  /** @deprecated This field should not be used nor relied upon */
  shippingAmount?: Maybe<Scalars['Int']>;
  subscriptionIntervalInDays?: Maybe<Scalars['Int']>;
  taxAmount?: Maybe<Scalars['Int']>;
  taxItems: Array<TaxItem>;
  unclaimedTaxes?: Maybe<Scalars['Int']>;
};

export type PriceItemsAndBundleItems = BundleLineItem | LineItem;

export type PriceLocalization = {
  __typename?: 'PriceLocalization';
  eachPriceText: Scalars['String'];
  regularPriceText: Scalars['String'];
};

/** Promo Discount information. */
export type PromoCodeDiscount = {
  __typename?: 'PromoCodeDiscount';
  /** the discount campaign amount (the percent off or the flat amount) */
  amount: Scalars['Int'];
  /** the amount that the promo code has discounted the order */
  discountAmount: Scalars['Int'];
  /** the discount id, which can be used to identify matching line_item_discounts */
  discountId: Scalars['UUID4'];
  /** how many line items this discounts applied to */
  lineItemCount: Scalars['Int'];
  promoCode: Scalars['String'];
  /** indicates if it's a percent or flat discount */
  type: DiscountType;
};

export type PurchaseQtyLimitLocalizations = {
  __typename?: 'PurchaseQtyLimitLocalizations';
  cartText: Scalars['String'];
};

export enum RegisterableType {
  Machine = 'MACHINE'
}

export type RegistrationInfo = {
  __typename?: 'RegistrationInfo';
  registerableType?: Maybe<RegisterableType>;
  registrable?: Maybe<Scalars['Boolean']>;
};

export type RegistrationRecord = {
  __typename?: 'RegistrationRecord';
  customData?: Maybe<Scalars['Json']>;
  emailOptIn?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID4'];
  insertedAt: Scalars['DateTime'];
  item: Item;
  itemId: Scalars['UUID4'];
  newUser: Scalars['Boolean'];
  order?: Maybe<SubmittedOrder>;
  orderId?: Maybe<Scalars['UUID4']>;
  purchaseDate?: Maybe<Scalars['Date']>;
  purchaseLocation: Scalars['String'];
  registeredAt: Scalars['DateTime'];
  source: Scalars['String'];
  status: StatusType;
  tenant: Tenant;
  tenantId: Scalars['UUID4'];
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['UUID4'];
  utmData?: Maybe<UtmData>;
  warrantyExpirationDate?: Maybe<Scalars['Date']>;
};

/**
 * Tax information split by sales tax and regulatory fees.
 *
 * This goes through each tax item and splits the taxes by imposition
 * type (sales tax, regulatory fees). The `total` field is the sum of
 * all the taxes for the given imposition type.
 */
export type RegulatoryTaxType = {
  __typename?: 'RegulatoryTaxType';
  /**
   * The imposition value.
   *
   * The is the string representation of the imposition type id. Such as
   * "General Sales Tax" or "Beverage Tax (Alcohol or Soft Drinks)".
   */
  code: Scalars['String'];
  /**
   * The imposition type id.
   *
   * Includes only Regulatory Fees.
   * Two regulator fees we care about specifically are:
   * - `35`: Beverage Tax (Alcohol or Soft Drinks)
   * - `61`: Beverage Container Fee
   */
  id: Scalars['String'];
  /** The total amount of taxes for the given imposition type. */
  total: Scalars['Int'];
};

/**
 * Inputs for requesting Password Reset for a User.
 *
 * The `state` field is used to pass information back to the browser when
 * as User clicks on the password reset link in their email. The state is
 * included as a query string appended to the URL. The value of `state` can
 * be any string, as long as it is URL safe.
 *
 * The API does not inspect or manipulate the `state`, it is simply passed
 * to the password reset link.
 */
export type RequestPasswordResetForUserInput = {
  email: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
};

export type RequestPasswordResetForUserPayload = {
  __typename?: 'RequestPasswordResetForUserPayload';
  email: Scalars['String'];
};

export type RequestUserVerificationInput = {
  email: Scalars['String'];
};

export type RequestUserVerificationPayload = {
  __typename?: 'RequestUserVerificationPayload';
  email?: Maybe<Scalars['String']>;
};

export type ResetUserPasswordInput = {
  password: Scalars['String'];
  token: Scalars['String'];
};

export type RestrictedItemsByZipCodePayload = {
  __typename?: 'RestrictedItemsByZipCodePayload';
  restrictedItems: Array<Item>;
};

export type RetrievedAddress = {
  __typename?: 'RetrievedAddress';
  adminAreaCode?: Maybe<Scalars['String']>;
  adminAreaName?: Maybe<Scalars['String']>;
  block?: Maybe<Scalars['String']>;
  buildingName?: Maybe<Scalars['String']>;
  buildingNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryName?: Maybe<Scalars['String']>;
  dataLevel?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  domesticId?: Maybe<Scalars['String']>;
  field1?: Maybe<Scalars['String']>;
  field2?: Maybe<Scalars['String']>;
  field3?: Maybe<Scalars['String']>;
  field4?: Maybe<Scalars['String']>;
  field5?: Maybe<Scalars['String']>;
  field6?: Maybe<Scalars['String']>;
  field7?: Maybe<Scalars['String']>;
  field8?: Maybe<Scalars['String']>;
  field9?: Maybe<Scalars['String']>;
  field10?: Maybe<Scalars['String']>;
  field11?: Maybe<Scalars['String']>;
  field12?: Maybe<Scalars['String']>;
  field13?: Maybe<Scalars['String']>;
  field14?: Maybe<Scalars['String']>;
  field15?: Maybe<Scalars['String']>;
  field16?: Maybe<Scalars['String']>;
  field17?: Maybe<Scalars['String']>;
  field18?: Maybe<Scalars['String']>;
  field19?: Maybe<Scalars['String']>;
  field20?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  languageAlternatives?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  line3?: Maybe<Scalars['String']>;
  line4?: Maybe<Scalars['String']>;
  line5?: Maybe<Scalars['String']>;
  neighbourhood?: Maybe<Scalars['String']>;
  poBoxNumber?: Maybe<Scalars['String']>;
  secondaryStreet?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  subBuilding?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type RetrievedItems = {
  __typename?: 'RetrievedItems';
  items?: Maybe<Array<RetrievedAddress>>;
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  acceptTermsAndConditions?: Maybe<User>;
  /**
   * Authorize and save a Gift Card to the checkout session
   *
   *   Example:
   *   ```
   *   mutation AddGiftCard($id: UUID4! $input: AddGiftCardInput!){
   *     addGiftCard(id: $id, input: $input){
   *       id
   *       giftCards {
   *         amount
   *         appliedAmount
   *         last4
   *         type
   *         giftCardId
   *       }
   *       price {
   *         total
   *       }
   *     }
   *   }
   *
   *   variables:
   *
   *   {
   *     "id": "session_id",
   *     "input": {
   *       "card_number": "5111111111111112345",
   *       "pin": "123456"
   *     }
   *   }
   *   ```
   *   Errors:
   *     giftCardNotFound
   *     noGiftCardBalanceAvailable
   *     giftCardMisMatch
   *     unableToApplyGiftCard
   *     sessionNotFound
   */
  addGiftCard?: Maybe<CheckoutSession>;
  addOrderSubscriptionItem?: Maybe<OrderSubscription>;
  /**
   * Applies a discount to cart
   *
   * Example:
   * ```
   * mutation applyDiscount($id: UUID4!, $input: DiscountInput!){
   *   applyDiscount(id: $id, input: $input){
   *     id
   *   }
   * }
   *
   * variables:
   *
   * {"id": "session_id",
   *   "input": {"promo_code": "GATORADE15"}}
   * ```
   *
   * Errors:
   *   unableToSaveDiscount
   *   unableToApplyDiscount
   *   discountPromoNotFound
   *   discountLimitExceeded
   *   discountPromoCodeRequiresEmail
   *   discountExceedsSubtotal
   *   discountPromoCodeNotApplicable
   */
  applyDiscount?: Maybe<CheckoutSession>;
  /**
   * Save the one of a user's existing saved shipping address to the checkout session
   *
   *   Errors:
   *     sessionNotFound
   *     addressNotFound
   */
  applySavedShippingAddress?: Maybe<CheckoutSession>;
  archiveRegistrationRecord?: Maybe<RegistrationRecord>;
  changeUserPassword?: Maybe<User>;
  createAccountAndRegistrationRecord?: Maybe<User>;
  createPaymentClientToken: PaymentClientTokenPayload;
  createPaymentMethod: PaymentMethod;
  createRegistrationRecord?: Maybe<RegistrationRecord>;
  createSetupIntent: SetupIntent;
  createTempSubscription?: Maybe<OrderSubscription>;
  /** create a cart using a submitted user order */
  createTemporaryCartFromOrder?: Maybe<Cart>;
  createUserAddress: Address;
  deleteCreditCard: Scalars['String'];
  deleteUserAddress: Address;
  /**
   * Return a single gas exchange record with the due date extended.
   *
   * A default number of days is used
   * Example:
   * ```
   * mutation ExtendDueDate($input: ExtendDueDateInput!) {
   *   extendDueDate(input: $input) {
   *     id
   *     dueDate
   *
   * ```
   * Variables:
   * ```
   * {
   *   "input": {
   *     "id": "456a9e8a-c9ba-4ccb-91bf-420549c32566"
   *   }
   * ```)
   */
  extendDueDate?: Maybe<GasExchangeRecord>;
  /**
   * This will finalize the price object by moving the checkout session from `:checkout`
   * stage to `:review` stage. Once past the `:checkout` stage, the price will include
   * tax calculations.
   *
   *   Errors:
   *     unableToSetStage
   */
  finalizePrice?: Maybe<CheckoutSession>;
  /**
   * Finalize the session after processing and order.
   *
   * This will move do all post submit actions for orders that are not finalized automatically.
   * Stripe orders we keep in v3_draft state after submission because we need to confirm payment on FE and after
   * successfully confirmed payed we run all post-submit tasks (archiving session etc)
   */
  finalizeSession?: Maybe<SubmittedOrder>;
  loginUser?: Maybe<User>;
  logoutUser?: Maybe<User>;
  /** Merge two carts */
  mergeCarts?: Maybe<Cart>;
  /** Creates a cart from a temporary cart */
  persistTemporaryCart?: Maybe<Cart>;
  processOrderSubscriptionTomorrow?: Maybe<OrderSubscription>;
  processSubscriptionNow?: Maybe<OrderSubscription>;
  /**
   * Retrieve a user's abandoned cart using an email hash string generated in
   *  an email by Salesforce.
   */
  recoverCart?: Maybe<Cart>;
  /**
   * removes a discount from session
   *
   * Example:
   * ```
   * mutation removeDiscount($id: UUID4!){
   *   removeDiscount(id: $id){
   *     id
   *   }
   * }
   *
   * variables:
   *
   * {"id": "session_id"}
   * ```
   *
   * Errors:
   *   unableToRemoveDiscount
   */
  removeDiscount?: Maybe<CheckoutSession>;
  /**
   * Remove a Gift Card from a checkout session. This will cancel any authorizations.
   *
   *   Example:
   *   ```
   *   mutation removeGiftCard($id: UUID4!){
   *     removeGiftCard(id: $id){
   *       id
   *       giftCards {
   *         amount
   *         appliedAmount
   *         last4
   *         type
   *         giftCardId
   *       }
   *       price {
   *         total
   *       }
   *     }
   *   }
   *
   *   variables:
   *
   *   {"id": "session_id"}
   *   ```
   *   Errors:
   *     giftCardNotFound
   *     unableToApplyGiftCard
   *     sessionNotFound
   */
  removeGiftCard?: Maybe<CheckoutSession>;
  /**
   * removes gift_info from the session
   *
   * Example:
   * ```
   * mutation removeGiftInfo($id: UUID4!){
   *   removeGiftInfo(id: $id){
   *     id
   *   }
   * }
   *
   * variables:
   *
   * {"id": "session_id"}
   * ```
   *
   * Errors:
   *   giftingDisabled
   */
  removeGiftInfo?: Maybe<CheckoutSession>;
  removeOrderSubscriptionItem?: Maybe<OrderSubscription>;
  /**
   * Requests a Password Reset for a User with the email provided.
   *
   * Mutation
   * ```
   * mutation RequestPasswordResetForUser($input: RequestPasswordResetForUserInput!) {
   *   requestPasswordResetForUser(input: $input) {
   *     email
   *   }
   * }
   * ```
   *
   * Variables
   * ```
   * {
   *   "input": {
   *     "email": "user@example.com"
   *   }
   * }
   * ```
   */
  requestPasswordResetForUser?: Maybe<RequestPasswordResetForUserPayload>;
  requestUserVerification?: Maybe<RequestUserVerificationPayload>;
  resetUserPassword?: Maybe<User>;
  /**
   * Used for Remember Me Feature. Captures fields user enters and can be pre-filled if user
   *   returns to the page after leaving. Also once the user enters an email, we can use that to send
   *   a cart abandonment email if the user leaves and does not
   *   come back within a given time period.
   *
   *   Errors:
   *     unableToSaveEnteredContactInfo
   */
  saveEnteredContactInfo?: Maybe<CheckoutSession>;
  /**
   * Saves gift_info to the session
   *
   * Example:
   * ```
   * mutation saveGiftInfo($id: UUID4!, $input: GiftInfoInput!){
   *   saveGiftInfo(id: $id, input: $input){
   *     id
   *   }
   * }
   *
   * variables:
   *
   * {"id": "session_id",
   *   "input": {"giftee_message": "HELLO"}}
   * ```
   *
   * Errors:
   *   giftingDisabled
   */
  saveGiftInfo?: Maybe<CheckoutSession>;
  /**
   * Saves payment information to the checkout session
   *
   * Example:
   * ```
   * mutation savePayment($id: UUID4!, $input: SavePaymentInput!){
   *   savePayment(id: $id, input: $input){
   *     id
   *   }
   * }
   *
   * variables:
   *
   * {"id": "session_id",
   *   "input": {"paypal":
   *     {"paymentMethod": "PAYPAL"}}}
   * ```
   *
   * Errors:
   *   unableToSavePayment
   *   paymentDataError
   *   incompleteShippingAddress
   *   missingBillingAddress
   */
  savePayment?: Maybe<CheckoutSession>;
  /**
   * Save miscellaneous payment options to the checkout session
   *
   * Errors:
   *   sessionNotFound
   *   unableToSavePaymentOptions
   */
  savePaymentOptions?: Maybe<CheckoutSession>;
  saveShippingMethod?: Maybe<CheckoutSession>;
  /**
   * Used to save miscellaneous optional entered during checkout process.
   *
   * Errors:
   *   sessionNotFound
   *   unableToSaveShippingOptions
   */
  saveShippingOptions?: Maybe<CheckoutSession>;
  /**
   * Used to save the suggested shipping address from the verifier on the checkout session
   *
   *   Errors:
   *     unableToSaveEnteredContactInfo
   */
  saveSuggestedAddress?: Maybe<CheckoutSession>;
  /**
   * Create payment transaction for using on FE. On Stripe it's PaymentIntent object that has
   * payment intent secret FE can use for redirect to external system.
   *
   * Example:
   * ```
   * mutation setupTransaction($id: UUID4!){
   *   setupTransaction(id: $id){
   *     id
   *   }
   * }
   *
   * variables:
   *
   * {"id": "session_id"}
   * ```
   */
  setupTransaction?: Maybe<CheckoutSession>;
  /**
   * Transition from store front to checkout session.
   *
   * This will either create an order or return an existing order
   * for the given cart_id. The order will be returned as the
   * draft order in the checkout session.
   * Example:
   *
   * mutation shopToCheckout($cartId: UUID4!){
   *   shopToCheckout(cartId: $cartId){
   *     id
   *   }
   * }
   *
   * variables:
   * {"cartId": "cart_id"}
   *
   * Errors:
   *   sessionNotFound
   *   cartNotFound
   *   emptyCart
   */
  shopToCheckout?: Maybe<CheckoutSession>;
  signupUser?: Maybe<User>;
  skipOrderSubscription?: Maybe<OrderSubscription>;
  /**
   * Submit the order for processing.
   *
   * This will create a new order and return the order id.
   *
   * Errors:
   *   failedToCalculateTaxes
   *   userWithoutAccount
   *   guestCartContainsSubscription
   */
  submitOrder?: Maybe<SubmittedOrder>;
  submitSubscriptionChanges?: Maybe<OrderSubscription>;
  updateCreditCardDefault: CreditCard;
  updateOrderSubscription?: Maybe<OrderSubscription>;
  updateOrderSubscriptionAddress?: Maybe<OrderSubscription>;
  updateOrderSubscriptionItem?: Maybe<OrderSubscription>;
  updateOrderSubscriptionPayment?: Maybe<OrderSubscription>;
  updateOrderSubscriptionStatus?: Maybe<OrderSubscription>;
  updateUserAddress: Address;
  updateUserAddressIsDefault: Address;
  /**
   * Updates user's first name and last name.
   *
   * Mutation
   * ```
   * mutation UpdateUserFirstLastName($input: UpdateUserFirstLastNameInput!) {
   *   updateUserFirstLastName(input: $input) {
   *     id
   *     first_name
   *     last_name
   *   }
   * }
   * ```
   *
   * Variables
   * ```
   * {
   *   "input": {
   *     "id": "UUID4",
   *     "first_name": "New"
   *     "last_name": "Updated"
   *   }
   * }
   * ```
   */
  updateUserFirstLastName?: Maybe<User>;
  updateUserPreferences: User;
  /**
   * mutation UserAddressVerification {
   *     userAddressVerification(
   *       input: {
   *         first_name: "",
   *         last_name: "",
   *         company: "",
   *         country_code: "",
   *         city: "",
   *         state: "",
   *         zip: "",
   *         line1: "",
   *         line2: ""
   *       }
   *     )
   *     {
   *       first_name,
   *       last_name,
   *       company,
   *       country_code,
   *       city,
   *       state,
   *       zip,
   *       line1,
   *       line2,
   *       success,
   *       errors{
   *         code,
   *         field,
   *         message,
   *         suggestion
   *       }
   *     }
   *   }
   */
  userAddressVerification?: Maybe<VerifyAddressPayload>;
  /**
   * Validate the session if it's in the stage :payment and check if payment was successfull.
   * If so, just return same session.
   * If payment was failed -> rollback and order and move session back to stage :checkout.
   * FE must anylize stage and if it's a :payment -> call finalizeSession mutation
   */
  validateSession?: Maybe<CheckoutSession>;
  /**
   * Used to verify the address that has been stored for the checkout session
   *
   *   Errors:
   *     incompleteShippingAddress
   *     addressVerification
   *     checkoutAddressVerificationError
   *     unableToUsePOBox
   *     unableToSaveVerificationOnShippingAddress
   */
  verifyAddress?: Maybe<CheckoutSession>;
  /**
   * mutation AddressVerification {
   *     verifyAddressForOrder(
   *       orderId: "",
   *       input: {
   *         first_name: "",
   *         last_name: "",
   *         company: "",
   *         country_code: "",
   *         city: "",
   *         state: "",
   *         zip: "",
   *         special_instructions: "",
   *         line1: "",
   *         line2: ""
   *       }
   *     )
   *     {
   *       first_name,
   *       last_name,
   *       company,
   *       country_code,
   *       city,
   *       state,
   *       zip,
   *       line1,
   *       line2,
   *       special_instructions,
   *       success,
   *       errors{
   *         code,
   *         field,
   *         message,
   *         suggestion
   *       }
   *     }
   *   }
   */
  verifyAddressForOrder?: Maybe<VerifyAddressPayload>;
  verifyUser?: Maybe<User>;
};


export type RootMutationTypeAddGiftCardArgs = {
  id: Scalars['UUID4'];
  input: GiftCardInput;
};


export type RootMutationTypeAddOrderSubscriptionItemArgs = {
  id: Scalars['UUID4'];
  input: AddOrderSubscriptionItemInput;
};


export type RootMutationTypeApplyDiscountArgs = {
  id: Scalars['UUID4'];
  input: DiscountInput;
};


export type RootMutationTypeApplySavedShippingAddressArgs = {
  additionalPhoneNumber?: InputMaybe<Scalars['String']>;
  addressId: Scalars['UUID4'];
  id: Scalars['UUID4'];
};


export type RootMutationTypeArchiveRegistrationRecordArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeChangeUserPasswordArgs = {
  input: ChangeUserPasswordInput;
};


export type RootMutationTypeCreateAccountAndRegistrationRecordArgs = {
  registrationRecordInput: CreateRegistrationRecordInput;
  userInput: SignupUserInput;
};


export type RootMutationTypeCreatePaymentMethodArgs = {
  input: CreatePaymentMethodInput;
};


export type RootMutationTypeCreateRegistrationRecordArgs = {
  input: CreateRegistrationRecordInput;
};


export type RootMutationTypeCreateTempSubscriptionArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeCreateTemporaryCartFromOrderArgs = {
  orderId: Scalars['UUID4'];
};


export type RootMutationTypeCreateUserAddressArgs = {
  input: UserAddressInput;
};


export type RootMutationTypeDeleteCreditCardArgs = {
  input: DeleteCreditCardInput;
};


export type RootMutationTypeDeleteUserAddressArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeExtendDueDateArgs = {
  input: ExtendDueDateInput;
};


export type RootMutationTypeFinalizePriceArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeFinalizeSessionArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeLoginUserArgs = {
  input: LoginUserInput;
};


export type RootMutationTypeMergeCartsArgs = {
  destCartId: Scalars['UUID4'];
  srcCartId: Scalars['UUID4'];
};


export type RootMutationTypePersistTemporaryCartArgs = {
  srcCartId: Scalars['UUID4'];
};


export type RootMutationTypeProcessOrderSubscriptionTomorrowArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeProcessSubscriptionNowArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeRecoverCartArgs = {
  emailHash: Scalars['String'];
};


export type RootMutationTypeRemoveDiscountArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeRemoveGiftCardArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeRemoveGiftInfoArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeRemoveOrderSubscriptionItemArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeRequestPasswordResetForUserArgs = {
  input: RequestPasswordResetForUserInput;
};


export type RootMutationTypeRequestUserVerificationArgs = {
  input: RequestUserVerificationInput;
};


export type RootMutationTypeResetUserPasswordArgs = {
  input: ResetUserPasswordInput;
};


export type RootMutationTypeSaveEnteredContactInfoArgs = {
  id: Scalars['UUID4'];
  input: SaveEnteredContactInfoInput;
};


export type RootMutationTypeSaveGiftInfoArgs = {
  id: Scalars['UUID4'];
  input: GiftInfoInput;
};


export type RootMutationTypeSavePaymentArgs = {
  id: Scalars['UUID4'];
  input: SavePaymentInput;
};


export type RootMutationTypeSavePaymentOptionsArgs = {
  id: Scalars['UUID4'];
  input: SavePaymentOptionsInput;
};


export type RootMutationTypeSaveShippingMethodArgs = {
  id: Scalars['UUID4'];
  input: SaveShippingMethodInput;
};


export type RootMutationTypeSaveShippingOptionsArgs = {
  id: Scalars['UUID4'];
  input: SaveShippingOptionsInput;
};


export type RootMutationTypeSaveSuggestedAddressArgs = {
  id: Scalars['UUID4'];
  input: SaveSuggestedAddressInput;
};


export type RootMutationTypeSetupTransactionArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeShopToCheckoutArgs = {
  cartId: Scalars['UUID4'];
};


export type RootMutationTypeSignupUserArgs = {
  input: SignupUserInput;
};


export type RootMutationTypeSkipOrderSubscriptionArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeSubmitOrderArgs = {
  id: Scalars['UUID4'];
  input: SubmitOrderInput;
};


export type RootMutationTypeSubmitSubscriptionChangesArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeUpdateCreditCardDefaultArgs = {
  input: UpdateCreditCardDefaultInput;
};


export type RootMutationTypeUpdateOrderSubscriptionArgs = {
  id: Scalars['UUID4'];
  input: UpdateOrderSubscriptionInput;
};


export type RootMutationTypeUpdateOrderSubscriptionAddressArgs = {
  id: Scalars['UUID4'];
  input: UpdateOrderSubscriptionAddressInput;
};


export type RootMutationTypeUpdateOrderSubscriptionItemArgs = {
  id: Scalars['UUID4'];
  input: UpdateOrderSubscriptionItemInput;
};


export type RootMutationTypeUpdateOrderSubscriptionPaymentArgs = {
  id: Scalars['UUID4'];
  input: UpdateOrderSubscriptionPaymentInput;
};


export type RootMutationTypeUpdateOrderSubscriptionStatusArgs = {
  id: Scalars['UUID4'];
  input: UpdateOrderSubscriptionStatusInput;
};


export type RootMutationTypeUpdateUserAddressArgs = {
  id: Scalars['UUID4'];
  input: UserAddressUpdateInput;
};


export type RootMutationTypeUpdateUserAddressIsDefaultArgs = {
  id: Scalars['UUID4'];
  input: UserAddressIsDefaultInput;
};


export type RootMutationTypeUpdateUserFirstLastNameArgs = {
  input: UpdateUserFirstLastNameInput;
};


export type RootMutationTypeUpdateUserPreferencesArgs = {
  input: UserPreferencesInput;
};


export type RootMutationTypeUserAddressVerificationArgs = {
  input: VerifyAddressInput;
};


export type RootMutationTypeValidateSessionArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeVerifyAddressArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeVerifyAddressForOrderArgs = {
  input: VerifyAddressInput;
  orderId: Scalars['String'];
};


export type RootMutationTypeVerifyUserArgs = {
  input: VerifyUserInput;
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /**
   * Gets the currently active account
   * Example:
   *   ```
   *   query {
   *     activeAccount {
   *       type
   *       credits {
   *         status
   *         type
   *         availableAmount
   *         spentAmount
   *         activeFrom
   *         activeUntil
   *       }
   *     }
   *   }
   *   ```
   */
  activeAccount?: Maybe<Account>;
  advancedItemSearch?: Maybe<Array<Maybe<AdvancedItemSearchResult>>>;
  /** Retrieve Checkout Session */
  checkoutSession?: Maybe<CheckoutSession>;
  /**
   * Gets the currently logged in user
   * Example:
   *   ```
   *   query {
   *     currentUser {
   *       emailuser_types
   *       firstName
   *       lastName
   *       creditCards {
   *         cardholderName
   *         billingAddress{
   *           firstName
   *           lastName
   *         }
   *       }
   *       addresses{
   *         line1
   *         line2
   *       }
   *     }
   *   }
   *   ```
   */
  currentUser?: Maybe<User>;
  /**
   * Get address suggestions for easy user input
   * Example
   * ```
   * query FindAddress($input: FindAddressInput!) {
   *   findAddress(input: $input) {
   *     items {
   *       id
   *       value
   *       description
   *       type
   *       highlight
   *     }
   *   }
   * }
   *
   * {"input": {"text": "3110 Pepsi road", "limit": "10"}}
   * ```
   */
  findAddress?: Maybe<FoundItems>;
  /**
   * Return a single gas exchange record filtered by id
   * Example:
   * ```
   * query GasExchangeRecord($id: UUID4!) {
   *   gas_exchange_record(id: $id) {
   *     id
   *   }
   * }
   * ```
   */
  gasExchangeRecord?: Maybe<GasExchangeRecord>;
  /**
   * Return a list of gas exchange records, paginated, for the current user
   * Example:
   * ```
   * query GasExchangeQueries {
   *   gasExchangeRecords(
   *     opts: {
   *     pagination: {
   *       page: 1
   *       limit: 10
   *     },
   *     search: {
   *         status: ACTIVE
   *     }
   *     }) {
   *     gasExchangeRecords {
   *       id
   *       status
   *     }
   *   }
   * }
   * ```
   */
  gasExchangeRecords: GasExchangeRecordPayload;
  isAddressValidForTax?: Maybe<IsAddressValidForTaxPayload>;
  localization?: Maybe<Localization>;
  /**
   * query getOrderSubscriptionForUser($id: UUID4!) {
   *   orderSubscription(id: $id) {
   *     id
   *     title
   *     intervalInDays
   *     orderSubscriptionItems {
   *       currentItem {
   *         id
   *       }
   *     }
   *   }
   * }
   */
  orderSubscription: OrderSubscription;
  /**
   * query getAllOrderSubscriptionsForUser {
   *   orderSubscriptions {
   *     id
   *     title
   *     intervalInDays
   *     orderSubscriptionItems {
   *       currentItem {
   *         id
   *       }
   *     }
   *   }
   * }
   */
  orderSubscriptions: Array<OrderSubscription>;
  /**
   * Returns a list of items forbidden from being sold in the given zip code.
   * If a list of upcs is given, it will check only those items, otherwise will check all items in the store.
   * Example:
   *   ```
   *   query RestrictedItemsByZipCode {
   *     restrictedItemsByZipCode(
   *       zip: "94545",
   *       upcs: ["2141212", "2142145432"]) {
   *       restrictedItems {
   *         id
   *       }
   *     }
   *   }
   *   ```
   */
  restrictedItemsByZipCode?: Maybe<RestrictedItemsByZipCodePayload>;
  /**
   * Retrieve an address with an id.
   *
   * Example
   * ```
   * query RetrieveAddress($id: String!) {
   *   retrieveAddress(id: $id) {
   *     items {
   *       id
   *       line1
   *       line2
   *       city
   *       state
   *       zip
   *       country
   *       subBuilding
   *     }
   *   }
   * }
   *
   * {"id": "id_12345678"}
   * ```
   */
  retrieveAddress?: Maybe<RetrievedItems>;
  /**
   * Return a single submitted order filtered by id
   * Example:
   *   ```
   *   query SubmittedOrderQueries {
   *     submitted_order(order_id: order_uuid) {
   *       id
   *     }
   *   }
   *   ```
   */
  submittedOrder?: Maybe<SubmittedOrder>;
  submittedOrders?: Maybe<SubmittedOrderPayload>;
  /**
   * Return the `Tenant` associated with the domain of the site making the request
   * Example:
   *   ```
   *     query {
   *       tenant {
   *         id
   *         domain
   *         fallbackUrl
   *       }
   *     }
   *   ```
   */
  tenant?: Maybe<Tenant>;
  /**
   * Validates if the given password meets the minimum complexity requirements.
   *
   * Example:
   *   ```
   *   query validatePassword($password: String!) {
   *     validatePassword(password: $password) {
   *       msg
   *       satisfied
   *     }
   *   }
   *   ```
   *   Variables:
   *
   *   ```
   *   {"password": "$123ASDsarasa"}
   *   ```
   */
  validatePassword: Array<PasswordRequirement>;
};


export type RootQueryTypeAdvancedItemSearchArgs = {
  term: Scalars['String'];
};


export type RootQueryTypeCheckoutSessionArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeFindAddressArgs = {
  input: FindAddressInput;
};


export type RootQueryTypeGasExchangeRecordArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeGasExchangeRecordsArgs = {
  opts?: InputMaybe<OptsInput>;
};


export type RootQueryTypeIsAddressValidForTaxArgs = {
  input: IsAddressValidForTaxInput;
};


export type RootQueryTypeOrderSubscriptionArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeRestrictedItemsByZipCodeArgs = {
  upcs?: InputMaybe<Array<Scalars['String']>>;
  zip: Scalars['String'];
};


export type RootQueryTypeRetrieveAddressArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeSubmittedOrderArgs = {
  orderId: Scalars['UUID4'];
};


export type RootQueryTypeSubmittedOrdersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeValidatePasswordArgs = {
  password: Scalars['String'];
};

export type SapLink = {
  __typename?: 'SapLink';
  activeCustomerIds?: Maybe<Array<Scalars['String']>>;
  customerIds?: Maybe<Array<Scalars['String']>>;
  primaryCustomerId?: Maybe<Scalars['String']>;
  propertyId?: Maybe<Scalars['String']>;
};

export type SaveEnteredContactInfoInput = {
  email?: InputMaybe<Scalars['String']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  /** please include all shipping inputed fields becauses the shipping update is an overwrite */
  shipping?: InputMaybe<SaveEnteredContactInfoShippingAddressInput>;
};

export type SaveEnteredContactInfoShippingAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  isAddressValidated?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  /** pseudonym for address */
  nickname?: InputMaybe<Scalars['String']>;
  /** notes left for the shipper to be able to properly deliver the package */
  specialInstructions?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** Uses custom oneOf directive.  Input is one of the following fields. */
export type SavePaymentInput = {
  allocatedCredit?: InputMaybe<AllocatedCreditInput>;
  applePay?: InputMaybe<ApplePayInput>;
  creditCard?: InputMaybe<CreditCardInput>;
  invoice?: InputMaybe<InvoiceInput>;
  paypal?: InputMaybe<PaypalInput>;
  savedCreditCard?: InputMaybe<SavedCreditCardInput>;
  stripe?: InputMaybe<StripeInput>;
};

export type SavePaymentOptionsInput = {
  /** Field size should not exceed 25 characters */
  customerPo?: InputMaybe<Scalars['String']>;
};

export type SaveShippingMethodInput = {
  code: Scalars['String'];
  shippingMethodId: Scalars['UUID4'];
  title: Scalars['String'];
};

export type SaveShippingOptionsInput = {
  requestedDeliveryDate?: InputMaybe<Scalars['Date']>;
};

/** Input for mutation to update the shipping address on the checkout session.  Address fields required for an address are all required */
export type SaveSuggestedAddressInput = {
  city: Scalars['String'];
  countryCode: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

/** Input for mutation to save credit card payment information */
export type SavedCreditCardInput = {
  billingAddress: BillingAddressInput;
  token: Scalars['String'];
};

/**
 * An address available for selection as a shipping address.
 *
 * This should be all available shipping addresses for a user
 * or account.
 */
export type SavedShippingAddress = {
  __typename?: 'SavedShippingAddress';
  /** this is the id found in the struct apiV1.Addresses.Address */
  addressId: Scalars['UUID4'];
  city: Scalars['String'];
  countryCode: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  isDefault: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['String']>;
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  specialInstructions?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  validated: Scalars['Boolean'];
  zip: Scalars['String'];
};

export type SearchInput = {
  status?: InputMaybe<GasExchangeRecordsStatus>;
};

/**
 * The stage of the session.
 *
 * * `:checkout`
 *   - The session is in the checkout stage. The user is
 *     currently filling out the checkout form and has not
 *     yet reached the review stage.
 * * `:review`
 *   - The session is in the review stage. The user has
 *     completely filled out the checkout form and is currently
 *     reviewing their order before submitting it.
 * * `:submission`
 *   - The session is in the submission stage. The user
 *     has submitted their checkout session which will
 *     be used to create a submitted order. It will soon
 *     move to completed or be reverted to review
 * * `:payment`
 *   - The session is in the payment stage. The user
 *     has submitted order, we already create draft submitted order and
 *     want to process payment on client. Depending on results we'll finalize
 *     process and will go to completed stage or we'll need to restart
 *     checkout process. Session is still alive and accessible.
 * * `:completed`
 *   - The session is completed. It will shortly be archived.
 */
export enum SessionStage {
  Checkout = 'CHECKOUT',
  Completed = 'COMPLETED',
  Payment = 'PAYMENT',
  Review = 'REVIEW',
  Submission = 'SUBMISSION'
}

export type SetupIntent = {
  __typename?: 'SetupIntent';
  clientSecret: Scalars['String'];
};

/** Shipping address used during checkout, fields do not get saved all at once */
export type ShippingAddress = {
  __typename?: 'ShippingAddress';
  addressId?: Maybe<Scalars['UUID4']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  isAddressValidated?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  specialInstructions?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type ShippingConfig = {
  __typename?: 'ShippingConfig';
  fixedFeeShipping?: Maybe<Scalars['Int']>;
  freeShippingThreshold?: Maybe<Scalars['Int']>;
  maxDeliveryWindowInDays?: Maybe<Scalars['Int']>;
};

/**
 * Selectable shipping methods representing static and dynamically
 *   fetched shipping locations for the previously input shipping address
 */
export type ShippingMethod = {
  __typename?: 'ShippingMethod';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID4']>;
  locationDescription?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Int']>;
  rateType?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** Configuration values for available shipping methods */
export type ShippingMethodConfig = {
  __typename?: 'ShippingMethodConfig';
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  name: Scalars['String'];
  rate: Scalars['Int'];
  rateType: Scalars['String'];
};

export type ShoppingBagConfig = {
  __typename?: 'ShoppingBagConfig';
  availableSubscriptionIntervalsInDays: Array<Scalars['Int']>;
  editSubscriptionsEnabled: Scalars['Boolean'];
  maxAmountForSelect: Scalars['Int'];
  minimumPurchaseAmount: Scalars['Int'];
  minimumPurchaseQty: Scalars['Int'];
  orderSubscriptionsEnabled: Scalars['Boolean'];
  subscriptionIntervalsInDays: Array<Scalars['Int']>;
};

export enum SignupChannelType {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export type SignupUserInput = {
  activationCode?: InputMaybe<Scalars['String']>;
  activationCodeRequired?: InputMaybe<Scalars['Boolean']>;
  botProtectionToken?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<SignupChannelType>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  email: Scalars['String'];
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  /** this field will contain fields specific for engagement implementations */
  engagementCustomData?: InputMaybe<Scalars['Json']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  preferredLocale?: InputMaybe<Scalars['String']>;
  preferredTimezone?: InputMaybe<Scalars['String']>;
};

export type StatesConfig = {
  __typename?: 'StatesConfig';
  countryId: Scalars['String'];
  statesAllowed: Array<AllowedState>;
};

export enum StatusLabels {
  /** Canceled */
  Canceled = 'CANCELED',
  /** Complete */
  Complete = 'COMPLETE',
  /** NoChange */
  NoChange = 'NO_CHANGE',
  /** Unknown */
  Unknown = 'UNKNOWN'
}

export enum StatusType {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

/**
 * Input for saving stripe payment info.
 * This info is save into Session.Payment object. Here is some explanation for what those tokens are:
 * session.payment.token - payment_intent_client_secret used to initiate paymentForm with valid elements(blik/p24/card).
 *                         generated on BE and saved to the session during the call setupTransaction mutation.
 * session.payment.client_confirmation_token - confirmation token generated on FE, it sticks to concrete user’s data
 *                                             on stripe and saved using savePayment mutation.
 * so, both these tokens/secrets are in session.payment object and we can use them on the review step to
 * call stripe.confirmPayment and be sure that we process most recent PaymentIntent with a data that belongs
 * to the user through the ConfirmationToken object.
 * More details: https://docs.stripe.com/js/payment_intents/confirm_payment
 */
export type StripeInput = {
  clientConfirmationToken?: InputMaybe<Scalars['String']>;
  isBillingEqualShipping: Scalars['Boolean'];
  paymentMethodType: Scalars['String'];
  saveCardForLater?: InputMaybe<Scalars['Boolean']>;
};

export type SubmitOrderInput = {
  paymentNonce?: InputMaybe<Scalars['String']>;
  preferredTimezone?: InputMaybe<Scalars['String']>;
};

/** Retrieve Submitted Order */
export type SubmittedOrder = {
  __typename?: 'SubmittedOrder';
  appId?: Maybe<Scalars['UUID4']>;
  bazaarvoice?: Maybe<Bazaarvoice>;
  cartId?: Maybe<Scalars['UUID4']>;
  /**
   * @deprecated The display_name field now represents the user visible order identifier/label
   * which is either explicitly set in the record or computed via the composite
   * order id logic. This obviates the need for the composite_id field.
   *
   */
  compositeId?: Maybe<Scalars['String']>;
  contactInfo: ContactInfo;
  currencyCode?: Maybe<Scalars['String']>;
  /** User's own internal id for the order */
  customerPo?: Maybe<Scalars['String']>;
  /**
   * The display name represents the user visible order label which identifies
   * the order to an end-user. This is either explicitly set in the
   * display_name_override column on the order or is computed as a composite of
   * the purchase order id (if any) and the internal order id.
   */
  displayName?: Maybe<Scalars['String']>;
  fulfillments: Array<Fulfillment>;
  gifteeEmail?: Maybe<Scalars['String']>;
  gifteeMessage?: Maybe<Scalars['String']>;
  giftorName?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  /**
   * Some orders are managed or "owned" by a different system. These orders are
   * sometimes imported into this system for tracking and reporting purposes but
   * don't have active workflows or fulfillment processes hooked up. This allows
   * these orders to be displayed with special notices in the UI.
   */
  isExternalOrder?: Maybe<Scalars['Boolean']>;
  isGift?: Maybe<Scalars['Boolean']>;
  lockerCode?: Maybe<Scalars['String']>;
  lockerTitle?: Maybe<Scalars['String']>;
  orderId: Scalars['UUID4'];
  orderSubscriptionRelationship: OrderSubscriptionRelationshipNames;
  orderType?: Maybe<SubmittedOrderType>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentRequest?: Maybe<PaymentRequest>;
  price: Price;
  requestedDeliveryDate?: Maybe<Scalars['String']>;
  shippingMethodConfig?: Maybe<ShippingMethodConfig>;
  shippingMethodPhone?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  submissionUid: Scalars['UUID4'];
  submittedAt?: Maybe<Scalars['DateTime']>;
  taxId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID4']>;
};

export type SubmittedOrderPayload = {
  __typename?: 'SubmittedOrderPayload';
  pagination: PaginationData;
  submittedOrders: Array<SubmittedOrder>;
};

export enum SubmittedOrderType {
  External = 'EXTERNAL',
  FreeOfCharge = 'FREE_OF_CHARGE',
  Internal = 'INTERNAL',
  MissingGasExchangeCylinder = 'MISSING_GAS_EXCHANGE_CYLINDER',
  Shop = 'SHOP',
  Subscription = 'SUBSCRIPTION'
}

/** Subscription metadata on an item */
export type SubscriptionMetadata = {
  __typename?: 'SubscriptionMetadata';
  discountAmount?: Maybe<Scalars['Int']>;
  discountType?: Maybe<DiscountType>;
  subscriptionIntervalInDays?: Maybe<Scalars['Int']>;
  subscriptionPrice?: Maybe<Scalars['Int']>;
};

export enum SubscriptionOption {
  Allowed = 'ALLOWED',
  None = 'NONE',
  Only = 'ONLY'
}

export type TaxItem = {
  __typename?: 'TaxItem';
  amount?: Maybe<Scalars['Int']>;
  calculatedTax?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  exempt?: Maybe<Scalars['Int']>;
  impositionTypeId?: Maybe<Scalars['Int']>;
  impositionValue?: Maybe<Scalars['String']>;
  jurisdiction?: Maybe<Scalars['String']>;
  jurisdictionType?: Maybe<Scalars['String']>;
  taxRuleId?: Maybe<Scalars['String']>;
  unclaimedTaxes?: Maybe<Scalars['Int']>;
};

export type Tenant = {
  __typename?: 'Tenant';
  analyticsConfig: AnalyticsConfig;
  /** @deprecated Deprecated in favor of `id`. */
  appId: Scalars['UUID4'];
  botProtection: BotProtection;
  brandConfig: BrandConfig;
  capabilities: Capabilities;
  checkout?: Maybe<Checkout>;
  contactConfig: ContactConfig;
  countryCode: Scalars['String'];
  domain: Scalars['String'];
  /** @deprecated Deprecated in favor of `store_url`. */
  fallbackUrl: Scalars['String'];
  giftCardConfig: GiftCardConfig;
  giftConfig: GiftConfig;
  id: Scalars['UUID4'];
  loyaltyConfig: LoyaltyConfig;
  paymentConfig: PaymentConfig;
  shippingConfig: ShippingConfig;
  shoppingBagConfig: ShoppingBagConfig;
  storeUrl: Scalars['String'];
  userExperience: UserExperience;
};

export type TenantPaymentOptions = {
  __typename?: 'TenantPaymentOptions';
  defaultCurrencyCode: Scalars['String'];
  merchantAccountId?: Maybe<Scalars['String']>;
};

export type TenantShippingOptions = {
  __typename?: 'TenantShippingOptions';
  shippingMethodsEnabled?: Maybe<Scalars['Boolean']>;
};

export type Tier = {
  __typename?: 'Tier';
  amount: Scalars['Int'];
  minQty: Scalars['Int'];
  type: TierType;
};

export enum TierType {
  /** The tier discounts a flat amount */
  Flat = 'FLAT',
  /** the tier dicounts a percentage amount */
  Percent = 'PERCENT'
}

export type TieredAttributes = {
  __typename?: 'TieredAttributes';
  tiers: Array<Tier>;
};

export type TieredBehaviour = {
  __typename?: 'TieredBehaviour';
  attributes: TieredAttributes;
  name: BehaviourEnum;
};

export type TrackingNumber = {
  __typename?: 'TrackingNumber';
  carrierName?: Maybe<Scalars['String']>;
  status?: Maybe<TrackingStatusLabels>;
  trackingNumber?: Maybe<Scalars['String']>;
  trackingServiceUpdatedAt?: Maybe<Scalars['NaiveDateTime']>;
  trackingUrl?: Maybe<Scalars['String']>;
};

export enum TrackingStatusLabels {
  /** AVAILABLE_FOR_PICKUP */
  AvailableForPickup = 'AVAILABLE_FOR_PICKUP',
  /** CANCELLED */
  Cancelled = 'CANCELLED',
  /** COMPLETE */
  Complete = 'COMPLETE',
  /** DELIVERED */
  Delivered = 'DELIVERED',
  /** FAILURE */
  Failure = 'FAILURE',
  /** IN_TRANSIT */
  InTransit = 'IN_TRANSIT',
  /** OUT_FOR_DELIVERY */
  OutForDelivery = 'OUT_FOR_DELIVERY',
  /** PRE_TRANSIT */
  PreTransit = 'PRE_TRANSIT',
  /** RETURNED */
  Returned = 'RETURNED',
  /** RETURN_TO_SENDER */
  ReturnToSender = 'RETURN_TO_SENDER',
  /** TRANSIT */
  Transit = 'TRANSIT',
  /** UNKNOWN */
  Unknown = 'UNKNOWN'
}

export type UpdateCreditCardDefaultInput = {
  default: Scalars['Boolean'];
  token: Scalars['String'];
};

export type UpdateOrderSubscriptionAddressInput = {
  addressId: Scalars['UUID4'];
};

export type UpdateOrderSubscriptionInput = {
  intervalInDays?: InputMaybe<Scalars['Int']>;
  nextOrderCreationDate?: InputMaybe<Scalars['Date']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateOrderSubscriptionItemInput = {
  quantity?: InputMaybe<Scalars['Int']>;
};

export type UpdateOrderSubscriptionPaymentInput = {
  paymentOptions?: InputMaybe<PaymentOptionsInput>;
};

export type UpdateOrderSubscriptionStatusInput = {
  status: OrderSubscriptionStatusNames;
  /** This field is required if status is PAUSED or CANCELED */
  statusReason?: InputMaybe<Scalars['String']>;
};

/** Inputs for updating user's first and last name. */
export type UpdateUserFirstLastNameInput = {
  firstName: Scalars['String'];
  id: Scalars['UUID4'];
  lastName: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  addresses: Array<Address>;
  appId: Scalars['UUID4'];
  cart?: Maybe<Cart>;
  dateOfBirth?: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  hashedEmail: Scalars['String'];
  hfName?: Maybe<Scalars['String']>;
  hlName?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  insertedAt: Scalars['DateTime'];
  isVerified: Scalars['Boolean'];
  lastLoggedIn?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  paymentMethods?: Maybe<PaymentMethods>;
  preferredLocale?: Maybe<Scalars['String']>;
  preferredTimezone?: Maybe<Scalars['String']>;
  registrationRecords: Array<RegistrationRecord>;
  tenant: Tenant;
  userString?: Maybe<Scalars['String']>;
};

export type UserAddressInput = {
  city: Scalars['String'];
  company?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type UserAddressIsDefaultInput = {
  isDefault: Scalars['Boolean'];
};

export type UserAddressUpdateInput = {
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UserExperience = {
  __typename?: 'UserExperience';
  hasRequestedDeliveryDate: Scalars['Boolean'];
};

export type UserPreferencesInput = {
  preferredLocale: Scalars['String'];
  preferredTimezone: Scalars['String'];
};

export type UtmData = {
  __typename?: 'UtmData';
  campaign?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  medium?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  term?: Maybe<Scalars['String']>;
};

export type UtmDataInput = {
  campaign?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  medium?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  term?: InputMaybe<Scalars['String']>;
};

export enum ValidationRequirement {
  Always = 'ALWAYS',
  Never = 'NEVER',
  Optional = 'OPTIONAL'
}

export type VerifyAddressInput = {
  city: Scalars['String'];
  company?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type VerifyAddressPayload = {
  __typename?: 'VerifyAddressPayload';
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  specialInstructions?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type VerifyUserInput = {
  token: Scalars['String'];
};

export type ZipCodeRestrictionLocalizations = {
  __typename?: 'ZipCodeRestrictionLocalizations';
  itemHeadingText: Scalars['String'];
  itemNoteText: Scalars['String'];
};

export type ActiveAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveAccountQuery = { __typename?: 'RootQueryType', activeAccount?: { __typename?: 'Account', type: string, name?: string | null | undefined, tags?: Array<string> | null | undefined, credits: Array<{ __typename?: 'Credit', status: string, type: string, availableAmount: number, spentAmount: number, activeFrom: any, activeUntil?: any | null | undefined }>, invoicing?: { __typename?: 'Invoicing', enabled?: boolean | null | undefined, addresses: Array<{ __typename?: 'InvoicedAddress', city: string, company?: string | null | undefined, countryCode: string, firstName?: string | null | undefined, id: any, lastName?: string | null | undefined, line1: string, line2?: string | null | undefined, state?: string | null | undefined, zip: string, phoneNumber: string }> } | null | undefined } | null | undefined };

export type AddGiftCardMutationVariables = Exact<{
  id: Scalars['UUID4'];
  input: GiftCardInput;
}>;


export type AddGiftCardMutation = { __typename?: 'RootMutationType', addGiftCard?: { __typename?: 'CheckoutSession', id: any, hasGasExchangeItems: boolean, stage: SessionStage, customerPo?: string | null | undefined, orderId?: string | null | undefined, requestedDeliveryDate?: string | null | undefined, submissionUid: any, activeAccount?: { __typename?: 'ActiveAccount', id: any, managedAddressesOnly?: boolean | null | undefined, name: string, type: string, isInvoiced?: boolean | null | undefined } | null | undefined, cart?: { __typename?: 'Cart', appId: any, id: any, items?: Array<{ __typename?: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, dynamicBundle: { __typename?: 'DynamicBundle', tag: string }, dynamicBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined, primaryBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, analyticsDetails?: any | null | undefined, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined } | { __typename?: 'CartItem', analyticsDetails?: any | null | undefined, id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, item: { __typename?: 'Item', brandName?: string | null | undefined, compareAtPrice: number, id: any, gtin: string, imgUrl?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, price?: number | null | undefined, slug?: string | null | undefined, title?: string | null | undefined, subItems?: Array<{ __typename?: 'BundleItem', imgUrl?: string | null | undefined, title?: string | null | undefined } | null | undefined> | null | undefined } } | null | undefined> | null | undefined, user?: { __typename?: 'User', id: any } | null | undefined } | null | undefined, contactInfo?: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'ShippingAddress', addressId?: any | null | undefined, city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, isAddressValidated?: boolean | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, taxId?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, giftInfo?: { __typename?: 'GiftInfo', gifteeEmail?: string | null | undefined, gifteeMessage?: string | null | undefined, giftorName?: string | null | undefined } | null | undefined, payment?: { __typename?: 'Payment', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: AllowedPaymentMethod | null | undefined, token?: string | null | undefined, clientConfirmationToken?: string | null | undefined, paymentStatus?: string | null | undefined, lastErrorCode?: string | null | undefined, billingAddress?: { __typename?: 'BillingAddress', city: string, state?: string | null | undefined, countryCode: string, zip: string, firstName: string, lastName: string, line1: string, line2?: string | null | undefined } | null | undefined } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, price: { __typename?: 'Price', discount: number, shipping: number, subtotal: number, taxRegulatoryTotal: number, taxSalesTotal: number, total: number, lineItems: Array<{ __typename: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, bundleComponents: Array<{ __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined } } | null | undefined> | null | undefined } | null | undefined>, primaryComponent: { __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', gtin: string, title?: string | null | undefined } } | null | undefined> | null | undefined } } | { __typename: 'LineItem', gtin: string, imgUrl?: string | null | undefined, itemId: any, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, title: string, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, subscription?: { __typename?: 'SubscriptionMetadata', discountAmount?: number | null | undefined, discountType?: DiscountType | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subscriptionPrice?: number | null | undefined } | null | undefined }>, loyaltyData?: { __typename?: 'LoyaltyData', totalAmount: number, totalEarnedPoints: number, totalPoints: number } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, promoCodeDiscounts: Array<{ __typename?: 'PromoCodeDiscount', promoCode: string, type: DiscountType, amount: number, discountAmount: number, discountId: any }>, regulatoryTaxTypes: Array<{ __typename?: 'RegulatoryTaxType', code: string, id: string, total: number }> }, shippingAddresses: Array<{ __typename?: 'SavedShippingAddress', addressId: any, city: string, countryCode: string, firstName?: string | null | undefined, isDefault: boolean, lastName?: string | null | undefined, line1: string, line2?: string | null | undefined, nickname?: string | null | undefined, phoneNumber?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated: boolean, zip: string }>, shippingMethodConfig?: { __typename?: 'ShippingMethodConfig', description?: string | null | undefined, id: any, name: string, rate: number } | null | undefined, user?: { __typename?: 'User', email: string, firstName?: string | null | undefined, id: any, lastName?: string | null | undefined } | null | undefined } | null | undefined };

export type AddressFragment = { __typename?: 'Address', city: string, company?: string | null | undefined, countryCode: string, firstName: string, id: any, lastName: string, line1: string, line2?: string | null | undefined, phoneNumber?: string | null | undefined, state?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, zip: string, isDefault?: boolean | null | undefined, isRemovable?: boolean | null | undefined };

export type AllocationFragment = { __typename?: 'Credit', status: string, type: string, availableAmount: number, spentAmount: number, activeFrom: any, activeUntil?: any | null | undefined };

export type ApplePayCardFragment = { __typename?: 'ApplePayCard', customerId: string, createdAt: string, default: boolean, token: string, cardType: string, cardholderName: string, last4: string, billingAddress?: { __typename?: 'BraintreeAddress', company?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, streetAddress?: string | null | undefined, extendedAddress?: string | null | undefined, locality?: string | null | undefined, region?: string | null | undefined, postalCode?: string | null | undefined, countryCodeAlpha2?: string | null | undefined } | null | undefined };

export type ApplyDiscountMutationVariables = Exact<{
  id: Scalars['UUID4'];
  input: DiscountInput;
}>;


export type ApplyDiscountMutation = { __typename?: 'RootMutationType', applyDiscount?: { __typename?: 'CheckoutSession', id: any, hasGasExchangeItems: boolean, stage: SessionStage, customerPo?: string | null | undefined, orderId?: string | null | undefined, requestedDeliveryDate?: string | null | undefined, submissionUid: any, activeAccount?: { __typename?: 'ActiveAccount', id: any, managedAddressesOnly?: boolean | null | undefined, name: string, type: string, isInvoiced?: boolean | null | undefined } | null | undefined, cart?: { __typename?: 'Cart', appId: any, id: any, items?: Array<{ __typename?: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, dynamicBundle: { __typename?: 'DynamicBundle', tag: string }, dynamicBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined, primaryBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, analyticsDetails?: any | null | undefined, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined } | { __typename?: 'CartItem', analyticsDetails?: any | null | undefined, id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, item: { __typename?: 'Item', brandName?: string | null | undefined, compareAtPrice: number, id: any, gtin: string, imgUrl?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, price?: number | null | undefined, slug?: string | null | undefined, title?: string | null | undefined, subItems?: Array<{ __typename?: 'BundleItem', imgUrl?: string | null | undefined, title?: string | null | undefined } | null | undefined> | null | undefined } } | null | undefined> | null | undefined, user?: { __typename?: 'User', id: any } | null | undefined } | null | undefined, contactInfo?: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'ShippingAddress', addressId?: any | null | undefined, city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, isAddressValidated?: boolean | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, taxId?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, giftInfo?: { __typename?: 'GiftInfo', gifteeEmail?: string | null | undefined, gifteeMessage?: string | null | undefined, giftorName?: string | null | undefined } | null | undefined, payment?: { __typename?: 'Payment', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: AllowedPaymentMethod | null | undefined, token?: string | null | undefined, clientConfirmationToken?: string | null | undefined, paymentStatus?: string | null | undefined, lastErrorCode?: string | null | undefined, billingAddress?: { __typename?: 'BillingAddress', city: string, state?: string | null | undefined, countryCode: string, zip: string, firstName: string, lastName: string, line1: string, line2?: string | null | undefined } | null | undefined } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, price: { __typename?: 'Price', discount: number, shipping: number, subtotal: number, taxRegulatoryTotal: number, taxSalesTotal: number, total: number, lineItems: Array<{ __typename: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, bundleComponents: Array<{ __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined } } | null | undefined> | null | undefined } | null | undefined>, primaryComponent: { __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', gtin: string, title?: string | null | undefined } } | null | undefined> | null | undefined } } | { __typename: 'LineItem', gtin: string, imgUrl?: string | null | undefined, itemId: any, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, title: string, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, subscription?: { __typename?: 'SubscriptionMetadata', discountAmount?: number | null | undefined, discountType?: DiscountType | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subscriptionPrice?: number | null | undefined } | null | undefined }>, loyaltyData?: { __typename?: 'LoyaltyData', totalAmount: number, totalEarnedPoints: number, totalPoints: number } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, promoCodeDiscounts: Array<{ __typename?: 'PromoCodeDiscount', promoCode: string, type: DiscountType, amount: number, discountAmount: number, discountId: any }>, regulatoryTaxTypes: Array<{ __typename?: 'RegulatoryTaxType', code: string, id: string, total: number }> }, shippingAddresses: Array<{ __typename?: 'SavedShippingAddress', addressId: any, city: string, countryCode: string, firstName?: string | null | undefined, isDefault: boolean, lastName?: string | null | undefined, line1: string, line2?: string | null | undefined, nickname?: string | null | undefined, phoneNumber?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated: boolean, zip: string }>, shippingMethodConfig?: { __typename?: 'ShippingMethodConfig', description?: string | null | undefined, id: any, name: string, rate: number } | null | undefined, user?: { __typename?: 'User', email: string, firstName?: string | null | undefined, id: any, lastName?: string | null | undefined } | null | undefined } | null | undefined };

export type ApplySavedShippingAddressMutationVariables = Exact<{
  additionalPhoneNumber?: InputMaybe<Scalars['String']>;
  addressId: Scalars['UUID4'];
  id: Scalars['UUID4'];
}>;


export type ApplySavedShippingAddressMutation = { __typename?: 'RootMutationType', applySavedShippingAddress?: { __typename?: 'CheckoutSession', id: any, hasGasExchangeItems: boolean, stage: SessionStage, customerPo?: string | null | undefined, orderId?: string | null | undefined, requestedDeliveryDate?: string | null | undefined, submissionUid: any, activeAccount?: { __typename?: 'ActiveAccount', id: any, managedAddressesOnly?: boolean | null | undefined, name: string, type: string, isInvoiced?: boolean | null | undefined } | null | undefined, cart?: { __typename?: 'Cart', appId: any, id: any, items?: Array<{ __typename?: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, dynamicBundle: { __typename?: 'DynamicBundle', tag: string }, dynamicBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined, primaryBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, analyticsDetails?: any | null | undefined, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined } | { __typename?: 'CartItem', analyticsDetails?: any | null | undefined, id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, item: { __typename?: 'Item', brandName?: string | null | undefined, compareAtPrice: number, id: any, gtin: string, imgUrl?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, price?: number | null | undefined, slug?: string | null | undefined, title?: string | null | undefined, subItems?: Array<{ __typename?: 'BundleItem', imgUrl?: string | null | undefined, title?: string | null | undefined } | null | undefined> | null | undefined } } | null | undefined> | null | undefined, user?: { __typename?: 'User', id: any } | null | undefined } | null | undefined, contactInfo?: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'ShippingAddress', addressId?: any | null | undefined, city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, isAddressValidated?: boolean | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, taxId?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, giftInfo?: { __typename?: 'GiftInfo', gifteeEmail?: string | null | undefined, gifteeMessage?: string | null | undefined, giftorName?: string | null | undefined } | null | undefined, payment?: { __typename?: 'Payment', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: AllowedPaymentMethod | null | undefined, token?: string | null | undefined, clientConfirmationToken?: string | null | undefined, paymentStatus?: string | null | undefined, lastErrorCode?: string | null | undefined, billingAddress?: { __typename?: 'BillingAddress', city: string, state?: string | null | undefined, countryCode: string, zip: string, firstName: string, lastName: string, line1: string, line2?: string | null | undefined } | null | undefined } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, price: { __typename?: 'Price', discount: number, shipping: number, subtotal: number, taxRegulatoryTotal: number, taxSalesTotal: number, total: number, lineItems: Array<{ __typename: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, bundleComponents: Array<{ __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined } } | null | undefined> | null | undefined } | null | undefined>, primaryComponent: { __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', gtin: string, title?: string | null | undefined } } | null | undefined> | null | undefined } } | { __typename: 'LineItem', gtin: string, imgUrl?: string | null | undefined, itemId: any, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, title: string, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, subscription?: { __typename?: 'SubscriptionMetadata', discountAmount?: number | null | undefined, discountType?: DiscountType | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subscriptionPrice?: number | null | undefined } | null | undefined }>, loyaltyData?: { __typename?: 'LoyaltyData', totalAmount: number, totalEarnedPoints: number, totalPoints: number } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, promoCodeDiscounts: Array<{ __typename?: 'PromoCodeDiscount', promoCode: string, type: DiscountType, amount: number, discountAmount: number, discountId: any }>, regulatoryTaxTypes: Array<{ __typename?: 'RegulatoryTaxType', code: string, id: string, total: number }> }, shippingAddresses: Array<{ __typename?: 'SavedShippingAddress', addressId: any, city: string, countryCode: string, firstName?: string | null | undefined, isDefault: boolean, lastName?: string | null | undefined, line1: string, line2?: string | null | undefined, nickname?: string | null | undefined, phoneNumber?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated: boolean, zip: string }>, shippingMethodConfig?: { __typename?: 'ShippingMethodConfig', description?: string | null | undefined, id: any, name: string, rate: number } | null | undefined, user?: { __typename?: 'User', email: string, firstName?: string | null | undefined, id: any, lastName?: string | null | undefined } | null | undefined } | null | undefined };

export type ArchiveRegistrationRecordMutationVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type ArchiveRegistrationRecordMutation = { __typename?: 'RootMutationType', archiveRegistrationRecord?: { __typename?: 'RegistrationRecord', id: any } | null | undefined };

export type AvailablePaymentMethodsFragment = { __typename?: 'AvailablePaymentMethods', allowedPaymentMethods: Array<AllowedPaymentMethod>, creditCard?: { __typename?: 'PaymentMethodCreditCard', savedCards: Array<{ __typename?: 'CreditCard', cardType: CreditCardType, cardholderName: string, isDefault: boolean, expirationMonth: number, expirationYear: number, lastFour: string, token: string, billingAddress: { __typename?: 'CreditCardBillingAddress', company?: string | null | undefined, countryCode: string, line2?: string | null | undefined, firstName: string, lastName: string, city: string, zip: string, state?: string | null | undefined, line1: string } }>, validCardTypes: Array<{ __typename?: 'CardType', brandImgUrl: string, id: number, name: string }> } | null | undefined, paypal?: { __typename?: 'PaymentMethodPaypal', savedAccounts: Array<{ __typename?: 'PaypalAccount', isDefault: boolean, email: string, token: string }> } | null | undefined, allocatedCredit?: { __typename?: 'Credit', availableAmount: number, id: any, type: string } | null | undefined };

export type AvailablePaymentMethodsQueryVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type AvailablePaymentMethodsQuery = { __typename?: 'RootQueryType', checkoutSession?: { __typename?: 'CheckoutSession', availablePaymentMethods: { __typename?: 'AvailablePaymentMethods', allowedPaymentMethods: Array<AllowedPaymentMethod>, creditCard?: { __typename?: 'PaymentMethodCreditCard', savedCards: Array<{ __typename?: 'CreditCard', cardType: CreditCardType, cardholderName: string, isDefault: boolean, expirationMonth: number, expirationYear: number, lastFour: string, token: string, billingAddress: { __typename?: 'CreditCardBillingAddress', company?: string | null | undefined, countryCode: string, line2?: string | null | undefined, firstName: string, lastName: string, city: string, zip: string, state?: string | null | undefined, line1: string } }>, validCardTypes: Array<{ __typename?: 'CardType', brandImgUrl: string, id: number, name: string }> } | null | undefined, paypal?: { __typename?: 'PaymentMethodPaypal', savedAccounts: Array<{ __typename?: 'PaypalAccount', isDefault: boolean, email: string, token: string }> } | null | undefined, allocatedCredit?: { __typename?: 'Credit', availableAmount: number, id: any, type: string } | null | undefined } } | null | undefined };

export type AvailableShippingMethodsQueryVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type AvailableShippingMethodsQuery = { __typename?: 'RootQueryType', checkoutSession?: { __typename?: 'CheckoutSession', availableShippingMethods?: Array<{ __typename?: 'ShippingMethod', locationDescription?: string | null | undefined, id?: any | null | undefined, title?: string | null | undefined, rate?: number | null | undefined, code?: string | null | undefined }> | null | undefined } | null | undefined };

export type ChangeUserPasswordMutationVariables = Exact<{
  input: ChangeUserPasswordInput;
}>;


export type ChangeUserPasswordMutation = { __typename?: 'RootMutationType', changeUserPassword?: { __typename?: 'User', id: any } | null | undefined };

export type CheckoutSessionFragment = { __typename?: 'CheckoutSession', id: any, hasGasExchangeItems: boolean, stage: SessionStage, customerPo?: string | null | undefined, orderId?: string | null | undefined, requestedDeliveryDate?: string | null | undefined, submissionUid: any, activeAccount?: { __typename?: 'ActiveAccount', id: any, managedAddressesOnly?: boolean | null | undefined, name: string, type: string, isInvoiced?: boolean | null | undefined } | null | undefined, cart?: { __typename?: 'Cart', appId: any, id: any, items?: Array<{ __typename?: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, dynamicBundle: { __typename?: 'DynamicBundle', tag: string }, dynamicBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined, primaryBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, analyticsDetails?: any | null | undefined, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined } | { __typename?: 'CartItem', analyticsDetails?: any | null | undefined, id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, item: { __typename?: 'Item', brandName?: string | null | undefined, compareAtPrice: number, id: any, gtin: string, imgUrl?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, price?: number | null | undefined, slug?: string | null | undefined, title?: string | null | undefined, subItems?: Array<{ __typename?: 'BundleItem', imgUrl?: string | null | undefined, title?: string | null | undefined } | null | undefined> | null | undefined } } | null | undefined> | null | undefined, user?: { __typename?: 'User', id: any } | null | undefined } | null | undefined, contactInfo?: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'ShippingAddress', addressId?: any | null | undefined, city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, isAddressValidated?: boolean | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, taxId?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, giftInfo?: { __typename?: 'GiftInfo', gifteeEmail?: string | null | undefined, gifteeMessage?: string | null | undefined, giftorName?: string | null | undefined } | null | undefined, payment?: { __typename?: 'Payment', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: AllowedPaymentMethod | null | undefined, token?: string | null | undefined, clientConfirmationToken?: string | null | undefined, paymentStatus?: string | null | undefined, lastErrorCode?: string | null | undefined, billingAddress?: { __typename?: 'BillingAddress', city: string, state?: string | null | undefined, countryCode: string, zip: string, firstName: string, lastName: string, line1: string, line2?: string | null | undefined } | null | undefined } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, price: { __typename?: 'Price', discount: number, shipping: number, subtotal: number, taxRegulatoryTotal: number, taxSalesTotal: number, total: number, lineItems: Array<{ __typename: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, bundleComponents: Array<{ __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined } } | null | undefined> | null | undefined } | null | undefined>, primaryComponent: { __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', gtin: string, title?: string | null | undefined } } | null | undefined> | null | undefined } } | { __typename: 'LineItem', gtin: string, imgUrl?: string | null | undefined, itemId: any, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, title: string, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, subscription?: { __typename?: 'SubscriptionMetadata', discountAmount?: number | null | undefined, discountType?: DiscountType | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subscriptionPrice?: number | null | undefined } | null | undefined }>, loyaltyData?: { __typename?: 'LoyaltyData', totalAmount: number, totalEarnedPoints: number, totalPoints: number } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, promoCodeDiscounts: Array<{ __typename?: 'PromoCodeDiscount', promoCode: string, type: DiscountType, amount: number, discountAmount: number, discountId: any }>, regulatoryTaxTypes: Array<{ __typename?: 'RegulatoryTaxType', code: string, id: string, total: number }> }, shippingAddresses: Array<{ __typename?: 'SavedShippingAddress', addressId: any, city: string, countryCode: string, firstName?: string | null | undefined, isDefault: boolean, lastName?: string | null | undefined, line1: string, line2?: string | null | undefined, nickname?: string | null | undefined, phoneNumber?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated: boolean, zip: string }>, shippingMethodConfig?: { __typename?: 'ShippingMethodConfig', description?: string | null | undefined, id: any, name: string, rate: number } | null | undefined, user?: { __typename?: 'User', email: string, firstName?: string | null | undefined, id: any, lastName?: string | null | undefined } | null | undefined };

export type CreateCartFromOrderMutationVariables = Exact<{
  orderId: Scalars['UUID4'];
}>;


export type CreateCartFromOrderMutation = { __typename?: 'RootMutationType', createTemporaryCartFromOrder?: { __typename?: 'Cart', id: any } | null | undefined };

export type CreatePaymentClientTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type CreatePaymentClientTokenMutation = { __typename?: 'RootMutationType', createPaymentClientToken: { __typename?: 'PaymentClientTokenPayload', token: string } };

export type CreatePaymentMethodMutationVariables = Exact<{
  input: CreatePaymentMethodInput;
}>;


export type CreatePaymentMethodMutation = { __typename?: 'RootMutationType', createPaymentMethod: { __typename: 'ApplePayCard' } | { __typename: 'CreditCard' } | { __typename: 'PaypalAccount' } };

export type CreateUserAddressMutationVariables = Exact<{
  input: UserAddressInput;
}>;


export type CreateUserAddressMutation = { __typename?: 'RootMutationType', createUserAddress: { __typename?: 'Address', id: any } };

export type CreditCardFragment = { __typename?: 'CreditCard', cardType: CreditCardType, cardholderName: string, expirationMonth: number, expirationYear: number, isDefault: boolean, isRemovable?: boolean | null | undefined, lastFour: string, token: string, billingAddress: { __typename?: 'CreditCardBillingAddress', company?: string | null | undefined, firstName: string, lastName: string, line1: string, line2?: string | null | undefined, city: string, state?: string | null | undefined, zip: string, countryCode: string } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', id: any, email: string, firstName?: string | null | undefined, lastName?: string | null | undefined, userString?: string | null | undefined, addresses: Array<{ __typename?: 'Address', city: string, company?: string | null | undefined, countryCode: string, firstName: string, id: any, lastName: string, line1: string, line2?: string | null | undefined, phoneNumber?: string | null | undefined, state?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, zip: string, isDefault?: boolean | null | undefined, isRemovable?: boolean | null | undefined }>, paymentMethods?: { __typename?: 'PaymentMethods', creditCards: Array<{ __typename?: 'CreditCard', cardType: CreditCardType, cardholderName: string, expirationMonth: number, expirationYear: number, isDefault: boolean, isRemovable?: boolean | null | undefined, lastFour: string, token: string, billingAddress: { __typename?: 'CreditCardBillingAddress', firstName: string, lastName: string, line1: string, line2?: string | null | undefined, city: string, state?: string | null | undefined, zip: string, countryCode: string } }>, paypalAccounts: Array<{ __typename?: 'PaypalAccount', isDefault: boolean, isRemovable?: boolean | null | undefined, email: string, token: string }> } | null | undefined } | null | undefined };

export type CurrentUserIdQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserIdQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', id: any } | null | undefined };

export type CurrentUserPaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserPaymentMethodsQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', id: any, paymentMethods?: { __typename?: 'PaymentMethods', creditCards: Array<{ __typename?: 'CreditCard', isDefault: boolean }>, paypalAccounts: Array<{ __typename?: 'PaypalAccount', isDefault: boolean }> } | null | undefined } | null | undefined };

export type CurrentUserRegistrationRecordsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserRegistrationRecordsQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', registrationRecords: Array<{ __typename?: 'RegistrationRecord', id: any, purchaseLocation: string, purchaseDate?: any | null | undefined, warrantyExpirationDate?: any | null | undefined, status: StatusType, item: { __typename?: 'Item', title?: string | null | undefined, imgUrl?: string | null | undefined, itemLinks?: Array<{ __typename?: 'ItemLink', type: ItemLinkType, url: string } | null | undefined> | null | undefined } }> } | null | undefined };

export type CurrentUserWithCartQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserWithCartQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', id: any, cart?: { __typename?: 'Cart', id: any } | null | undefined } | null | undefined };

type Customization_GatoradeIdBottle_Fragment = { __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined };

type Customization_GatoradeTowel_Fragment = { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined };

type Customization_LegacyCustomization_Fragment = { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined };

export type CustomizationFragment = Customization_GatoradeIdBottle_Fragment | Customization_GatoradeTowel_Fragment | Customization_LegacyCustomization_Fragment;

export type DeleteCreditCardMutationVariables = Exact<{
  input: DeleteCreditCardInput;
}>;


export type DeleteCreditCardMutation = { __typename?: 'RootMutationType', deleteCreditCard: string };

export type DeleteUserAddressMutationVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type DeleteUserAddressMutation = { __typename?: 'RootMutationType', deleteUserAddress: { __typename?: 'Address', id: any } };

export type DiscountFragment = { __typename?: 'Discount', id: any, activeFrom: any, activeUntil?: any | null | undefined, amount?: number | null | undefined, appId?: any | null | undefined, isPercent?: boolean | null | undefined, isPromoCodeRequired?: boolean | null | undefined, limit?: number | null | undefined, promoCode?: string | null | undefined, type?: DiscountType | null | undefined, typeDependentValue?: string | null | undefined, usage?: number | null | undefined };

export type ExtendDueDateMutationVariables = Exact<{
  input: ExtendDueDateInput;
}>;


export type ExtendDueDateMutation = { __typename?: 'RootMutationType', extendDueDate?: { __typename?: 'GasExchangeRecord', id: any } | null | undefined };

export type FinalizePriceMutationVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type FinalizePriceMutation = { __typename?: 'RootMutationType', finalizePrice?: { __typename?: 'CheckoutSession', id: any, hasGasExchangeItems: boolean, stage: SessionStage, customerPo?: string | null | undefined, orderId?: string | null | undefined, requestedDeliveryDate?: string | null | undefined, submissionUid: any, activeAccount?: { __typename?: 'ActiveAccount', id: any, managedAddressesOnly?: boolean | null | undefined, name: string, type: string, isInvoiced?: boolean | null | undefined } | null | undefined, cart?: { __typename?: 'Cart', appId: any, id: any, items?: Array<{ __typename?: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, dynamicBundle: { __typename?: 'DynamicBundle', tag: string }, dynamicBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined, primaryBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, analyticsDetails?: any | null | undefined, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined } | { __typename?: 'CartItem', analyticsDetails?: any | null | undefined, id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, item: { __typename?: 'Item', brandName?: string | null | undefined, compareAtPrice: number, id: any, gtin: string, imgUrl?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, price?: number | null | undefined, slug?: string | null | undefined, title?: string | null | undefined, subItems?: Array<{ __typename?: 'BundleItem', imgUrl?: string | null | undefined, title?: string | null | undefined } | null | undefined> | null | undefined } } | null | undefined> | null | undefined, user?: { __typename?: 'User', id: any } | null | undefined } | null | undefined, contactInfo?: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'ShippingAddress', addressId?: any | null | undefined, city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, isAddressValidated?: boolean | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, taxId?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, giftInfo?: { __typename?: 'GiftInfo', gifteeEmail?: string | null | undefined, gifteeMessage?: string | null | undefined, giftorName?: string | null | undefined } | null | undefined, payment?: { __typename?: 'Payment', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: AllowedPaymentMethod | null | undefined, token?: string | null | undefined, clientConfirmationToken?: string | null | undefined, paymentStatus?: string | null | undefined, lastErrorCode?: string | null | undefined, billingAddress?: { __typename?: 'BillingAddress', city: string, state?: string | null | undefined, countryCode: string, zip: string, firstName: string, lastName: string, line1: string, line2?: string | null | undefined } | null | undefined } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, price: { __typename?: 'Price', discount: number, shipping: number, subtotal: number, taxRegulatoryTotal: number, taxSalesTotal: number, total: number, lineItems: Array<{ __typename: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, bundleComponents: Array<{ __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined } } | null | undefined> | null | undefined } | null | undefined>, primaryComponent: { __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', gtin: string, title?: string | null | undefined } } | null | undefined> | null | undefined } } | { __typename: 'LineItem', gtin: string, imgUrl?: string | null | undefined, itemId: any, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, title: string, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, subscription?: { __typename?: 'SubscriptionMetadata', discountAmount?: number | null | undefined, discountType?: DiscountType | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subscriptionPrice?: number | null | undefined } | null | undefined }>, loyaltyData?: { __typename?: 'LoyaltyData', totalAmount: number, totalEarnedPoints: number, totalPoints: number } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, promoCodeDiscounts: Array<{ __typename?: 'PromoCodeDiscount', promoCode: string, type: DiscountType, amount: number, discountAmount: number, discountId: any }>, regulatoryTaxTypes: Array<{ __typename?: 'RegulatoryTaxType', code: string, id: string, total: number }> }, shippingAddresses: Array<{ __typename?: 'SavedShippingAddress', addressId: any, city: string, countryCode: string, firstName?: string | null | undefined, isDefault: boolean, lastName?: string | null | undefined, line1: string, line2?: string | null | undefined, nickname?: string | null | undefined, phoneNumber?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated: boolean, zip: string }>, shippingMethodConfig?: { __typename?: 'ShippingMethodConfig', description?: string | null | undefined, id: any, name: string, rate: number } | null | undefined, user?: { __typename?: 'User', email: string, firstName?: string | null | undefined, id: any, lastName?: string | null | undefined } | null | undefined } | null | undefined };

export type FinalizeSessionMutationVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type FinalizeSessionMutation = { __typename?: 'RootMutationType', finalizeSession?: { __typename?: 'SubmittedOrder', id: any, submissionUid: any, bazaarvoice?: { __typename?: 'Bazaarvoice', encryptedEmail?: string | null | undefined, encryptionKeyId?: string | null | undefined } | null | undefined, contactInfo: { __typename?: 'ContactInfo', email?: string | null | undefined, emailOptIn?: boolean | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'ShippingAddress', addressId?: any | null | undefined } | null | undefined }, paymentRequest?: { __typename?: 'PaymentRequest', paymentMethod?: AllowedPaymentMethod | null | undefined } | null | undefined, price: { __typename?: 'Price', discount: number, shipping: number, subtotal: number, taxSalesTotal: number, total: number, lineItems: Array<{ __typename: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, bundleComponents: Array<{ __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined } } | null | undefined> | null | undefined } | null | undefined>, primaryComponent: { __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', gtin: string, title?: string | null | undefined } } | null | undefined> | null | undefined } } | { __typename: 'LineItem', gtin: string, imgUrl?: string | null | undefined, itemId: any, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, title: string, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, subscription?: { __typename?: 'SubscriptionMetadata', discountAmount?: number | null | undefined, discountType?: DiscountType | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subscriptionPrice?: number | null | undefined } | null | undefined }> }, user?: { __typename?: 'User', id: any } | null | undefined } | null | undefined };

export type FindAddressQueryVariables = Exact<{
  input: FindAddressInput;
}>;


export type FindAddressQuery = { __typename?: 'RootQueryType', findAddress?: { __typename?: 'FoundItems', items?: Array<{ __typename?: 'FoundAddress', id?: string | null | undefined, value?: string | null | undefined, description?: string | null | undefined, type?: string | null | undefined }> | null | undefined } | null | undefined };

export type GasExchangeListQueryVariables = Exact<{
  page: Scalars['Int'];
  status: GasExchangeRecordsStatus;
}>;


export type GasExchangeListQuery = { __typename?: 'RootQueryType', gasExchangeRecords: { __typename?: 'GasExchangeRecordPayload', pagination: { __typename?: 'PaginationData', page: number, totalPages: number }, gasExchangeRecords: Array<{ __typename?: 'GasExchangeRecord', id: any, dueDate?: any | null | undefined, qty?: number | null | undefined, returnedQty?: number | null | undefined, status?: GasExchangeRecordStatusType | null | undefined, noOfDaysTillDueDate?: number | null | undefined, lastGasExchangeReturn?: { __typename?: 'GasExchangeReturn', returnDate?: any | null | undefined } | null | undefined, lineItem: { __typename?: 'LineItem', title: string }, order: { __typename?: 'SubmittedOrder', orderId: any, submittedAt?: any | null | undefined } }> } };

export type GasExchangeRecordQueryVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type GasExchangeRecordQuery = { __typename?: 'RootQueryType', gasExchangeRecord?: { __typename?: 'GasExchangeRecord', id: any, status?: GasExchangeRecordStatusType | null | undefined, dueDate?: any | null | undefined, initialDueDate?: any | null | undefined, qty?: number | null | undefined, returnedQty?: number | null | undefined, deadlineIsExtendable?: boolean | null | undefined, noOfDaysTillDueDate?: number | null | undefined, warnUserAboutDepositFees?: boolean | null | undefined, lastGasExchangeReturn?: { __typename?: 'GasExchangeReturn', returnDate?: any | null | undefined } | null | undefined, order: { __typename?: 'SubmittedOrder', id: any, submittedAt?: any | null | undefined, contactInfo: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'ShippingAddress', addressId?: any | null | undefined, city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, isAddressValidated?: boolean | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined } | null | undefined }, paymentInfo?: { __typename?: 'PaymentInfo', cardExpirationDate?: string | null | undefined, cardExpiryMonth?: string | null | undefined, cardExpiryYear?: string | null | undefined, cardType?: PaymentInfoCardType | null | undefined, email?: string | null | undefined, last4?: string | null | undefined } | null | undefined, paymentRequest?: { __typename?: 'PaymentRequest', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: AllowedPaymentMethod | null | undefined, billingAddress?: { __typename?: 'BillingAddress', city: string, company?: string | null | undefined, countryCode: string, firstName: string, lastName: string, line1: string, line2?: string | null | undefined, state?: string | null | undefined, zip: string } | null | undefined } | null | undefined }, missingOrder?: { __typename?: 'SubmittedOrder', price: { __typename?: 'Price', total: number } } | null | undefined, lineItem: { __typename?: 'LineItem', subtotal: number, perUnitPrice: number, strikethroughUnitPrice?: number | null | undefined, quantity: number, item?: { __typename?: 'EmbeddedItem', title?: string | null | undefined, imgUrl?: string | null | undefined } | null | undefined } } | null | undefined };

export type GiftCardFragment = { __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string };

export type InvoicedAddressFragment = { __typename?: 'InvoicedAddress', city: string, company?: string | null | undefined, countryCode: string, firstName?: string | null | undefined, id: any, lastName?: string | null | undefined, line1: string, line2?: string | null | undefined, state?: string | null | undefined, zip: string, phoneNumber: string };

export type IsAddressValidForTaxQueryVariables = Exact<{
  input: IsAddressValidForTaxInput;
}>;


export type IsAddressValidForTaxQuery = { __typename?: 'RootQueryType', isAddressValidForTax?: { __typename?: 'IsAddressValidForTaxPayload', isValid?: boolean | null | undefined } | null | undefined };

type LineItem_BundleLineItem_Fragment = { __typename: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, bundleComponents: Array<{ __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined } } | null | undefined> | null | undefined } | null | undefined>, primaryComponent: { __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', gtin: string, title?: string | null | undefined } } | null | undefined> | null | undefined } };

type LineItem_LineItem_Fragment = { __typename: 'LineItem', gtin: string, imgUrl?: string | null | undefined, itemId: any, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, title: string, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, subscription?: { __typename?: 'SubscriptionMetadata', discountAmount?: number | null | undefined, discountType?: DiscountType | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subscriptionPrice?: number | null | undefined } | null | undefined };

export type LineItemFragment = LineItem_BundleLineItem_Fragment | LineItem_LineItem_Fragment;

export type LocalizationQueryVariables = Exact<{ [key: string]: never; }>;


export type LocalizationQuery = { __typename?: 'RootQueryType', localization?: { __typename?: 'Localization', currentLocale: string, defaultLocale: string, checkout?: { __typename?: 'CheckoutLocalization', pageTitlesInHead?: { __typename?: 'CheckoutPageTitlesLocalization', checkout: string, status: string } | null | undefined, reviewStep?: { __typename?: 'CheckoutReviewStepLocalizations', editButtonText: string, emailNote: string, giftEmailNote: string, giftMessageNote: string, giftShippingHeadingText: string, headingText: string, paymentHeadingText: string, shippingHeadingText: string, submitOrderButtonText: string, agreeToTermsText: string } | null | undefined, breadcrumbs?: { __typename?: 'CheckoutBreadcrumbsLocalization', address: string, payment: string, review: string, shipping: string } | null | undefined, shippingStep?: { __typename?: 'CheckoutShippingStepLocalizations', addAddressButtonText: string, addAddressHeadingText: string, additionalPhoneNumberLabel: string, addressHeadingText: string, contactNoteText: string, continueToPaymentButtonText: string, continueToShippingMethodButtonText: string, savedAddressHeadingText: string, shipAlertText: string, shippingHeadingText: string } | null | undefined, shippingMethodStep?: { __typename?: 'CheckoutShippingMethodStepLocalizations', headingText: string, selectShippingMethodText: string, freeText: string } | null | undefined, paymentStep?: { __typename?: 'CheckoutPaymentStepLocalizations', addCardHeadingText: string, addPaymentButtonText: string, addPaymentHeadingText: string, billingAddressHeadingText: string, billingSameAsShippingText: string, continueToReviewButtonText: string, headingText: string, sectionHeadingText: string, shippingAddressHeadingText: string, giftCardCoversFullAmountTitle: string, giftCardCoversFullAmountDescription: string } | null | undefined, orderStatusPage?: { __typename?: 'CheckoutOrderStatusPageLocalizations', continueShoppingButtonText: string, headingText: string, notFoundMsg: string, orderConfirmationShipmentText: string, orderDateText: string, orderDetailsHeadingText: string, orderDetailsNote: string, orderDetailsText: string, paymentHeadingText: string, printButtonText: string, shippingHeadingText: string } | null | undefined, orderDetails?: { __typename?: 'CheckoutOrderDetailsLocalizations', billingSameAsShippingText: string, cardholderNameText: string, expiresText: string, invoiceTermsText: string, invoiceText: string, poNumberText: string, shippingMethodText: string } | null | undefined, orderSummary?: { __typename?: 'CheckoutOrderSummaryLocalizations', bulkDiscountText: string, bundleDiscountText: string, bundleItemDefaultText: string, cartHeadingText: string, yourOrderText: string, freeShipLabel: string, itemPlural: string, itemSingular: string, regulatoryTaxLabel: string, salesTaxLabel: string, shippingLabel: string, subtotalLabel: string, totalLabel: string, whatsIncludedText: string } | null | undefined, couponCode?: { __typename?: 'CheckoutCouponCodeLocalizations', addCouponButtonText: string, applyCouponButtonText: string, couponLabel: string, couponCodeLabel: string, couponPlaceholderText: string, removeCouponButtonText: string, cancelCouponButtonText: string, editCouponButtonText: string } | null | undefined, giftCard?: { __typename?: 'CheckoutGiftCardLocalizations', addCouponGiftButtonText: string, addGiftButtonText: string, giftNumberPlaceholderText: string, giftNumberLabel: string, giftPinPlaceholderText: string, giftPinLabel: string, giftCardEndingIn: string } | null | undefined, rdd?: { __typename?: 'CheckoutRddLocalizations', changeDateText: string, headingText: string, needOrderSoonerText: string, noteText: string, selectDateText: string, yourRequestedDateText: string } | null | undefined, giftForm?: { __typename?: 'CheckoutGiftFormLocalizations', emailFieldLabel: string, gifteeFieldLabel: string, infoText: string, messageFieldLabel: string, sendAsGiftText: string, shippingAddressHeadingText: string } | null | undefined, errors?: { __typename?: 'CheckoutErrorsLocalizations', genericErrorMsg: string, minimumPurchaseAmount: string, minimumPurchaseQuantity: string, unverifiedEmail: string, paymentNotAccepted: string, unableToUsePoBox: string, paymentFailureErrorText: string, guestCartContainsSubscription?: { __typename?: 'GuestCartContainsSubscriptionLocalizations', cartText: string, itemHeadingText: string, itemNoteText: string } | null | undefined, lowStock?: { __typename?: 'LowStockLocalizations', cartText: string, itemHeadingText: string, itemNoteText: string } | null | undefined, purchaseQtyLimit?: { __typename?: 'PurchaseQtyLimitLocalizations', cartText: string } | null | undefined, outOfStock?: { __typename?: 'OutOfStockLocalizations', cartText: string, itemHeadingText: string, itemNoteText: string } | null | undefined, itemUnavailable?: { __typename?: 'ItemUnavailableLocalizations', cartText: string, itemHeadingText: string, itemNoteText: string } | null | undefined, insufficientLoyaltyBalance?: { __typename?: 'InsufficientLoyaltyBalanceLocalizations', itemHeadingText: string, itemNoteText: string } | null | undefined, invalidLoyaltyReward?: { __typename?: 'InvalidLoyaltyRewardLocalizations', itemHeadingText: string, itemNoteText: string } | null | undefined, invalidGiftCard?: { __typename?: 'InvalidGiftCardLocalizations', itemHeadingText: string, itemNoteText: string } | null | undefined, zipCodeRestriction?: { __typename?: 'ZipCodeRestrictionLocalizations', itemHeadingText: string, itemNoteText: string } | null | undefined, discount?: { __typename?: 'DiscountLocalizations', discountCannotApplyToSubscription: string, discountExceedsSubtotal: string, discountHeadingText: string, discountNoteText: string, discountNotFound: string, discountPromoCodeRequiresEmail: string, discountPromoCodeRequiresEmailOrLogin: string, discountTooLarge: string } | null | undefined } | null | undefined } | null | undefined, forms?: { __typename?: 'FormsLocalization', account?: { __typename?: 'FormsAccountLocalization', firstNameLabel: string, lastNameLabel: string } | null | undefined, address?: { __typename?: 'FormsAddressLocalization', cardholderNameLabel: string, cityLabel: string, companyLabel: string, countryLabel: string, emailLabel: string, firstNameLabel: string, isDefaultLabel: string, lastNameLabel: string, line1Label: string, line2Label: string, manuallyEnterAddressText: string, nicknameLabel: string, phoneLabel: string, phoneNumberLabel: string, requiredFieldsText: string, regionText: string, requiredText: string, specialInstructionsLabel: string, stateLabel: string, taxIdLabel: string, zipLabel: string, autocompletePlaceholderText: string } | null | undefined, creditCard?: { __typename?: 'FormsCreditCardLocalization', cardholderNameLabel: string, cardNumberLabel: string, cardSavedForGasExchangeNote: string, cardSavedForSubsNote: string, cvvLabel: string, expirationDateLabel: string, saveCardForLaterText: string, securityNote: string, cvvTooltip?: { __typename?: 'CreditCardTooltipLocalization', cardsWith3DigitsNote: string, cardsWith3DigitsText: string, cardsWith4DigitsNote: string, cardsWith4DigitsText: string, cvv3DigitAlt: string, cvv4DigitAlt: string, headingText: string } | null | undefined } | null | undefined, forgotPassword?: { __typename?: 'FormsForgotPasswordLocalization', backToLoginText: string, contactLinkContentText: string, contactLinkText: string, emailLabelText: string, formDescriptionText: string, headingText: string, submitButtonText: string, submittedText: string } | null | undefined, resetPassword?: { __typename?: 'FormsResetPasswordLocalization', contactLinkContentText: string, contactLinkText: string, headingText: string, passwordInputLabelText: string, requestNewLinkContentText: string, requestNewLinkText: string, resetTokenDefaultErrorText: string, resetTokenExpiredErrorText: string, resetTokenIdErrorText: string, resetTokenMismatchErrorText: string, resetTokenNotFoundErrorText: string, resetTokenUnableToDecodeErrorText: string, submitText: string } | null | undefined, signIn?: { __typename?: 'FormsSignInLocalization', accountLockedErrorText: string, emailInputPlaceholderText: string, forgotPasswordButtonText: string, genericErrorText: string, headingDefaultText: string, headingText: string, loginButtonText: string, passwordInputPlaceholderText: string, signUpButtonText: string, signUpDefaultHeadingText: string, signUpHeadingText: string } | null | undefined, signup?: { __typename?: 'FormsSignupLocalization', accountLogoAltText: string, ageRequirementErrorText: string, birthdayLabelText: string, createAccountPageHeadingText: string, dayLabelText: string, emailLabelText: string, emailPlaceholderText: string, errorResetPasswordLinkText: string, errorText: string, firstNameLabelText: string, firstNamePlaceholderText: string, headingText: string, lastNameLabelText: string, lastNamePlaceholderText: string, monthLabelText: string, passwordLabelText: string, passwordPlaceholderText: string, submitText: string, yearLabelText: string, emailOptIn?: { __typename?: 'EmailOptInLocalization', body: string, defaultLabelText: string, privacyPolicyLinkText: string, termsOfUseLinkText: string } | null | undefined } | null | undefined, tos?: { __typename?: 'FormsTosLocalization', body: string, errorText: string, tosLinkText: string } | null | undefined, validation?: { __typename?: 'FormsValidationLocalization', dayRequiredErrorText: string, emailRequiredErrorText: string, fieldRequiredErrorText: string, invalidDateErrorText: string, invalidPasswordErrorText: string, invalidPhoneErrorText: string, invalidTaxIdErrorText: string, invalidTaxIdLengthErrorText: string, monthRequiredErrorText: string, newPasswordRequiredErrorText: string, passwordRequiredErrorText: string, requiredErrorText: string, signupPasswordRequiredErrorText: string, wrongEmailErrorText: string, yearRequiredErrorText: string, companyRequiredWithTaxIdErrorText: string, taxIdRequiredWithCompanyErrorText: string } | null | undefined } | null | undefined, portal?: { __typename?: 'PortalLocalization', exchangeDetailPage?: { __typename?: 'PortalExchangeDetailsPageLocalization', avoidDepositFeesWarningTextFractional: string, avoidDepositFeesWarningTextMany: string, avoidDepositFeesWarningTextPlural: string, avoidDepositFeesWarningTextSingular: string, daysLeftToReturnHeadingText: string, daysLeftToReturnTextPlural: string, daysLeftToReturnTextSingular: string, depositFeeAddedAlertText: string, depositFeeAddedText: string, exchangeDetailsText: string, expectedReturnDateText: string, extendReturnDeadlineText: string, missedReturnDateText: string, notFoundMsg: string, orderDetailsHeadingText: string, orderedText: string, paymentHeadingText: string, returnByText: string, returnDateExtendedText: string, returnDateText: string, returnedOnText: string, returnedOutOfTotalText: string, returnedText: string, shippingHeadingText: string, statusText: string, yourOrderText: string } | null | undefined, header?: { __typename?: 'PortalHeaderLocalization', signOutLinkText: string } | null | undefined, accountVerification?: { __typename?: 'AccountVerificationLocalization', heading: string, body: string, buttonText: string, contactSupportText: string, emailSentText: string, tokenExpiredText: string, invalidLinkText: string, verifySuccessText: string } | null | undefined, accountPage?: { __typename?: 'PortalAccountPageLocalization', activeAccountHeadingText: string, addressesHeadingText: string, defaultTitleText: string, emailHeadingText: string, nameHeadingText: string, nameUpdateButtonText: string, nameUpdateCancelButtonText: string, nameUpdateSubmitButtonText: string, passwordChangeButtonText: string, passwordHeadingText: string, paymentsHeadingText: string } | null | undefined, address?: { __typename?: 'PortalAddressLocalization', addHeadingText: string, addSubmitButtonText: string, cancelButtonText: string, editHeadingText: string, makeDefaultText: string, updateSubmitButtonText: string } | null | undefined, breadcrumbs?: { __typename?: 'PortalBreadcrumbsLocalization', account: string, accountDetails: string, addAddress: string, addPayment: string, editAddress: string, exchange: string, exchangeDetails: string, machines: string, notFound: string, orders: string, shippingAddresses: string, subscriptions: string, changePassword: string } | null | undefined, card?: { __typename?: 'PortalCardLocalization', addAddressLabel: string, addPaymentLabel: string, allocationText: string, creditCardNumberText: string, currentLabel: string, defaultAddressLabel: string, defaultPaymentLabel: string, deleteButtonText: string, editButtonText: string, makeDefaultButtonText: string, numRemainingLabel: string, selectLabel: string, subscriptionAddressButtonText: string, viewAllButtonText: string } | null | undefined, password?: { __typename?: 'PortalPasswordLocalization', backButtonText: string, cancelButtonText: string, changePasswordCancelButtonText: string, changePasswordHeadingText: string, changePasswordSubmitButtonText: string, checkYourEmailContentText: string, checkYourEmailHeadingText: string, currentPasswordLabelText: string, forgotPasswordHeadingText: string, forgotPasswordHeadingWithTenantText: string, newPasswordLabelText: string, passwordUpdatedBannerText: string, resetPasswordHeadingText: string, resetPasswordHeadingWithTenantText: string, updatePasswordHeadingText: string, minCharactersText: { __typename?: 'PasswordRequirementSingleCondition', boldText: string, bodyText: string }, oneUppercaseOneLowercaseAlphaText: { __typename?: 'PasswordRequirementDoubleCondition', bodyText: string, boldText1: string, boldText2: string }, twoNumericDigitsText: { __typename?: 'PasswordRequirementSingleCondition', boldText: string, bodyText: string }, oneSpecialCharText: { __typename?: 'PasswordRequirementSingleCondition', bodyText: string, boldText: string } } | null | undefined, errors?: { __typename?: 'PortalErrorsLocalization', geoBlock?: { __typename?: 'PortalErrorsGeoblockLocalization', apiError: string, zipBlocked: string } | null | undefined, addressVerification?: { __typename?: 'PortalErrorsAddressVerificationLocalization', checkoutSpecificConfirmSuggestedText: string, confirmSuggestedAddressText: string, confirmText: string, doYouWantToProceedText: string, editEnteredAddressText: string, editText: string, enteredAddressText: string, goBackText: string, invalidZipCodeText: string, keepEnteredAddressText: string, notAbleToVerifyShippingAddressText: string, recommendChangesText: string, shippingAddressText: string, suggestedAddressText: string, useSuggestedAddressText: string, verifyText: string } | null | undefined } | null | undefined, machinesPage?: { __typename?: 'PortalMachinesPageLocalization', addMachinesText: string, areYouSureDeleteThisMachineText: string, cancelText: string, confirmDeletionText: string, deleteMachineText: string, getGasText: string, learnAboutSparklingWaterMakersText: string, machinesText: string, machineText: string, registerYourMachineNowText: string, troubleshootingGuideText: string, unlockWarrantyText: string, userManualText: string, warrantyExpiredText: string, warrantyExpiresText: string, yesDeleteThisMachineText: string } | null | undefined, exchangeList?: { __typename?: 'PortalExchangeListPageLocalization', active: string, closed: string, cylinderText: string, dueInDaysTextPlural: string, dueInDaysTextSingular: string, gasExchangeListTitle: string, gasExchangePageListTitle: string, orderDate: string, returnByDate: string, returnedDate: string, returnPastDue: string, viewDetails: string } | null | undefined, orderDetailPage?: { __typename?: 'PortalOrderDetailPageLocalization', dateText: string, invoiceNote: string, notFoundErrorText: string, orderIdHeadingText: string, orderSummaryHeadingText: string, paymentHeadingText: string, printButtonText: string, shippingAddressHeadingText: string, trackingText: string, questionAboutOrderText: string, questionAboutOrderNumberText: string } | null | undefined, orderSummary?: { __typename?: 'PortalOrderSummaryLocalization', estimatedFeeLabel: string, estimatedTaxLabel: string, feeLabel: string, freeShipLabel: string, shippingLabel: string, subtotalLabel: string, totalLabel: string } | null | undefined, ordersPage?: { __typename?: 'PortalOrdersPageLocalization', dateHeadingText: string, exchangeText: string, orderIdHeadingText: string, ordersHeadingText: string, receiptButtonText: string, reorderButtonText: string, reorderErrorNote: string, shippingAddressHeadingText: string, totalHeadingText: string } | null | undefined, subscriptionDetailPage?: { __typename?: 'PortalSubscriptionDetailPageLocalization', addressHeadingText: string, backButtonText: string, canceledText: string, cancelHeadingSubText: string, cancelHeadingText: string, cancelLabel: string, cancelSubscriptionButtonText: string, closeButtonText: string, editAddressButtonText: string, editPaymentButtonText: string, intervalHeadingText: string, intervalText: string, manageSubscriptionLabel: string, needToStartNewLabel: string, nextDeliveryDateHeadingText: string, nextShipmentDateText: string, noLongerNeedLabel: string, orderedAtHeadingText: string, otherLabel: string, pausedBannerText: string, pausedText: string, paymentHeadingText: string, paymentUpdateButtonText: string, paymentUpdateNeededText: string, priceNoteText: string, reasonForCancelingLabel: string, reasonForCancelingPlaceholder: string, renameLabel: string, resumedBannerText: string, resumeLabel: string, shippingIssueLabel: string, skipHeadingText: string, skipLabel: string, skipNextShipmentButtonText: string, skippedBannerText: string, skippedShipmentDateText: string, subscriptionNotFoundText: string, subscriptionText: string } | null | undefined, subscriptionsPage?: { __typename?: 'PortalSubscriptionsPageLocalization', actionRequiredLabel: string, canceledLabel: string, headingText: string, intervalText: string, nextDeliveryDateText: string, noSubscriptionsFoundText: string, pausedLabel: string } | null | undefined, payment?: { __typename?: 'PortalPaymentLocalization', addHeadingText: string, billingSameAsShippingText: string, cancelButtonText: string, creditCardSelectorText: string, makeDefaultText: string, paypalSelectorText: string, submitButtonText: string } | null | undefined, notAvailable?: { __typename?: 'PortalNotAvailableLocalization', headingText: string, naAbbreviationText: string, linkContentText: string, linkText: string, orders: string, subscriptions: string, exchanges: string } | null | undefined, alts?: { __typename?: 'PortalAltsLocalization', accountAltText: string, shopLogoAltText: string } | null | undefined, pageTitlesInHead?: { __typename?: 'PortalPageTitlesInHeadLocalization', verifyAccount: string } | null | undefined } | null | undefined, components?: { __typename?: 'ComponentsLocalization', addressVerification?: { __typename?: 'AddressVerificationLocalization', addressErrorBoldText: string, addressErrorText: string, editManuallyText: string, editOnlyText: string, editOrSuggestionText: string, enteredAddressText: string, invalidZipCodeText: string, keepEnteredButtonText: string, reviewAddressText: string, suggestedAddressText: string, titleText: string, useSuggestedButtonText: string, zipErrorBoldText: string, zipErrorText: string } | null | undefined, customNotFound?: { __typename?: 'CustomNotFoundLocalization', cartButtonText: string, headingText: string, homeButtonText: string, subHeadingText: string } | null | undefined, errorModal?: { __typename?: 'ErrorModalLocalization', errorHeadingText: string, okText: string, visitOurLinkForAssistanceText: string } | null | undefined, orderProcessing?: { __typename?: 'OrderProcessing', headingText: string, subHeadingText: string } | null | undefined, exchangeReturnByDate?: { __typename?: 'ExchangeReturnByDateLocalization', exchangeText: string, returnByText: string } | null | undefined, footer?: { __typename?: 'FooterLocalization', allRightsReserved: string } | null | undefined, price?: { __typename?: 'PriceLocalization', eachPriceText: string, regularPriceText: string } | null | undefined } | null | undefined } | null | undefined };

export type LoginUserMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginUserMutation = { __typename?: 'RootMutationType', loginUser?: { __typename?: 'User', id: any } | null | undefined };

export type LogoutUserMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutUserMutation = { __typename?: 'RootMutationType', logoutUser?: { __typename: 'User' } | null | undefined };

export type MergeCartsMutationVariables = Exact<{
  destCartId: Scalars['UUID4'];
  srcCartId: Scalars['UUID4'];
}>;


export type MergeCartsMutation = { __typename?: 'RootMutationType', mergeCarts?: { __typename?: 'Cart', id: any } | null | undefined };

export type PaypalAccountFragment = { __typename?: 'PaypalAccount', email: string, isRemovable?: boolean | null | undefined, token: string, isDefault: boolean };

export type PersistTemporaryCartMutationVariables = Exact<{
  srcCartId: Scalars['UUID4'];
}>;


export type PersistTemporaryCartMutation = { __typename?: 'RootMutationType', persistTemporaryCart?: { __typename?: 'Cart', id: any } | null | undefined };

export type PriceFragment = { __typename?: 'Price', discount: number, shipping: number, subtotal: number, taxRegulatoryTotal: number, taxSalesTotal: number, total: number, lineItems: Array<{ __typename: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, bundleComponents: Array<{ __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined } } | null | undefined> | null | undefined } | null | undefined>, primaryComponent: { __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', gtin: string, title?: string | null | undefined } } | null | undefined> | null | undefined } } | { __typename: 'LineItem', gtin: string, imgUrl?: string | null | undefined, itemId: any, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, title: string, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, subscription?: { __typename?: 'SubscriptionMetadata', discountAmount?: number | null | undefined, discountType?: DiscountType | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subscriptionPrice?: number | null | undefined } | null | undefined }>, loyaltyData?: { __typename?: 'LoyaltyData', totalAmount: number, totalEarnedPoints: number, totalPoints: number } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, promoCodeDiscounts: Array<{ __typename?: 'PromoCodeDiscount', promoCode: string, type: DiscountType, amount: number, discountAmount: number, discountId: any }>, regulatoryTaxTypes: Array<{ __typename?: 'RegulatoryTaxType', code: string, id: string, total: number }> };

export type RemoveDiscountMutationVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type RemoveDiscountMutation = { __typename?: 'RootMutationType', removeDiscount?: { __typename?: 'CheckoutSession', id: any, hasGasExchangeItems: boolean, stage: SessionStage, customerPo?: string | null | undefined, orderId?: string | null | undefined, requestedDeliveryDate?: string | null | undefined, submissionUid: any, activeAccount?: { __typename?: 'ActiveAccount', id: any, managedAddressesOnly?: boolean | null | undefined, name: string, type: string, isInvoiced?: boolean | null | undefined } | null | undefined, cart?: { __typename?: 'Cart', appId: any, id: any, items?: Array<{ __typename?: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, dynamicBundle: { __typename?: 'DynamicBundle', tag: string }, dynamicBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined, primaryBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, analyticsDetails?: any | null | undefined, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined } | { __typename?: 'CartItem', analyticsDetails?: any | null | undefined, id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, item: { __typename?: 'Item', brandName?: string | null | undefined, compareAtPrice: number, id: any, gtin: string, imgUrl?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, price?: number | null | undefined, slug?: string | null | undefined, title?: string | null | undefined, subItems?: Array<{ __typename?: 'BundleItem', imgUrl?: string | null | undefined, title?: string | null | undefined } | null | undefined> | null | undefined } } | null | undefined> | null | undefined, user?: { __typename?: 'User', id: any } | null | undefined } | null | undefined, contactInfo?: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'ShippingAddress', addressId?: any | null | undefined, city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, isAddressValidated?: boolean | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, taxId?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, giftInfo?: { __typename?: 'GiftInfo', gifteeEmail?: string | null | undefined, gifteeMessage?: string | null | undefined, giftorName?: string | null | undefined } | null | undefined, payment?: { __typename?: 'Payment', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: AllowedPaymentMethod | null | undefined, token?: string | null | undefined, clientConfirmationToken?: string | null | undefined, paymentStatus?: string | null | undefined, lastErrorCode?: string | null | undefined, billingAddress?: { __typename?: 'BillingAddress', city: string, state?: string | null | undefined, countryCode: string, zip: string, firstName: string, lastName: string, line1: string, line2?: string | null | undefined } | null | undefined } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, price: { __typename?: 'Price', discount: number, shipping: number, subtotal: number, taxRegulatoryTotal: number, taxSalesTotal: number, total: number, lineItems: Array<{ __typename: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, bundleComponents: Array<{ __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined } } | null | undefined> | null | undefined } | null | undefined>, primaryComponent: { __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', gtin: string, title?: string | null | undefined } } | null | undefined> | null | undefined } } | { __typename: 'LineItem', gtin: string, imgUrl?: string | null | undefined, itemId: any, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, title: string, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, subscription?: { __typename?: 'SubscriptionMetadata', discountAmount?: number | null | undefined, discountType?: DiscountType | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subscriptionPrice?: number | null | undefined } | null | undefined }>, loyaltyData?: { __typename?: 'LoyaltyData', totalAmount: number, totalEarnedPoints: number, totalPoints: number } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, promoCodeDiscounts: Array<{ __typename?: 'PromoCodeDiscount', promoCode: string, type: DiscountType, amount: number, discountAmount: number, discountId: any }>, regulatoryTaxTypes: Array<{ __typename?: 'RegulatoryTaxType', code: string, id: string, total: number }> }, shippingAddresses: Array<{ __typename?: 'SavedShippingAddress', addressId: any, city: string, countryCode: string, firstName?: string | null | undefined, isDefault: boolean, lastName?: string | null | undefined, line1: string, line2?: string | null | undefined, nickname?: string | null | undefined, phoneNumber?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated: boolean, zip: string }>, shippingMethodConfig?: { __typename?: 'ShippingMethodConfig', description?: string | null | undefined, id: any, name: string, rate: number } | null | undefined, user?: { __typename?: 'User', email: string, firstName?: string | null | undefined, id: any, lastName?: string | null | undefined } | null | undefined } | null | undefined };

export type RemoveGiftCardMutationVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type RemoveGiftCardMutation = { __typename?: 'RootMutationType', removeGiftCard?: { __typename?: 'CheckoutSession', id: any, hasGasExchangeItems: boolean, stage: SessionStage, customerPo?: string | null | undefined, orderId?: string | null | undefined, requestedDeliveryDate?: string | null | undefined, submissionUid: any, activeAccount?: { __typename?: 'ActiveAccount', id: any, managedAddressesOnly?: boolean | null | undefined, name: string, type: string, isInvoiced?: boolean | null | undefined } | null | undefined, cart?: { __typename?: 'Cart', appId: any, id: any, items?: Array<{ __typename?: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, dynamicBundle: { __typename?: 'DynamicBundle', tag: string }, dynamicBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined, primaryBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, analyticsDetails?: any | null | undefined, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined } | { __typename?: 'CartItem', analyticsDetails?: any | null | undefined, id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, item: { __typename?: 'Item', brandName?: string | null | undefined, compareAtPrice: number, id: any, gtin: string, imgUrl?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, price?: number | null | undefined, slug?: string | null | undefined, title?: string | null | undefined, subItems?: Array<{ __typename?: 'BundleItem', imgUrl?: string | null | undefined, title?: string | null | undefined } | null | undefined> | null | undefined } } | null | undefined> | null | undefined, user?: { __typename?: 'User', id: any } | null | undefined } | null | undefined, contactInfo?: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'ShippingAddress', addressId?: any | null | undefined, city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, isAddressValidated?: boolean | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, taxId?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, giftInfo?: { __typename?: 'GiftInfo', gifteeEmail?: string | null | undefined, gifteeMessage?: string | null | undefined, giftorName?: string | null | undefined } | null | undefined, payment?: { __typename?: 'Payment', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: AllowedPaymentMethod | null | undefined, token?: string | null | undefined, clientConfirmationToken?: string | null | undefined, paymentStatus?: string | null | undefined, lastErrorCode?: string | null | undefined, billingAddress?: { __typename?: 'BillingAddress', city: string, state?: string | null | undefined, countryCode: string, zip: string, firstName: string, lastName: string, line1: string, line2?: string | null | undefined } | null | undefined } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, price: { __typename?: 'Price', discount: number, shipping: number, subtotal: number, taxRegulatoryTotal: number, taxSalesTotal: number, total: number, lineItems: Array<{ __typename: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, bundleComponents: Array<{ __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined } } | null | undefined> | null | undefined } | null | undefined>, primaryComponent: { __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', gtin: string, title?: string | null | undefined } } | null | undefined> | null | undefined } } | { __typename: 'LineItem', gtin: string, imgUrl?: string | null | undefined, itemId: any, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, title: string, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, subscription?: { __typename?: 'SubscriptionMetadata', discountAmount?: number | null | undefined, discountType?: DiscountType | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subscriptionPrice?: number | null | undefined } | null | undefined }>, loyaltyData?: { __typename?: 'LoyaltyData', totalAmount: number, totalEarnedPoints: number, totalPoints: number } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, promoCodeDiscounts: Array<{ __typename?: 'PromoCodeDiscount', promoCode: string, type: DiscountType, amount: number, discountAmount: number, discountId: any }>, regulatoryTaxTypes: Array<{ __typename?: 'RegulatoryTaxType', code: string, id: string, total: number }> }, shippingAddresses: Array<{ __typename?: 'SavedShippingAddress', addressId: any, city: string, countryCode: string, firstName?: string | null | undefined, isDefault: boolean, lastName?: string | null | undefined, line1: string, line2?: string | null | undefined, nickname?: string | null | undefined, phoneNumber?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated: boolean, zip: string }>, shippingMethodConfig?: { __typename?: 'ShippingMethodConfig', description?: string | null | undefined, id: any, name: string, rate: number } | null | undefined, user?: { __typename?: 'User', email: string, firstName?: string | null | undefined, id: any, lastName?: string | null | undefined } | null | undefined } | null | undefined };

export type RemoveGiftInfoMutationVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type RemoveGiftInfoMutation = { __typename?: 'RootMutationType', removeGiftInfo?: { __typename?: 'CheckoutSession', id: any, hasGasExchangeItems: boolean, stage: SessionStage, customerPo?: string | null | undefined, orderId?: string | null | undefined, requestedDeliveryDate?: string | null | undefined, submissionUid: any, activeAccount?: { __typename?: 'ActiveAccount', id: any, managedAddressesOnly?: boolean | null | undefined, name: string, type: string, isInvoiced?: boolean | null | undefined } | null | undefined, cart?: { __typename?: 'Cart', appId: any, id: any, items?: Array<{ __typename?: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, dynamicBundle: { __typename?: 'DynamicBundle', tag: string }, dynamicBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined, primaryBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, analyticsDetails?: any | null | undefined, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined } | { __typename?: 'CartItem', analyticsDetails?: any | null | undefined, id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, item: { __typename?: 'Item', brandName?: string | null | undefined, compareAtPrice: number, id: any, gtin: string, imgUrl?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, price?: number | null | undefined, slug?: string | null | undefined, title?: string | null | undefined, subItems?: Array<{ __typename?: 'BundleItem', imgUrl?: string | null | undefined, title?: string | null | undefined } | null | undefined> | null | undefined } } | null | undefined> | null | undefined, user?: { __typename?: 'User', id: any } | null | undefined } | null | undefined, contactInfo?: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'ShippingAddress', addressId?: any | null | undefined, city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, isAddressValidated?: boolean | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, taxId?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, giftInfo?: { __typename?: 'GiftInfo', gifteeEmail?: string | null | undefined, gifteeMessage?: string | null | undefined, giftorName?: string | null | undefined } | null | undefined, payment?: { __typename?: 'Payment', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: AllowedPaymentMethod | null | undefined, token?: string | null | undefined, clientConfirmationToken?: string | null | undefined, paymentStatus?: string | null | undefined, lastErrorCode?: string | null | undefined, billingAddress?: { __typename?: 'BillingAddress', city: string, state?: string | null | undefined, countryCode: string, zip: string, firstName: string, lastName: string, line1: string, line2?: string | null | undefined } | null | undefined } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, price: { __typename?: 'Price', discount: number, shipping: number, subtotal: number, taxRegulatoryTotal: number, taxSalesTotal: number, total: number, lineItems: Array<{ __typename: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, bundleComponents: Array<{ __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined } } | null | undefined> | null | undefined } | null | undefined>, primaryComponent: { __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', gtin: string, title?: string | null | undefined } } | null | undefined> | null | undefined } } | { __typename: 'LineItem', gtin: string, imgUrl?: string | null | undefined, itemId: any, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, title: string, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, subscription?: { __typename?: 'SubscriptionMetadata', discountAmount?: number | null | undefined, discountType?: DiscountType | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subscriptionPrice?: number | null | undefined } | null | undefined }>, loyaltyData?: { __typename?: 'LoyaltyData', totalAmount: number, totalEarnedPoints: number, totalPoints: number } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, promoCodeDiscounts: Array<{ __typename?: 'PromoCodeDiscount', promoCode: string, type: DiscountType, amount: number, discountAmount: number, discountId: any }>, regulatoryTaxTypes: Array<{ __typename?: 'RegulatoryTaxType', code: string, id: string, total: number }> }, shippingAddresses: Array<{ __typename?: 'SavedShippingAddress', addressId: any, city: string, countryCode: string, firstName?: string | null | undefined, isDefault: boolean, lastName?: string | null | undefined, line1: string, line2?: string | null | undefined, nickname?: string | null | undefined, phoneNumber?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated: boolean, zip: string }>, shippingMethodConfig?: { __typename?: 'ShippingMethodConfig', description?: string | null | undefined, id: any, name: string, rate: number } | null | undefined, user?: { __typename?: 'User', email: string, firstName?: string | null | undefined, id: any, lastName?: string | null | undefined } | null | undefined } | null | undefined };

export type RequestPasswordResetForUserMutationVariables = Exact<{
  input: RequestPasswordResetForUserInput;
}>;


export type RequestPasswordResetForUserMutation = { __typename?: 'RootMutationType', requestPasswordResetForUser?: { __typename?: 'RequestPasswordResetForUserPayload', email: string } | null | undefined };

export type ResetUserPasswordMutationVariables = Exact<{
  input: ResetUserPasswordInput;
}>;


export type ResetUserPasswordMutation = { __typename?: 'RootMutationType', resetUserPassword?: { __typename?: 'User', id: any } | null | undefined };

export type RestrictedItemsByZipCodeQueryVariables = Exact<{
  zip: Scalars['String'];
}>;


export type RestrictedItemsByZipCodeQuery = { __typename?: 'RootQueryType', restrictedItemsByZipCode?: { __typename?: 'RestrictedItemsByZipCodePayload', restrictedItems: Array<{ __typename?: 'Item', id: any }> } | null | undefined };

export type RetrieveAddressQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type RetrieveAddressQuery = { __typename?: 'RootQueryType', retrieveAddress?: { __typename?: 'RetrievedItems', items?: Array<{ __typename?: 'RetrievedAddress', line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined, country?: string | null | undefined, subBuilding?: string | null | undefined }> | null | undefined } | null | undefined };

export type SaveEnteredContactInfoMutationVariables = Exact<{
  id: Scalars['UUID4'];
  input: SaveEnteredContactInfoInput;
}>;


export type SaveEnteredContactInfoMutation = { __typename?: 'RootMutationType', saveEnteredContactInfo?: { __typename?: 'CheckoutSession', id: any, hasGasExchangeItems: boolean, stage: SessionStage, customerPo?: string | null | undefined, orderId?: string | null | undefined, requestedDeliveryDate?: string | null | undefined, submissionUid: any, activeAccount?: { __typename?: 'ActiveAccount', id: any, managedAddressesOnly?: boolean | null | undefined, name: string, type: string, isInvoiced?: boolean | null | undefined } | null | undefined, cart?: { __typename?: 'Cart', appId: any, id: any, items?: Array<{ __typename?: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, dynamicBundle: { __typename?: 'DynamicBundle', tag: string }, dynamicBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined, primaryBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, analyticsDetails?: any | null | undefined, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined } | { __typename?: 'CartItem', analyticsDetails?: any | null | undefined, id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, item: { __typename?: 'Item', brandName?: string | null | undefined, compareAtPrice: number, id: any, gtin: string, imgUrl?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, price?: number | null | undefined, slug?: string | null | undefined, title?: string | null | undefined, subItems?: Array<{ __typename?: 'BundleItem', imgUrl?: string | null | undefined, title?: string | null | undefined } | null | undefined> | null | undefined } } | null | undefined> | null | undefined, user?: { __typename?: 'User', id: any } | null | undefined } | null | undefined, contactInfo?: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'ShippingAddress', addressId?: any | null | undefined, city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, isAddressValidated?: boolean | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, taxId?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, giftInfo?: { __typename?: 'GiftInfo', gifteeEmail?: string | null | undefined, gifteeMessage?: string | null | undefined, giftorName?: string | null | undefined } | null | undefined, payment?: { __typename?: 'Payment', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: AllowedPaymentMethod | null | undefined, token?: string | null | undefined, clientConfirmationToken?: string | null | undefined, paymentStatus?: string | null | undefined, lastErrorCode?: string | null | undefined, billingAddress?: { __typename?: 'BillingAddress', city: string, state?: string | null | undefined, countryCode: string, zip: string, firstName: string, lastName: string, line1: string, line2?: string | null | undefined } | null | undefined } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, price: { __typename?: 'Price', discount: number, shipping: number, subtotal: number, taxRegulatoryTotal: number, taxSalesTotal: number, total: number, lineItems: Array<{ __typename: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, bundleComponents: Array<{ __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined } } | null | undefined> | null | undefined } | null | undefined>, primaryComponent: { __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', gtin: string, title?: string | null | undefined } } | null | undefined> | null | undefined } } | { __typename: 'LineItem', gtin: string, imgUrl?: string | null | undefined, itemId: any, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, title: string, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, subscription?: { __typename?: 'SubscriptionMetadata', discountAmount?: number | null | undefined, discountType?: DiscountType | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subscriptionPrice?: number | null | undefined } | null | undefined }>, loyaltyData?: { __typename?: 'LoyaltyData', totalAmount: number, totalEarnedPoints: number, totalPoints: number } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, promoCodeDiscounts: Array<{ __typename?: 'PromoCodeDiscount', promoCode: string, type: DiscountType, amount: number, discountAmount: number, discountId: any }>, regulatoryTaxTypes: Array<{ __typename?: 'RegulatoryTaxType', code: string, id: string, total: number }> }, shippingAddresses: Array<{ __typename?: 'SavedShippingAddress', addressId: any, city: string, countryCode: string, firstName?: string | null | undefined, isDefault: boolean, lastName?: string | null | undefined, line1: string, line2?: string | null | undefined, nickname?: string | null | undefined, phoneNumber?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated: boolean, zip: string }>, shippingMethodConfig?: { __typename?: 'ShippingMethodConfig', description?: string | null | undefined, id: any, name: string, rate: number } | null | undefined, user?: { __typename?: 'User', email: string, firstName?: string | null | undefined, id: any, lastName?: string | null | undefined } | null | undefined } | null | undefined };

export type SaveGiftInfoMutationVariables = Exact<{
  id: Scalars['UUID4'];
  input: GiftInfoInput;
}>;


export type SaveGiftInfoMutation = { __typename?: 'RootMutationType', saveGiftInfo?: { __typename?: 'CheckoutSession', id: any, hasGasExchangeItems: boolean, stage: SessionStage, customerPo?: string | null | undefined, orderId?: string | null | undefined, requestedDeliveryDate?: string | null | undefined, submissionUid: any, activeAccount?: { __typename?: 'ActiveAccount', id: any, managedAddressesOnly?: boolean | null | undefined, name: string, type: string, isInvoiced?: boolean | null | undefined } | null | undefined, cart?: { __typename?: 'Cart', appId: any, id: any, items?: Array<{ __typename?: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, dynamicBundle: { __typename?: 'DynamicBundle', tag: string }, dynamicBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined, primaryBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, analyticsDetails?: any | null | undefined, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined } | { __typename?: 'CartItem', analyticsDetails?: any | null | undefined, id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, item: { __typename?: 'Item', brandName?: string | null | undefined, compareAtPrice: number, id: any, gtin: string, imgUrl?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, price?: number | null | undefined, slug?: string | null | undefined, title?: string | null | undefined, subItems?: Array<{ __typename?: 'BundleItem', imgUrl?: string | null | undefined, title?: string | null | undefined } | null | undefined> | null | undefined } } | null | undefined> | null | undefined, user?: { __typename?: 'User', id: any } | null | undefined } | null | undefined, contactInfo?: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'ShippingAddress', addressId?: any | null | undefined, city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, isAddressValidated?: boolean | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, taxId?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, giftInfo?: { __typename?: 'GiftInfo', gifteeEmail?: string | null | undefined, gifteeMessage?: string | null | undefined, giftorName?: string | null | undefined } | null | undefined, payment?: { __typename?: 'Payment', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: AllowedPaymentMethod | null | undefined, token?: string | null | undefined, clientConfirmationToken?: string | null | undefined, paymentStatus?: string | null | undefined, lastErrorCode?: string | null | undefined, billingAddress?: { __typename?: 'BillingAddress', city: string, state?: string | null | undefined, countryCode: string, zip: string, firstName: string, lastName: string, line1: string, line2?: string | null | undefined } | null | undefined } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, price: { __typename?: 'Price', discount: number, shipping: number, subtotal: number, taxRegulatoryTotal: number, taxSalesTotal: number, total: number, lineItems: Array<{ __typename: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, bundleComponents: Array<{ __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined } } | null | undefined> | null | undefined } | null | undefined>, primaryComponent: { __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', gtin: string, title?: string | null | undefined } } | null | undefined> | null | undefined } } | { __typename: 'LineItem', gtin: string, imgUrl?: string | null | undefined, itemId: any, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, title: string, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, subscription?: { __typename?: 'SubscriptionMetadata', discountAmount?: number | null | undefined, discountType?: DiscountType | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subscriptionPrice?: number | null | undefined } | null | undefined }>, loyaltyData?: { __typename?: 'LoyaltyData', totalAmount: number, totalEarnedPoints: number, totalPoints: number } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, promoCodeDiscounts: Array<{ __typename?: 'PromoCodeDiscount', promoCode: string, type: DiscountType, amount: number, discountAmount: number, discountId: any }>, regulatoryTaxTypes: Array<{ __typename?: 'RegulatoryTaxType', code: string, id: string, total: number }> }, shippingAddresses: Array<{ __typename?: 'SavedShippingAddress', addressId: any, city: string, countryCode: string, firstName?: string | null | undefined, isDefault: boolean, lastName?: string | null | undefined, line1: string, line2?: string | null | undefined, nickname?: string | null | undefined, phoneNumber?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated: boolean, zip: string }>, shippingMethodConfig?: { __typename?: 'ShippingMethodConfig', description?: string | null | undefined, id: any, name: string, rate: number } | null | undefined, user?: { __typename?: 'User', email: string, firstName?: string | null | undefined, id: any, lastName?: string | null | undefined } | null | undefined } | null | undefined };

export type SavePaymentMutationVariables = Exact<{
  id: Scalars['UUID4'];
  input: SavePaymentInput;
}>;


export type SavePaymentMutation = { __typename?: 'RootMutationType', savePayment?: { __typename?: 'CheckoutSession', id: any, hasGasExchangeItems: boolean, stage: SessionStage, customerPo?: string | null | undefined, orderId?: string | null | undefined, requestedDeliveryDate?: string | null | undefined, submissionUid: any, activeAccount?: { __typename?: 'ActiveAccount', id: any, managedAddressesOnly?: boolean | null | undefined, name: string, type: string, isInvoiced?: boolean | null | undefined } | null | undefined, cart?: { __typename?: 'Cart', appId: any, id: any, items?: Array<{ __typename?: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, dynamicBundle: { __typename?: 'DynamicBundle', tag: string }, dynamicBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined, primaryBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, analyticsDetails?: any | null | undefined, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined } | { __typename?: 'CartItem', analyticsDetails?: any | null | undefined, id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, item: { __typename?: 'Item', brandName?: string | null | undefined, compareAtPrice: number, id: any, gtin: string, imgUrl?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, price?: number | null | undefined, slug?: string | null | undefined, title?: string | null | undefined, subItems?: Array<{ __typename?: 'BundleItem', imgUrl?: string | null | undefined, title?: string | null | undefined } | null | undefined> | null | undefined } } | null | undefined> | null | undefined, user?: { __typename?: 'User', id: any } | null | undefined } | null | undefined, contactInfo?: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'ShippingAddress', addressId?: any | null | undefined, city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, isAddressValidated?: boolean | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, taxId?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, giftInfo?: { __typename?: 'GiftInfo', gifteeEmail?: string | null | undefined, gifteeMessage?: string | null | undefined, giftorName?: string | null | undefined } | null | undefined, payment?: { __typename?: 'Payment', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: AllowedPaymentMethod | null | undefined, token?: string | null | undefined, clientConfirmationToken?: string | null | undefined, paymentStatus?: string | null | undefined, lastErrorCode?: string | null | undefined, billingAddress?: { __typename?: 'BillingAddress', city: string, state?: string | null | undefined, countryCode: string, zip: string, firstName: string, lastName: string, line1: string, line2?: string | null | undefined } | null | undefined } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, price: { __typename?: 'Price', discount: number, shipping: number, subtotal: number, taxRegulatoryTotal: number, taxSalesTotal: number, total: number, lineItems: Array<{ __typename: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, bundleComponents: Array<{ __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined } } | null | undefined> | null | undefined } | null | undefined>, primaryComponent: { __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', gtin: string, title?: string | null | undefined } } | null | undefined> | null | undefined } } | { __typename: 'LineItem', gtin: string, imgUrl?: string | null | undefined, itemId: any, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, title: string, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, subscription?: { __typename?: 'SubscriptionMetadata', discountAmount?: number | null | undefined, discountType?: DiscountType | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subscriptionPrice?: number | null | undefined } | null | undefined }>, loyaltyData?: { __typename?: 'LoyaltyData', totalAmount: number, totalEarnedPoints: number, totalPoints: number } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, promoCodeDiscounts: Array<{ __typename?: 'PromoCodeDiscount', promoCode: string, type: DiscountType, amount: number, discountAmount: number, discountId: any }>, regulatoryTaxTypes: Array<{ __typename?: 'RegulatoryTaxType', code: string, id: string, total: number }> }, shippingAddresses: Array<{ __typename?: 'SavedShippingAddress', addressId: any, city: string, countryCode: string, firstName?: string | null | undefined, isDefault: boolean, lastName?: string | null | undefined, line1: string, line2?: string | null | undefined, nickname?: string | null | undefined, phoneNumber?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated: boolean, zip: string }>, shippingMethodConfig?: { __typename?: 'ShippingMethodConfig', description?: string | null | undefined, id: any, name: string, rate: number } | null | undefined, user?: { __typename?: 'User', email: string, firstName?: string | null | undefined, id: any, lastName?: string | null | undefined } | null | undefined } | null | undefined };

export type SavePaymentOptionsMutationVariables = Exact<{
  id: Scalars['UUID4'];
  input: SavePaymentOptionsInput;
}>;


export type SavePaymentOptionsMutation = { __typename?: 'RootMutationType', savePaymentOptions?: { __typename?: 'CheckoutSession', id: any, hasGasExchangeItems: boolean, stage: SessionStage, customerPo?: string | null | undefined, orderId?: string | null | undefined, requestedDeliveryDate?: string | null | undefined, submissionUid: any, activeAccount?: { __typename?: 'ActiveAccount', id: any, managedAddressesOnly?: boolean | null | undefined, name: string, type: string, isInvoiced?: boolean | null | undefined } | null | undefined, cart?: { __typename?: 'Cart', appId: any, id: any, items?: Array<{ __typename?: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, dynamicBundle: { __typename?: 'DynamicBundle', tag: string }, dynamicBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined, primaryBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, analyticsDetails?: any | null | undefined, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined } | { __typename?: 'CartItem', analyticsDetails?: any | null | undefined, id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, item: { __typename?: 'Item', brandName?: string | null | undefined, compareAtPrice: number, id: any, gtin: string, imgUrl?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, price?: number | null | undefined, slug?: string | null | undefined, title?: string | null | undefined, subItems?: Array<{ __typename?: 'BundleItem', imgUrl?: string | null | undefined, title?: string | null | undefined } | null | undefined> | null | undefined } } | null | undefined> | null | undefined, user?: { __typename?: 'User', id: any } | null | undefined } | null | undefined, contactInfo?: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'ShippingAddress', addressId?: any | null | undefined, city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, isAddressValidated?: boolean | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, taxId?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, giftInfo?: { __typename?: 'GiftInfo', gifteeEmail?: string | null | undefined, gifteeMessage?: string | null | undefined, giftorName?: string | null | undefined } | null | undefined, payment?: { __typename?: 'Payment', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: AllowedPaymentMethod | null | undefined, token?: string | null | undefined, clientConfirmationToken?: string | null | undefined, paymentStatus?: string | null | undefined, lastErrorCode?: string | null | undefined, billingAddress?: { __typename?: 'BillingAddress', city: string, state?: string | null | undefined, countryCode: string, zip: string, firstName: string, lastName: string, line1: string, line2?: string | null | undefined } | null | undefined } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, price: { __typename?: 'Price', discount: number, shipping: number, subtotal: number, taxRegulatoryTotal: number, taxSalesTotal: number, total: number, lineItems: Array<{ __typename: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, bundleComponents: Array<{ __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined } } | null | undefined> | null | undefined } | null | undefined>, primaryComponent: { __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', gtin: string, title?: string | null | undefined } } | null | undefined> | null | undefined } } | { __typename: 'LineItem', gtin: string, imgUrl?: string | null | undefined, itemId: any, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, title: string, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, subscription?: { __typename?: 'SubscriptionMetadata', discountAmount?: number | null | undefined, discountType?: DiscountType | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subscriptionPrice?: number | null | undefined } | null | undefined }>, loyaltyData?: { __typename?: 'LoyaltyData', totalAmount: number, totalEarnedPoints: number, totalPoints: number } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, promoCodeDiscounts: Array<{ __typename?: 'PromoCodeDiscount', promoCode: string, type: DiscountType, amount: number, discountAmount: number, discountId: any }>, regulatoryTaxTypes: Array<{ __typename?: 'RegulatoryTaxType', code: string, id: string, total: number }> }, shippingAddresses: Array<{ __typename?: 'SavedShippingAddress', addressId: any, city: string, countryCode: string, firstName?: string | null | undefined, isDefault: boolean, lastName?: string | null | undefined, line1: string, line2?: string | null | undefined, nickname?: string | null | undefined, phoneNumber?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated: boolean, zip: string }>, shippingMethodConfig?: { __typename?: 'ShippingMethodConfig', description?: string | null | undefined, id: any, name: string, rate: number } | null | undefined, user?: { __typename?: 'User', email: string, firstName?: string | null | undefined, id: any, lastName?: string | null | undefined } | null | undefined } | null | undefined };

export type SaveShippingMethodMutationVariables = Exact<{
  id: Scalars['UUID4'];
  input: SaveShippingMethodInput;
}>;


export type SaveShippingMethodMutation = { __typename?: 'RootMutationType', saveShippingMethod?: { __typename?: 'CheckoutSession', id: any, hasGasExchangeItems: boolean, stage: SessionStage, customerPo?: string | null | undefined, orderId?: string | null | undefined, requestedDeliveryDate?: string | null | undefined, submissionUid: any, activeAccount?: { __typename?: 'ActiveAccount', id: any, managedAddressesOnly?: boolean | null | undefined, name: string, type: string, isInvoiced?: boolean | null | undefined } | null | undefined, cart?: { __typename?: 'Cart', appId: any, id: any, items?: Array<{ __typename?: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, dynamicBundle: { __typename?: 'DynamicBundle', tag: string }, dynamicBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined, primaryBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, analyticsDetails?: any | null | undefined, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined } | { __typename?: 'CartItem', analyticsDetails?: any | null | undefined, id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, item: { __typename?: 'Item', brandName?: string | null | undefined, compareAtPrice: number, id: any, gtin: string, imgUrl?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, price?: number | null | undefined, slug?: string | null | undefined, title?: string | null | undefined, subItems?: Array<{ __typename?: 'BundleItem', imgUrl?: string | null | undefined, title?: string | null | undefined } | null | undefined> | null | undefined } } | null | undefined> | null | undefined, user?: { __typename?: 'User', id: any } | null | undefined } | null | undefined, contactInfo?: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'ShippingAddress', addressId?: any | null | undefined, city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, isAddressValidated?: boolean | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, taxId?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, giftInfo?: { __typename?: 'GiftInfo', gifteeEmail?: string | null | undefined, gifteeMessage?: string | null | undefined, giftorName?: string | null | undefined } | null | undefined, payment?: { __typename?: 'Payment', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: AllowedPaymentMethod | null | undefined, token?: string | null | undefined, clientConfirmationToken?: string | null | undefined, paymentStatus?: string | null | undefined, lastErrorCode?: string | null | undefined, billingAddress?: { __typename?: 'BillingAddress', city: string, state?: string | null | undefined, countryCode: string, zip: string, firstName: string, lastName: string, line1: string, line2?: string | null | undefined } | null | undefined } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, price: { __typename?: 'Price', discount: number, shipping: number, subtotal: number, taxRegulatoryTotal: number, taxSalesTotal: number, total: number, lineItems: Array<{ __typename: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, bundleComponents: Array<{ __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined } } | null | undefined> | null | undefined } | null | undefined>, primaryComponent: { __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', gtin: string, title?: string | null | undefined } } | null | undefined> | null | undefined } } | { __typename: 'LineItem', gtin: string, imgUrl?: string | null | undefined, itemId: any, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, title: string, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, subscription?: { __typename?: 'SubscriptionMetadata', discountAmount?: number | null | undefined, discountType?: DiscountType | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subscriptionPrice?: number | null | undefined } | null | undefined }>, loyaltyData?: { __typename?: 'LoyaltyData', totalAmount: number, totalEarnedPoints: number, totalPoints: number } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, promoCodeDiscounts: Array<{ __typename?: 'PromoCodeDiscount', promoCode: string, type: DiscountType, amount: number, discountAmount: number, discountId: any }>, regulatoryTaxTypes: Array<{ __typename?: 'RegulatoryTaxType', code: string, id: string, total: number }> }, shippingAddresses: Array<{ __typename?: 'SavedShippingAddress', addressId: any, city: string, countryCode: string, firstName?: string | null | undefined, isDefault: boolean, lastName?: string | null | undefined, line1: string, line2?: string | null | undefined, nickname?: string | null | undefined, phoneNumber?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated: boolean, zip: string }>, shippingMethodConfig?: { __typename?: 'ShippingMethodConfig', description?: string | null | undefined, id: any, name: string, rate: number } | null | undefined, user?: { __typename?: 'User', email: string, firstName?: string | null | undefined, id: any, lastName?: string | null | undefined } | null | undefined } | null | undefined };

export type SaveShippingOptionsMutationVariables = Exact<{
  id: Scalars['UUID4'];
  input: SaveShippingOptionsInput;
}>;


export type SaveShippingOptionsMutation = { __typename?: 'RootMutationType', saveShippingOptions?: { __typename?: 'CheckoutSession', id: any, hasGasExchangeItems: boolean, stage: SessionStage, customerPo?: string | null | undefined, orderId?: string | null | undefined, requestedDeliveryDate?: string | null | undefined, submissionUid: any, activeAccount?: { __typename?: 'ActiveAccount', id: any, managedAddressesOnly?: boolean | null | undefined, name: string, type: string, isInvoiced?: boolean | null | undefined } | null | undefined, cart?: { __typename?: 'Cart', appId: any, id: any, items?: Array<{ __typename?: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, dynamicBundle: { __typename?: 'DynamicBundle', tag: string }, dynamicBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined, primaryBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, analyticsDetails?: any | null | undefined, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined } | { __typename?: 'CartItem', analyticsDetails?: any | null | undefined, id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, item: { __typename?: 'Item', brandName?: string | null | undefined, compareAtPrice: number, id: any, gtin: string, imgUrl?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, price?: number | null | undefined, slug?: string | null | undefined, title?: string | null | undefined, subItems?: Array<{ __typename?: 'BundleItem', imgUrl?: string | null | undefined, title?: string | null | undefined } | null | undefined> | null | undefined } } | null | undefined> | null | undefined, user?: { __typename?: 'User', id: any } | null | undefined } | null | undefined, contactInfo?: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'ShippingAddress', addressId?: any | null | undefined, city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, isAddressValidated?: boolean | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, taxId?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, giftInfo?: { __typename?: 'GiftInfo', gifteeEmail?: string | null | undefined, gifteeMessage?: string | null | undefined, giftorName?: string | null | undefined } | null | undefined, payment?: { __typename?: 'Payment', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: AllowedPaymentMethod | null | undefined, token?: string | null | undefined, clientConfirmationToken?: string | null | undefined, paymentStatus?: string | null | undefined, lastErrorCode?: string | null | undefined, billingAddress?: { __typename?: 'BillingAddress', city: string, state?: string | null | undefined, countryCode: string, zip: string, firstName: string, lastName: string, line1: string, line2?: string | null | undefined } | null | undefined } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, price: { __typename?: 'Price', discount: number, shipping: number, subtotal: number, taxRegulatoryTotal: number, taxSalesTotal: number, total: number, lineItems: Array<{ __typename: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, bundleComponents: Array<{ __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined } } | null | undefined> | null | undefined } | null | undefined>, primaryComponent: { __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', gtin: string, title?: string | null | undefined } } | null | undefined> | null | undefined } } | { __typename: 'LineItem', gtin: string, imgUrl?: string | null | undefined, itemId: any, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, title: string, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, subscription?: { __typename?: 'SubscriptionMetadata', discountAmount?: number | null | undefined, discountType?: DiscountType | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subscriptionPrice?: number | null | undefined } | null | undefined }>, loyaltyData?: { __typename?: 'LoyaltyData', totalAmount: number, totalEarnedPoints: number, totalPoints: number } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, promoCodeDiscounts: Array<{ __typename?: 'PromoCodeDiscount', promoCode: string, type: DiscountType, amount: number, discountAmount: number, discountId: any }>, regulatoryTaxTypes: Array<{ __typename?: 'RegulatoryTaxType', code: string, id: string, total: number }> }, shippingAddresses: Array<{ __typename?: 'SavedShippingAddress', addressId: any, city: string, countryCode: string, firstName?: string | null | undefined, isDefault: boolean, lastName?: string | null | undefined, line1: string, line2?: string | null | undefined, nickname?: string | null | undefined, phoneNumber?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated: boolean, zip: string }>, shippingMethodConfig?: { __typename?: 'ShippingMethodConfig', description?: string | null | undefined, id: any, name: string, rate: number } | null | undefined, user?: { __typename?: 'User', email: string, firstName?: string | null | undefined, id: any, lastName?: string | null | undefined } | null | undefined } | null | undefined };

export type SaveSuggestedAddressMutationVariables = Exact<{
  id: Scalars['UUID4'];
  input: SaveSuggestedAddressInput;
}>;


export type SaveSuggestedAddressMutation = { __typename?: 'RootMutationType', saveSuggestedAddress?: { __typename?: 'CheckoutSession', id: any, hasGasExchangeItems: boolean, stage: SessionStage, customerPo?: string | null | undefined, orderId?: string | null | undefined, requestedDeliveryDate?: string | null | undefined, submissionUid: any, activeAccount?: { __typename?: 'ActiveAccount', id: any, managedAddressesOnly?: boolean | null | undefined, name: string, type: string, isInvoiced?: boolean | null | undefined } | null | undefined, cart?: { __typename?: 'Cart', appId: any, id: any, items?: Array<{ __typename?: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, dynamicBundle: { __typename?: 'DynamicBundle', tag: string }, dynamicBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined, primaryBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, analyticsDetails?: any | null | undefined, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined } | { __typename?: 'CartItem', analyticsDetails?: any | null | undefined, id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, item: { __typename?: 'Item', brandName?: string | null | undefined, compareAtPrice: number, id: any, gtin: string, imgUrl?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, price?: number | null | undefined, slug?: string | null | undefined, title?: string | null | undefined, subItems?: Array<{ __typename?: 'BundleItem', imgUrl?: string | null | undefined, title?: string | null | undefined } | null | undefined> | null | undefined } } | null | undefined> | null | undefined, user?: { __typename?: 'User', id: any } | null | undefined } | null | undefined, contactInfo?: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'ShippingAddress', addressId?: any | null | undefined, city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, isAddressValidated?: boolean | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, taxId?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, giftInfo?: { __typename?: 'GiftInfo', gifteeEmail?: string | null | undefined, gifteeMessage?: string | null | undefined, giftorName?: string | null | undefined } | null | undefined, payment?: { __typename?: 'Payment', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: AllowedPaymentMethod | null | undefined, token?: string | null | undefined, clientConfirmationToken?: string | null | undefined, paymentStatus?: string | null | undefined, lastErrorCode?: string | null | undefined, billingAddress?: { __typename?: 'BillingAddress', city: string, state?: string | null | undefined, countryCode: string, zip: string, firstName: string, lastName: string, line1: string, line2?: string | null | undefined } | null | undefined } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, price: { __typename?: 'Price', discount: number, shipping: number, subtotal: number, taxRegulatoryTotal: number, taxSalesTotal: number, total: number, lineItems: Array<{ __typename: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, bundleComponents: Array<{ __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined } } | null | undefined> | null | undefined } | null | undefined>, primaryComponent: { __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', gtin: string, title?: string | null | undefined } } | null | undefined> | null | undefined } } | { __typename: 'LineItem', gtin: string, imgUrl?: string | null | undefined, itemId: any, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, title: string, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, subscription?: { __typename?: 'SubscriptionMetadata', discountAmount?: number | null | undefined, discountType?: DiscountType | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subscriptionPrice?: number | null | undefined } | null | undefined }>, loyaltyData?: { __typename?: 'LoyaltyData', totalAmount: number, totalEarnedPoints: number, totalPoints: number } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, promoCodeDiscounts: Array<{ __typename?: 'PromoCodeDiscount', promoCode: string, type: DiscountType, amount: number, discountAmount: number, discountId: any }>, regulatoryTaxTypes: Array<{ __typename?: 'RegulatoryTaxType', code: string, id: string, total: number }> }, shippingAddresses: Array<{ __typename?: 'SavedShippingAddress', addressId: any, city: string, countryCode: string, firstName?: string | null | undefined, isDefault: boolean, lastName?: string | null | undefined, line1: string, line2?: string | null | undefined, nickname?: string | null | undefined, phoneNumber?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated: boolean, zip: string }>, shippingMethodConfig?: { __typename?: 'ShippingMethodConfig', description?: string | null | undefined, id: any, name: string, rate: number } | null | undefined, user?: { __typename?: 'User', email: string, firstName?: string | null | undefined, id: any, lastName?: string | null | undefined } | null | undefined } | null | undefined };

export type CreateSetupIntentMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateSetupIntentMutation = { __typename?: 'RootMutationType', createSetupIntent: { __typename?: 'SetupIntent', clientSecret: string } };

export type SetupTransactionMutationVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type SetupTransactionMutation = { __typename?: 'RootMutationType', setupTransaction?: { __typename?: 'CheckoutSession', id: any, payment?: { __typename?: 'Payment', token?: string | null | undefined, clientConfirmationToken?: string | null | undefined } | null | undefined } | null | undefined };

export type ShopToCheckoutMutationVariables = Exact<{
  cartId: Scalars['UUID4'];
}>;


export type ShopToCheckoutMutation = { __typename?: 'RootMutationType', shopToCheckout?: { __typename?: 'CheckoutSession', id: any, hasGasExchangeItems: boolean, stage: SessionStage, customerPo?: string | null | undefined, orderId?: string | null | undefined, requestedDeliveryDate?: string | null | undefined, submissionUid: any, activeAccount?: { __typename?: 'ActiveAccount', id: any, managedAddressesOnly?: boolean | null | undefined, name: string, type: string, isInvoiced?: boolean | null | undefined } | null | undefined, cart?: { __typename?: 'Cart', appId: any, id: any, items?: Array<{ __typename?: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, dynamicBundle: { __typename?: 'DynamicBundle', tag: string }, dynamicBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined, primaryBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, analyticsDetails?: any | null | undefined, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined } | { __typename?: 'CartItem', analyticsDetails?: any | null | undefined, id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, item: { __typename?: 'Item', brandName?: string | null | undefined, compareAtPrice: number, id: any, gtin: string, imgUrl?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, price?: number | null | undefined, slug?: string | null | undefined, title?: string | null | undefined, subItems?: Array<{ __typename?: 'BundleItem', imgUrl?: string | null | undefined, title?: string | null | undefined } | null | undefined> | null | undefined } } | null | undefined> | null | undefined, user?: { __typename?: 'User', id: any } | null | undefined } | null | undefined, contactInfo?: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'ShippingAddress', addressId?: any | null | undefined, city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, isAddressValidated?: boolean | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, taxId?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, giftInfo?: { __typename?: 'GiftInfo', gifteeEmail?: string | null | undefined, gifteeMessage?: string | null | undefined, giftorName?: string | null | undefined } | null | undefined, payment?: { __typename?: 'Payment', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: AllowedPaymentMethod | null | undefined, token?: string | null | undefined, clientConfirmationToken?: string | null | undefined, paymentStatus?: string | null | undefined, lastErrorCode?: string | null | undefined, billingAddress?: { __typename?: 'BillingAddress', city: string, state?: string | null | undefined, countryCode: string, zip: string, firstName: string, lastName: string, line1: string, line2?: string | null | undefined } | null | undefined } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, price: { __typename?: 'Price', discount: number, shipping: number, subtotal: number, taxRegulatoryTotal: number, taxSalesTotal: number, total: number, lineItems: Array<{ __typename: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, bundleComponents: Array<{ __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined } } | null | undefined> | null | undefined } | null | undefined>, primaryComponent: { __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', gtin: string, title?: string | null | undefined } } | null | undefined> | null | undefined } } | { __typename: 'LineItem', gtin: string, imgUrl?: string | null | undefined, itemId: any, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, title: string, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, subscription?: { __typename?: 'SubscriptionMetadata', discountAmount?: number | null | undefined, discountType?: DiscountType | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subscriptionPrice?: number | null | undefined } | null | undefined }>, loyaltyData?: { __typename?: 'LoyaltyData', totalAmount: number, totalEarnedPoints: number, totalPoints: number } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, promoCodeDiscounts: Array<{ __typename?: 'PromoCodeDiscount', promoCode: string, type: DiscountType, amount: number, discountAmount: number, discountId: any }>, regulatoryTaxTypes: Array<{ __typename?: 'RegulatoryTaxType', code: string, id: string, total: number }> }, shippingAddresses: Array<{ __typename?: 'SavedShippingAddress', addressId: any, city: string, countryCode: string, firstName?: string | null | undefined, isDefault: boolean, lastName?: string | null | undefined, line1: string, line2?: string | null | undefined, nickname?: string | null | undefined, phoneNumber?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated: boolean, zip: string }>, shippingMethodConfig?: { __typename?: 'ShippingMethodConfig', description?: string | null | undefined, id: any, name: string, rate: number } | null | undefined, user?: { __typename?: 'User', email: string, firstName?: string | null | undefined, id: any, lastName?: string | null | undefined } | null | undefined } | null | undefined };

export type SignUpUserMutationVariables = Exact<{
  input: SignupUserInput;
}>;


export type SignUpUserMutation = { __typename?: 'RootMutationType', signupUser?: { __typename?: 'User', id: any, hashedEmail: string } | null | undefined };

export type SkipOrderSubscriptionMutationVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type SkipOrderSubscriptionMutation = { __typename?: 'RootMutationType', skipOrderSubscription?: { __typename?: 'OrderSubscription', id: any } | null | undefined };

export type SubmitOrderMutationVariables = Exact<{
  id: Scalars['UUID4'];
  input: SubmitOrderInput;
}>;


export type SubmitOrderMutation = { __typename?: 'RootMutationType', submitOrder?: { __typename?: 'SubmittedOrder', id: any, submissionUid: any, bazaarvoice?: { __typename?: 'Bazaarvoice', encryptedEmail?: string | null | undefined, encryptionKeyId?: string | null | undefined } | null | undefined, contactInfo: { __typename?: 'ContactInfo', email?: string | null | undefined, emailOptIn?: boolean | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'ShippingAddress', addressId?: any | null | undefined } | null | undefined, shippingMethod?: { __typename?: 'ShippingMethod', code?: string | null | undefined, title?: string | null | undefined, phone?: string | null | undefined } | null | undefined }, paymentRequest?: { __typename?: 'PaymentRequest', paymentMethod?: AllowedPaymentMethod | null | undefined } | null | undefined, price: { __typename?: 'Price', discount: number, shipping: number, subtotal: number, taxSalesTotal: number, total: number, lineItems: Array<{ __typename: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, bundleComponents: Array<{ __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined } } | null | undefined> | null | undefined } | null | undefined>, primaryComponent: { __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', gtin: string, title?: string | null | undefined } } | null | undefined> | null | undefined } } | { __typename: 'LineItem', gtin: string, imgUrl?: string | null | undefined, itemId: any, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, title: string, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, subscription?: { __typename?: 'SubscriptionMetadata', discountAmount?: number | null | undefined, discountType?: DiscountType | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subscriptionPrice?: number | null | undefined } | null | undefined }> }, user?: { __typename?: 'User', id: any } | null | undefined } | null | undefined };

export type SubmittedOrderQueryVariables = Exact<{
  orderId: Scalars['UUID4'];
}>;


export type SubmittedOrderQuery = { __typename?: 'RootQueryType', submittedOrder?: { __typename?: 'SubmittedOrder', customerPo?: string | null | undefined, displayName?: string | null | undefined, giftorName?: string | null | undefined, id: any, isExternalOrder?: boolean | null | undefined, orderType?: SubmittedOrderType | null | undefined, requestedDeliveryDate?: string | null | undefined, submittedAt?: any | null | undefined, contactInfo: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'ShippingAddress', addressId?: any | null | undefined, city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, isAddressValidated?: boolean | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined, taxId?: string | null | undefined } | null | undefined, shippingMethod?: { __typename?: 'ShippingMethod', code?: string | null | undefined, title?: string | null | undefined, phone?: string | null | undefined } | null | undefined }, fulfillments: Array<{ __typename?: 'Fulfillment', id: any, insertedAt?: any | null | undefined, status?: StatusLabels | null | undefined, tracking?: { __typename?: 'TrackingNumber', carrierName?: string | null | undefined, status?: TrackingStatusLabels | null | undefined, trackingNumber?: string | null | undefined, trackingUrl?: string | null | undefined } | null | undefined, items: Array<{ __typename?: 'FulfillmentItem', quantity?: number | null | undefined, item?: { __typename?: 'Item', id: any, imgUrl?: string | null | undefined, title?: string | null | undefined } | null | undefined }> }>, paymentInfo?: { __typename?: 'PaymentInfo', cardExpirationDate?: string | null | undefined, cardExpiryMonth?: string | null | undefined, cardExpiryYear?: string | null | undefined, cardType?: PaymentInfoCardType | null | undefined, email?: string | null | undefined, last4?: string | null | undefined } | null | undefined, paymentRequest?: { __typename?: 'PaymentRequest', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: AllowedPaymentMethod | null | undefined, billingAddress?: { __typename?: 'BillingAddress', city: string, company?: string | null | undefined, countryCode: string, firstName: string, lastName: string, line1: string, line2?: string | null | undefined, state?: string | null | undefined, zip: string } | null | undefined } | null | undefined, price: { __typename?: 'Price', discount: number, shipping: number, subtotal: number, taxRegulatoryTotal: number, taxSalesTotal: number, total: number, lineItems: Array<{ __typename: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, bundleComponents: Array<{ __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined } } | null | undefined> | null | undefined } | null | undefined>, primaryComponent: { __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', gtin: string, title?: string | null | undefined } } | null | undefined> | null | undefined } } | { __typename: 'LineItem', gtin: string, imgUrl?: string | null | undefined, itemId: any, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, title: string, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, subscription?: { __typename?: 'SubscriptionMetadata', discountAmount?: number | null | undefined, discountType?: DiscountType | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subscriptionPrice?: number | null | undefined } | null | undefined }>, loyaltyData?: { __typename?: 'LoyaltyData', totalAmount: number, totalEarnedPoints: number, totalPoints: number } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, promoCodeDiscounts: Array<{ __typename?: 'PromoCodeDiscount', promoCode: string, type: DiscountType, amount: number, discountAmount: number, discountId: any }>, regulatoryTaxTypes: Array<{ __typename?: 'RegulatoryTaxType', code: string, id: string, total: number }> }, shippingMethodConfig?: { __typename?: 'ShippingMethodConfig', name: string } | null | undefined } | null | undefined };

export type SubmittedOrdersQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type SubmittedOrdersQuery = { __typename?: 'RootQueryType', submittedOrders?: { __typename?: 'SubmittedOrderPayload', pagination: { __typename?: 'PaginationData', totalPages: number }, submittedOrders: Array<{ __typename?: 'SubmittedOrder', id: any, isExternalOrder?: boolean | null | undefined, orderSubscriptionRelationship: OrderSubscriptionRelationshipNames, displayName?: string | null | undefined, submittedAt?: any | null | undefined, requestedDeliveryDate?: string | null | undefined, userId?: any | null | undefined, price: { __typename?: 'Price', total: number, items: Array<{ __typename?: 'PriceItem', item?: { __typename?: 'EmbeddedItem', gasExchangeInfo?: { __typename?: 'EmbeddedItemGasExchangeInfo', enabled: boolean } | null | undefined } | null | undefined }> }, contactInfo: { __typename?: 'ContactInfo', shippingAddress?: { __typename?: 'ShippingAddress', nickname?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined } | null | undefined }, fulfillments: Array<{ __typename?: 'Fulfillment', id: any }> }> } | null | undefined };

export type SubscriptionQueryVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type SubscriptionQuery = { __typename?: 'RootQueryType', orderSubscription: { __typename?: 'OrderSubscription', id: any, insertedAt: any, intervalInDays: number, nextOrderCreationDates: Array<any | null | undefined>, status: OrderSubscriptionStatusNames, statusReason?: string | null | undefined, title: string, address: { __typename?: 'Address', city: string, countryCode: string, firstName: string, id: any, lastName: string, line1: string, line2?: string | null | undefined, state?: string | null | undefined, zip: string }, paymentInfo?: { __typename?: 'PaymentInfo', cardExpiryMonth?: string | null | undefined, cardExpiryYear?: string | null | undefined, cardType?: PaymentInfoCardType | null | undefined, cardholderName?: string | null | undefined, email?: string | null | undefined, last4?: string | null | undefined, paymentMethod?: PaymentInfoPaymentMethod | null | undefined, paymentToken?: string | null | undefined } | null | undefined, price: { __typename?: 'Price', shipping: number, subtotal: number, taxRegulatoryTotal: number, taxSalesTotal: number, total: number, lineItems: Array<{ __typename?: 'BundleLineItem' } | { __typename?: 'LineItem', perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, item?: { __typename?: 'EmbeddedItem', imgUrl?: string | null | undefined, title?: string | null | undefined, fluidOzPerPack?: any | null | undefined, productsPerPack?: number | null | undefined } | null | undefined }> } } };

export type SubscriptionAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionAddressesQuery = { __typename?: 'RootQueryType', orderSubscriptions: Array<{ __typename?: 'OrderSubscription', address: { __typename?: 'Address', id: any }, orderSubscriptionItems: Array<{ __typename?: 'OrderSubscriptionItem', currentItem?: { __typename?: 'Item', id: any } | null | undefined }> }> };

export type SubscriptionForAddressUpdateQueryVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type SubscriptionForAddressUpdateQuery = { __typename?: 'RootQueryType', orderSubscription: { __typename?: 'OrderSubscription', id: any, title: string, address: { __typename?: 'Address', id: any }, orderSubscriptionItems: Array<{ __typename?: 'OrderSubscriptionItem', currentItem?: { __typename?: 'Item', id: any } | null | undefined }> } };

export type SubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionsQuery = { __typename?: 'RootQueryType', orderSubscriptions: Array<{ __typename?: 'OrderSubscription', id: any, insertedAt: any, intervalInDays: number, nextOrderCreationDates: Array<any | null | undefined>, status: OrderSubscriptionStatusNames, statusReason?: string | null | undefined, title: string, orderSubscriptionItems: Array<{ __typename?: 'OrderSubscriptionItem', currentItem?: { __typename?: 'Item', imgUrl?: string | null | undefined } | null | undefined }> }> };

export type TenantQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantQuery = { __typename?: 'RootQueryType', tenant?: { __typename?: 'Tenant', id: any, domain: string, fallbackUrl: string, analyticsConfig: { __typename?: 'AnalyticsConfig', projectId?: string | null | undefined, writeKey?: string | null | undefined, gtm?: { __typename?: 'GtmConfig', containerId?: string | null | undefined } | null | undefined }, botProtection: { __typename?: 'BotProtection', active: boolean, provider?: BotProtectionProvider | null | undefined, siteKey?: { __typename?: 'BotProtectionSiteKey', web: string } | null | undefined }, giftCardConfig: { __typename?: 'GiftCardConfig', giftCardsEnabled?: boolean | null | undefined }, brandConfig: { __typename?: 'BrandConfig', customCss?: string | null | undefined, audience: string, copyright: string, optInTextLocalized: string, contactUrl?: string | null | undefined, supportEmail?: string | null | undefined, email?: string | null | undefined, logoUrl: string, title: string, yearsAgeGate?: number | null | undefined, customizations: { __typename?: 'BrandConfigCustomizations', account?: { __typename?: 'BrandConfigCustomizationsAccount', signinPageTitle?: string | null | undefined, signupPageTitle?: string | null | undefined, profilePageTitle?: string | null | undefined, valueprops: Array<{ __typename?: 'BrandConfigCustomizationsAccountValueprops', imgUrl?: string | null | undefined, text?: string | null | undefined }> } | null | undefined, contacts: Array<{ __typename?: 'BrandConfigCustomizationsContact', city?: string | null | undefined, countryCode?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, phoneNumber?: string | null | undefined, showCountry?: boolean | null | undefined, state?: string | null | undefined, type: string, zip?: string | null | undefined }>, fonts: Array<{ __typename?: 'BrandConfigCustomizationsFont', name: string, style?: string | null | undefined, weight?: string | null | undefined, urls: Array<{ __typename?: 'BrandConfigCustomizationsFontSources', format?: string | null | undefined, local?: string | null | undefined, url?: string | null | undefined }>, meta?: Array<{ __typename?: 'BrandConfigCustomizationsFontMeta', key: string, value: string }> | null | undefined }>, images: Array<{ __typename?: 'BrandConfigCustomizationsImage', name: string, src: string, alt?: string | null | undefined }>, links: Array<{ __typename?: 'BrandConfigCustomizationsLink', location: string, position: number, title: string, url: string, newTab: boolean }> }, trackingFonts?: Array<{ __typename?: 'BrandConfigTrackingFonts', isTrackingRequired: boolean, resource: string } | null | undefined> | null | undefined, customTexts: Array<{ __typename?: 'CustomText', body: Array<string>, location: string, position?: number | null | undefined, type: string, links: Array<{ __typename?: 'CustomTextLink', type: string, key: string, linkValue: string, displayValue: string }> }> }, capabilities: { __typename?: 'Capabilities', signUp: { __typename?: 'CapabilitiesSignUp', enabled: boolean } }, checkout?: { __typename?: 'Checkout', vatInclusivePricing?: boolean | null | undefined, showCouponCodeCta?: boolean | null | undefined, version?: string | null | undefined, paymentOptions?: { __typename?: 'TenantPaymentOptions', defaultCurrencyCode: string } | null | undefined, shippingOptions?: { __typename?: 'TenantShippingOptions', shippingMethodsEnabled?: boolean | null | undefined } | null | undefined } | null | undefined, giftConfig: { __typename?: 'GiftConfig', giftingEnabled?: boolean | null | undefined }, contactConfig: { __typename?: 'ContactConfig', shippingAddressConfig: { __typename?: 'AddressConfig', requireValidation: ValidationRequirement, note?: string | null | undefined, isStateRequired?: boolean | null | undefined, taxId?: boolean | null | undefined, companyName?: boolean | null | undefined, countriesAllowed: Array<{ __typename?: 'CountriesAllowed', id: string, name: string }>, statesConfig: Array<{ __typename?: 'StatesConfig', countryId: string, statesAllowed: Array<{ __typename?: 'AllowedState', id: string, name: string }> }>, phoneNumberCountryCodesAllowed?: Array<{ __typename?: 'PhoneNumberCountryCodesAllowed', code: string, country: string } | null | undefined> | null | undefined } }, paymentConfig: { __typename?: 'PaymentConfig', processor?: PaymentProcessor | null | undefined, publicPaymentToken?: string | null | undefined, billingAddressConfig: { __typename?: 'AddressConfig', requireValidation: ValidationRequirement, note?: string | null | undefined, countriesAllowed: Array<{ __typename?: 'CountriesAllowed', id: string, name: string }>, statesConfig: Array<{ __typename?: 'StatesConfig', countryId: string, statesAllowed: Array<{ __typename?: 'AllowedState', id: string, name: string }> }> }, paymentTypes: Array<{ __typename?: 'PaymentType', brandImgUrl: string, id: number, name: string }> }, shippingConfig: { __typename?: 'ShippingConfig', maxDeliveryWindowInDays?: number | null | undefined }, shoppingBagConfig: { __typename?: 'ShoppingBagConfig', maxAmountForSelect: number, minimumPurchaseAmount: number, minimumPurchaseQty: number, availableSubscriptionIntervalsInDays: Array<number>, orderSubscriptionsEnabled: boolean, subscriptionIntervalsInDays: Array<number> }, userExperience: { __typename?: 'UserExperience', hasRequestedDeliveryDate: boolean } } | null | undefined };

export type UpdateCreditCardDefaultMutationVariables = Exact<{
  input: UpdateCreditCardDefaultInput;
}>;


export type UpdateCreditCardDefaultMutation = { __typename?: 'RootMutationType', updateCreditCardDefault: { __typename?: 'CreditCard', isDefault: boolean } };

export type UpdateUserFirstLastNameMutationVariables = Exact<{
  input: UpdateUserFirstLastNameInput;
}>;


export type UpdateUserFirstLastNameMutation = { __typename?: 'RootMutationType', updateUserFirstLastName?: { __typename?: 'User', id: any } | null | undefined };

export type UpdateOrderSubscriptionAddressMutationVariables = Exact<{
  subscriptionId: Scalars['UUID4'];
  input: UpdateOrderSubscriptionAddressInput;
}>;


export type UpdateOrderSubscriptionAddressMutation = { __typename?: 'RootMutationType', updateOrderSubscriptionAddress?: { __typename?: 'OrderSubscription', id: any } | null | undefined };

export type UpdateOrderSubscriptionPaymentMutationVariables = Exact<{
  id: Scalars['UUID4'];
  input: UpdateOrderSubscriptionPaymentInput;
}>;


export type UpdateOrderSubscriptionPaymentMutation = { __typename?: 'RootMutationType', updateOrderSubscriptionPayment?: { __typename?: 'OrderSubscription', id: any } | null | undefined };

export type UpdateSubscriptionMutationVariables = Exact<{
  id: Scalars['UUID4'];
  input: UpdateOrderSubscriptionInput;
}>;


export type UpdateSubscriptionMutation = { __typename?: 'RootMutationType', updateOrderSubscription?: { __typename?: 'OrderSubscription', id: any, title: string } | null | undefined };

export type UpdateSubscriptionStatusMutationVariables = Exact<{
  id: Scalars['UUID4'];
  input: UpdateOrderSubscriptionStatusInput;
}>;


export type UpdateSubscriptionStatusMutation = { __typename?: 'RootMutationType', updateOrderSubscriptionStatus?: { __typename?: 'OrderSubscription', id: any } | null | undefined };

export type UpdateUserAddressMutationVariables = Exact<{
  id: Scalars['UUID4'];
  input: UserAddressUpdateInput;
}>;


export type UpdateUserAddressMutation = { __typename?: 'RootMutationType', updateUserAddress: { __typename?: 'Address', id: any } };

export type UpdateUserAddressDefaultMutationVariables = Exact<{
  id: Scalars['UUID4'];
  input: UserAddressIsDefaultInput;
}>;


export type UpdateUserAddressDefaultMutation = { __typename?: 'RootMutationType', updateUserAddressIsDefault: { __typename?: 'Address', id: any } };

export type UserAddressVerificationMutationVariables = Exact<{
  input: VerifyAddressInput;
}>;


export type UserAddressVerificationMutation = { __typename?: 'RootMutationType', userAddressVerification?: { __typename?: 'VerifyAddressPayload', firstName: string, lastName: string, company?: string | null | undefined, countryCode: string, city: string, state?: string | null | undefined, zip: string, line1: string, line2?: string | null | undefined, specialInstructions?: string | null | undefined } | null | undefined };

export type ValidatePasswordQueryVariables = Exact<{
  password: Scalars['String'];
}>;


export type ValidatePasswordQuery = { __typename?: 'RootQueryType', validatePassword: Array<{ __typename?: 'PasswordRequirement', msg: string, satisfied: boolean }> };

export type ValidateSessionMutationVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type ValidateSessionMutation = { __typename?: 'RootMutationType', validateSession?: { __typename?: 'CheckoutSession', id: any, hasGasExchangeItems: boolean, stage: SessionStage, customerPo?: string | null | undefined, orderId?: string | null | undefined, requestedDeliveryDate?: string | null | undefined, submissionUid: any, activeAccount?: { __typename?: 'ActiveAccount', id: any, managedAddressesOnly?: boolean | null | undefined, name: string, type: string, isInvoiced?: boolean | null | undefined } | null | undefined, cart?: { __typename?: 'Cart', appId: any, id: any, items?: Array<{ __typename?: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, dynamicBundle: { __typename?: 'DynamicBundle', tag: string }, dynamicBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined, primaryBundleItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, analyticsDetails?: any | null | undefined, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, gtin: string } }> | null | undefined } | { __typename?: 'CartItem', analyticsDetails?: any | null | undefined, id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, item: { __typename?: 'Item', brandName?: string | null | undefined, compareAtPrice: number, id: any, gtin: string, imgUrl?: string | null | undefined, inventoryQty?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, price?: number | null | undefined, slug?: string | null | undefined, title?: string | null | undefined, subItems?: Array<{ __typename?: 'BundleItem', imgUrl?: string | null | undefined, title?: string | null | undefined } | null | undefined> | null | undefined } } | null | undefined> | null | undefined, user?: { __typename?: 'User', id: any } | null | undefined } | null | undefined, contactInfo?: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'ShippingAddress', addressId?: any | null | undefined, city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, isAddressValidated?: boolean | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, taxId?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, giftInfo?: { __typename?: 'GiftInfo', gifteeEmail?: string | null | undefined, gifteeMessage?: string | null | undefined, giftorName?: string | null | undefined } | null | undefined, payment?: { __typename?: 'Payment', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: AllowedPaymentMethod | null | undefined, token?: string | null | undefined, clientConfirmationToken?: string | null | undefined, paymentStatus?: string | null | undefined, lastErrorCode?: string | null | undefined, billingAddress?: { __typename?: 'BillingAddress', city: string, state?: string | null | undefined, countryCode: string, zip: string, firstName: string, lastName: string, line1: string, line2?: string | null | undefined } | null | undefined } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, price: { __typename?: 'Price', discount: number, shipping: number, subtotal: number, taxRegulatoryTotal: number, taxSalesTotal: number, total: number, lineItems: Array<{ __typename: 'BundleLineItem', bundleId: any, imgUrl?: string | null | undefined, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subtotal: number, title: string, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, bundleComponents: Array<{ __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', title?: string | null | undefined } } | null | undefined> | null | undefined } | null | undefined>, primaryComponent: { __typename?: 'BundleComponent', title?: string | null | undefined, subtitle?: string | null | undefined, componentPriceItems?: Array<{ __typename?: 'DynamicBundleItem', itemId: any, quantity: number, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, item: { __typename?: 'Item', gtin: string, title?: string | null | undefined } } | null | undefined> | null | undefined } } | { __typename: 'LineItem', gtin: string, imgUrl?: string | null | undefined, itemId: any, itemNotifications: Array<string>, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, title: string, customizations?: Array<{ __typename: 'GatoradeIdBottle', bottleLidFeatureText?: string | null | undefined, bottleLidFeatureType?: string | null | undefined, bottleLidLogo?: string | null | undefined, bottleLidLogoImage?: string | null | undefined, bottleLidNumber?: string | null | undefined, bottleLidNumberType?: string | null | undefined, bottleLidPattern?: string | null | undefined, bottleLidPrimaryColor?: string | null | undefined, bottleLidPrintFileUrl?: string | null | undefined, bottleLidSecondaryColor?: string | null | undefined, bottleLidThumbnailImage?: string | null | undefined, bottleSideFeatureLogo?: string | null | undefined, bottleSideFeatureText?: string | null | undefined, bottleSideFeatureType?: string | null | undefined, bottleSideLogoUrl?: string | null | undefined, bottleSideMascotName?: string | null | undefined, bottleSidePattern?: string | null | undefined, bottleSidePatternImage?: string | null | undefined, bottleSidePrimaryColor?: string | null | undefined, bottleSidePrimaryColorValue?: string | null | undefined, bottleSidePrintFileUrl?: string | null | undefined, bottleSideSecondaryColor?: string | null | undefined, bottleSideSecondaryColorValue?: string | null | undefined, bottleSideThumbnailImage?: string | null | undefined, description?: string | null | undefined } | { __typename: 'GatoradeTowel', towelFeatureLogo?: string | null | undefined, towelFeatureText?: string | null | undefined, towelFeatureType?: string | null | undefined, towelLogoUrl?: string | null | undefined, towelMascotName?: string | null | undefined, towelPattern?: string | null | undefined, towelPatternImage?: string | null | undefined, towelPrimaryColor?: string | null | undefined, towelPrimaryColorValue?: string | null | undefined, towelPrintFileUrl?: string | null | undefined, towelSecondaryColor?: string | null | undefined, towelSecondaryColorValue?: string | null | undefined, towelThumbnailImage?: string | null | undefined } | { __typename: 'LegacyCustomization', number?: string | null | undefined, text?: string | null | undefined, patternId?: string | null | undefined }> | null | undefined, discounts: Array<{ __typename?: 'LineItemDiscount', amount: number, name?: string | null | undefined, type: DiscountType, category: DiscountCategory, discountId: any }>, subscription?: { __typename?: 'SubscriptionMetadata', discountAmount?: number | null | undefined, discountType?: DiscountType | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subscriptionPrice?: number | null | undefined } | null | undefined }>, loyaltyData?: { __typename?: 'LoyaltyData', totalAmount: number, totalEarnedPoints: number, totalPoints: number } | null | undefined, giftCards?: Array<{ __typename?: 'EmbeddedGiftCard', amount: number, appliedAmount: number, last4: string, type: string } | null | undefined> | null | undefined, promoCodeDiscounts: Array<{ __typename?: 'PromoCodeDiscount', promoCode: string, type: DiscountType, amount: number, discountAmount: number, discountId: any }>, regulatoryTaxTypes: Array<{ __typename?: 'RegulatoryTaxType', code: string, id: string, total: number }> }, shippingAddresses: Array<{ __typename?: 'SavedShippingAddress', addressId: any, city: string, countryCode: string, firstName?: string | null | undefined, isDefault: boolean, lastName?: string | null | undefined, line1: string, line2?: string | null | undefined, nickname?: string | null | undefined, phoneNumber?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated: boolean, zip: string }>, shippingMethodConfig?: { __typename?: 'ShippingMethodConfig', description?: string | null | undefined, id: any, name: string, rate: number } | null | undefined, user?: { __typename?: 'User', email: string, firstName?: string | null | undefined, id: any, lastName?: string | null | undefined } | null | undefined } | null | undefined };

export type VerifiedAddressFragment = { __typename?: 'VerifyAddressPayload', firstName: string, lastName: string, company?: string | null | undefined, countryCode: string, city: string, state?: string | null | undefined, zip: string, line1: string, line2?: string | null | undefined, specialInstructions?: string | null | undefined };

export type VerifyAddressMutationVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type VerifyAddressMutation = { __typename?: 'RootMutationType', verifyAddress?: { __typename?: 'CheckoutSession', id: any } | null | undefined };

export type VerifyUserMutationVariables = Exact<{
  input: VerifyUserInput;
}>;


export type VerifyUserMutation = { __typename?: 'RootMutationType', verifyUser?: { __typename?: 'User', id: any, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined };

export const AddressFragmentDoc = gql`
    fragment Address on Address {
  city
  company
  countryCode
  firstName
  id
  lastName
  line1
  line2
  phoneNumber
  state
  nickname
  specialInstructions
  zip
  isDefault
  isRemovable
}
    `;
export const AllocationFragmentDoc = gql`
    fragment Allocation on Credit {
  status
  type
  availableAmount
  spentAmount
  activeFrom
  activeUntil
}
    `;
export const ApplePayCardFragmentDoc = gql`
    fragment ApplePayCard on ApplePayCard {
  billingAddress {
    company
    firstName
    lastName
    streetAddress
    extendedAddress
    locality
    region
    postalCode
    countryCodeAlpha2
  }
  customerId
  createdAt
  default
  token
  cardType
  cardholderName
  last4
}
    `;
export const AvailablePaymentMethodsFragmentDoc = gql`
    fragment AvailablePaymentMethods on AvailablePaymentMethods {
  allowedPaymentMethods
  creditCard {
    savedCards {
      billingAddress {
        company
        countryCode
        line2
        firstName
        lastName
        city
        zip
        state
        line1
      }
      cardType
      cardholderName
      isDefault
      expirationMonth
      expirationYear
      lastFour
      token
    }
    validCardTypes {
      brandImgUrl
      id
      name
    }
  }
  paypal {
    savedAccounts {
      isDefault
      email
      token
    }
  }
  allocatedCredit {
    availableAmount
    id
    type
  }
}
    `;
export const CustomizationFragmentDoc = gql`
    fragment Customization on Customization {
  __typename
  ... on GatoradeIdBottle {
    bottleLidFeatureText
    bottleLidFeatureType
    bottleLidLogo
    bottleLidLogoImage
    bottleLidNumber
    bottleLidNumberType
    bottleLidPattern
    bottleLidPrimaryColor
    bottleLidPrintFileUrl
    bottleLidSecondaryColor
    bottleLidThumbnailImage
    bottleSideFeatureLogo
    bottleSideFeatureText
    bottleSideFeatureType
    bottleSideLogoUrl
    bottleSideMascotName
    bottleSidePattern
    bottleSidePatternImage
    bottleSidePrimaryColor
    bottleSidePrimaryColorValue
    bottleSidePrintFileUrl
    bottleSideSecondaryColor
    bottleSideSecondaryColorValue
    bottleSideThumbnailImage
    description
  }
  ... on GatoradeTowel {
    towelFeatureLogo
    towelFeatureText
    towelFeatureType
    towelLogoUrl
    towelMascotName
    towelPattern
    towelPatternImage
    towelPrimaryColor
    towelPrimaryColorValue
    towelPrintFileUrl
    towelSecondaryColor
    towelSecondaryColorValue
    towelThumbnailImage
  }
  ... on LegacyCustomization {
    number
    text
    patternId
  }
}
    `;
export const GiftCardFragmentDoc = gql`
    fragment GiftCard on EmbeddedGiftCard {
  amount
  appliedAmount
  last4
  type
}
    `;
export const LineItemFragmentDoc = gql`
    fragment LineItem on PriceItemsAndBundleItems {
  __typename
  ... on BundleLineItem {
    bundleId
    discounts {
      amount
      name
      type
      category
      discountId
    }
    bundleComponents {
      title
      subtitle
      componentPriceItems {
        customizations {
          ...Customization
        }
        itemId
        quantity
        item {
          title
        }
      }
    }
    primaryComponent {
      title
      subtitle
      componentPriceItems {
        customizations {
          ...Customization
        }
        itemId
        quantity
        item {
          gtin
          title
        }
      }
    }
    imgUrl
    itemNotifications
    perUnitPrice
    quantity
    strikethroughUnitPrice
    subtotal
    title
  }
  ... on LineItem {
    customizations {
      ...Customization
    }
    discounts {
      amount
      name
      type
      category
      discountId
    }
    gtin
    imgUrl
    itemId
    itemNotifications
    perUnitPrice
    quantity
    strikethroughUnitPrice
    subscription {
      discountAmount
      discountType
      subscriptionIntervalInDays
      subscriptionPrice
    }
    subscriptionIntervalInDays
    subtotal
    title
  }
}
    ${CustomizationFragmentDoc}`;
export const PriceFragmentDoc = gql`
    fragment Price on Price {
  discount
  lineItems {
    ...LineItem
  }
  loyaltyData {
    totalAmount
    totalEarnedPoints
    totalPoints
  }
  giftCards {
    ...GiftCard
  }
  promoCodeDiscounts {
    promoCode
    type
    amount
    discountAmount
    discountId
  }
  regulatoryTaxTypes {
    code
    id
    total
  }
  shipping
  subtotal
  taxRegulatoryTotal
  taxSalesTotal
  total
}
    ${LineItemFragmentDoc}
${GiftCardFragmentDoc}`;
export const CheckoutSessionFragmentDoc = gql`
    fragment CheckoutSession on CheckoutSession {
  id
  hasGasExchangeItems
  activeAccount {
    id
    managedAddressesOnly
    name
    type
    isInvoiced
  }
  cart {
    appId
    id
    items {
      ... on CartItem {
        analyticsDetails
        id
        item {
          brandName
          compareAtPrice
          id
          gtin
          imgUrl
          inventoryQty
          isOutOfStock
          minOrderQty
          price
          slug
          subItems {
            imgUrl
            title
          }
          title
        }
        quantity
        subscriptionIntervalInDays
      }
      ... on BundleLineItem {
        bundleId
        dynamicBundle {
          tag
        }
        dynamicBundleItems {
          customizations {
            ...Customization
          }
          itemId
          quantity
          item {
            title
            inventoryQty
            isOutOfStock
            gtin
          }
        }
        imgUrl
        perUnitPrice
        primaryBundleItems {
          customizations {
            ...Customization
          }
          itemId
          quantity
          item {
            title
            inventoryQty
            isOutOfStock
            gtin
          }
          analyticsDetails
        }
        quantity
        strikethroughUnitPrice
        subtotal
        title
      }
    }
    user {
      id
    }
  }
  stage
  contactInfo {
    email
    phone
    shippingAddress {
      addressId
      city
      company
      countryCode
      firstName
      isAddressValidated
      lastName
      line1
      line2
      nickname
      specialInstructions
      state
      taxId
      zip
    }
  }
  customerPo
  giftInfo {
    gifteeEmail
    gifteeMessage
    giftorName
  }
  orderId
  payment {
    billingAddress {
      city
      state
      countryCode
      zip
      firstName
      lastName
      line1
      line2
    }
    isBillingEqualShipping
    paymentMethod
    token
    clientConfirmationToken
    paymentStatus
    lastErrorCode
  }
  giftCards {
    ...GiftCard
  }
  price {
    ...Price
  }
  requestedDeliveryDate
  shippingAddresses {
    addressId
    city
    countryCode
    firstName
    isDefault
    lastName
    line1
    line2
    nickname
    phoneNumber
    specialInstructions
    state
    validated
    zip
  }
  shippingMethodConfig {
    description
    id
    name
    rate
  }
  submissionUid
  user {
    email
    firstName
    id
    lastName
  }
}
    ${CustomizationFragmentDoc}
${GiftCardFragmentDoc}
${PriceFragmentDoc}`;
export const CreditCardFragmentDoc = gql`
    fragment CreditCard on CreditCard {
  billingAddress {
    company
    firstName
    lastName
    line1
    line2
    city
    state
    zip
    countryCode
  }
  cardType
  cardholderName
  expirationMonth
  expirationYear
  isDefault
  isRemovable
  lastFour
  token
}
    `;
export const DiscountFragmentDoc = gql`
    fragment Discount on Discount {
  id
  activeFrom
  activeUntil
  amount
  appId
  isPercent
  isPromoCodeRequired
  limit
  promoCode
  type
  typeDependentValue
  usage
}
    `;
export const InvoicedAddressFragmentDoc = gql`
    fragment InvoicedAddress on InvoicedAddress {
  city
  company
  countryCode
  firstName
  id
  lastName
  line1
  line2
  state
  zip
  phoneNumber
}
    `;
export const PaypalAccountFragmentDoc = gql`
    fragment PaypalAccount on PaypalAccount {
  email
  isRemovable
  token
  isDefault
}
    `;
export const VerifiedAddressFragmentDoc = gql`
    fragment VerifiedAddress on VerifyAddressPayload {
  firstName
  lastName
  company
  countryCode
  city
  state
  zip
  line1
  line2
  specialInstructions
}
    `;
export const ActiveAccountDocument = gql`
    query ActiveAccount {
  activeAccount {
    type
    name
    tags
    credits(search: {status: [ACTIVE], type: ALLOCATION, frozen: false}) {
      ...Allocation
    }
    invoicing {
      enabled
      addresses {
        ...InvoicedAddress
      }
    }
  }
}
    ${AllocationFragmentDoc}
${InvoicedAddressFragmentDoc}`;

/**
 * __useActiveAccountQuery__
 *
 * To run a query within a React component, call `useActiveAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveAccountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActiveAccountQuery, ActiveAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActiveAccountQuery, ActiveAccountQueryVariables>(ActiveAccountDocument, options);
      }
export function useActiveAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActiveAccountQuery, ActiveAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActiveAccountQuery, ActiveAccountQueryVariables>(ActiveAccountDocument, options);
        }
export type ActiveAccountQueryHookResult = ReturnType<typeof useActiveAccountQuery>;
export type ActiveAccountLazyQueryHookResult = ReturnType<typeof useActiveAccountLazyQuery>;
export type ActiveAccountQueryResult = Apollo.QueryResult<ActiveAccountQuery, ActiveAccountQueryVariables>;
export const AddGiftCardDocument = gql`
    mutation addGiftCard($id: UUID4!, $input: GiftCardInput!) {
  addGiftCard(id: $id, input: $input) {
    ...CheckoutSession
  }
}
    ${CheckoutSessionFragmentDoc}`;
export type AddGiftCardMutationFn = Apollo.MutationFunction<AddGiftCardMutation, AddGiftCardMutationVariables>;

/**
 * __useAddGiftCardMutation__
 *
 * To run a mutation, you first call `useAddGiftCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGiftCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGiftCardMutation, { data, loading, error }] = useAddGiftCardMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddGiftCardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddGiftCardMutation, AddGiftCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddGiftCardMutation, AddGiftCardMutationVariables>(AddGiftCardDocument, options);
      }
export type AddGiftCardMutationHookResult = ReturnType<typeof useAddGiftCardMutation>;
export type AddGiftCardMutationResult = Apollo.MutationResult<AddGiftCardMutation>;
export type AddGiftCardMutationOptions = Apollo.BaseMutationOptions<AddGiftCardMutation, AddGiftCardMutationVariables>;
export const ApplyDiscountDocument = gql`
    mutation applyDiscount($id: UUID4!, $input: DiscountInput!) {
  applyDiscount(id: $id, input: $input) {
    ...CheckoutSession
  }
}
    ${CheckoutSessionFragmentDoc}`;
export type ApplyDiscountMutationFn = Apollo.MutationFunction<ApplyDiscountMutation, ApplyDiscountMutationVariables>;

/**
 * __useApplyDiscountMutation__
 *
 * To run a mutation, you first call `useApplyDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyDiscountMutation, { data, loading, error }] = useApplyDiscountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyDiscountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ApplyDiscountMutation, ApplyDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ApplyDiscountMutation, ApplyDiscountMutationVariables>(ApplyDiscountDocument, options);
      }
export type ApplyDiscountMutationHookResult = ReturnType<typeof useApplyDiscountMutation>;
export type ApplyDiscountMutationResult = Apollo.MutationResult<ApplyDiscountMutation>;
export type ApplyDiscountMutationOptions = Apollo.BaseMutationOptions<ApplyDiscountMutation, ApplyDiscountMutationVariables>;
export const ApplySavedShippingAddressDocument = gql`
    mutation applySavedShippingAddress($additionalPhoneNumber: String, $addressId: UUID4!, $id: UUID4!) {
  applySavedShippingAddress(
    additionalPhoneNumber: $additionalPhoneNumber
    addressId: $addressId
    id: $id
  ) {
    ...CheckoutSession
  }
}
    ${CheckoutSessionFragmentDoc}`;
export type ApplySavedShippingAddressMutationFn = Apollo.MutationFunction<ApplySavedShippingAddressMutation, ApplySavedShippingAddressMutationVariables>;

/**
 * __useApplySavedShippingAddressMutation__
 *
 * To run a mutation, you first call `useApplySavedShippingAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplySavedShippingAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applySavedShippingAddressMutation, { data, loading, error }] = useApplySavedShippingAddressMutation({
 *   variables: {
 *      additionalPhoneNumber: // value for 'additionalPhoneNumber'
 *      addressId: // value for 'addressId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplySavedShippingAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ApplySavedShippingAddressMutation, ApplySavedShippingAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ApplySavedShippingAddressMutation, ApplySavedShippingAddressMutationVariables>(ApplySavedShippingAddressDocument, options);
      }
export type ApplySavedShippingAddressMutationHookResult = ReturnType<typeof useApplySavedShippingAddressMutation>;
export type ApplySavedShippingAddressMutationResult = Apollo.MutationResult<ApplySavedShippingAddressMutation>;
export type ApplySavedShippingAddressMutationOptions = Apollo.BaseMutationOptions<ApplySavedShippingAddressMutation, ApplySavedShippingAddressMutationVariables>;
export const ArchiveRegistrationRecordDocument = gql`
    mutation archiveRegistrationRecord($id: UUID4!) {
  archiveRegistrationRecord(id: $id) {
    id
  }
}
    `;
export type ArchiveRegistrationRecordMutationFn = Apollo.MutationFunction<ArchiveRegistrationRecordMutation, ArchiveRegistrationRecordMutationVariables>;

/**
 * __useArchiveRegistrationRecordMutation__
 *
 * To run a mutation, you first call `useArchiveRegistrationRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveRegistrationRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveRegistrationRecordMutation, { data, loading, error }] = useArchiveRegistrationRecordMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveRegistrationRecordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveRegistrationRecordMutation, ArchiveRegistrationRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveRegistrationRecordMutation, ArchiveRegistrationRecordMutationVariables>(ArchiveRegistrationRecordDocument, options);
      }
export type ArchiveRegistrationRecordMutationHookResult = ReturnType<typeof useArchiveRegistrationRecordMutation>;
export type ArchiveRegistrationRecordMutationResult = Apollo.MutationResult<ArchiveRegistrationRecordMutation>;
export type ArchiveRegistrationRecordMutationOptions = Apollo.BaseMutationOptions<ArchiveRegistrationRecordMutation, ArchiveRegistrationRecordMutationVariables>;
export const AvailablePaymentMethodsDocument = gql`
    query availablePaymentMethods($id: UUID4!) {
  checkoutSession(id: $id) {
    availablePaymentMethods {
      ...AvailablePaymentMethods
    }
  }
}
    ${AvailablePaymentMethodsFragmentDoc}`;

/**
 * __useAvailablePaymentMethodsQuery__
 *
 * To run a query within a React component, call `useAvailablePaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailablePaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailablePaymentMethodsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAvailablePaymentMethodsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AvailablePaymentMethodsQuery, AvailablePaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AvailablePaymentMethodsQuery, AvailablePaymentMethodsQueryVariables>(AvailablePaymentMethodsDocument, options);
      }
export function useAvailablePaymentMethodsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AvailablePaymentMethodsQuery, AvailablePaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AvailablePaymentMethodsQuery, AvailablePaymentMethodsQueryVariables>(AvailablePaymentMethodsDocument, options);
        }
export type AvailablePaymentMethodsQueryHookResult = ReturnType<typeof useAvailablePaymentMethodsQuery>;
export type AvailablePaymentMethodsLazyQueryHookResult = ReturnType<typeof useAvailablePaymentMethodsLazyQuery>;
export type AvailablePaymentMethodsQueryResult = Apollo.QueryResult<AvailablePaymentMethodsQuery, AvailablePaymentMethodsQueryVariables>;
export const AvailableShippingMethodsDocument = gql`
    query availableShippingMethods($id: UUID4!) {
  checkoutSession(id: $id) {
    availableShippingMethods {
      locationDescription
      id
      title
      rate
      code
    }
  }
}
    `;

/**
 * __useAvailableShippingMethodsQuery__
 *
 * To run a query within a React component, call `useAvailableShippingMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableShippingMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableShippingMethodsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAvailableShippingMethodsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AvailableShippingMethodsQuery, AvailableShippingMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AvailableShippingMethodsQuery, AvailableShippingMethodsQueryVariables>(AvailableShippingMethodsDocument, options);
      }
export function useAvailableShippingMethodsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AvailableShippingMethodsQuery, AvailableShippingMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AvailableShippingMethodsQuery, AvailableShippingMethodsQueryVariables>(AvailableShippingMethodsDocument, options);
        }
export type AvailableShippingMethodsQueryHookResult = ReturnType<typeof useAvailableShippingMethodsQuery>;
export type AvailableShippingMethodsLazyQueryHookResult = ReturnType<typeof useAvailableShippingMethodsLazyQuery>;
export type AvailableShippingMethodsQueryResult = Apollo.QueryResult<AvailableShippingMethodsQuery, AvailableShippingMethodsQueryVariables>;
export const ChangeUserPasswordDocument = gql`
    mutation ChangeUserPassword($input: ChangeUserPasswordInput!) {
  changeUserPassword(input: $input) {
    id
  }
}
    `;
export type ChangeUserPasswordMutationFn = Apollo.MutationFunction<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>;

/**
 * __useChangeUserPasswordMutation__
 *
 * To run a mutation, you first call `useChangeUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUserPasswordMutation, { data, loading, error }] = useChangeUserPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeUserPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>(ChangeUserPasswordDocument, options);
      }
export type ChangeUserPasswordMutationHookResult = ReturnType<typeof useChangeUserPasswordMutation>;
export type ChangeUserPasswordMutationResult = Apollo.MutationResult<ChangeUserPasswordMutation>;
export type ChangeUserPasswordMutationOptions = Apollo.BaseMutationOptions<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>;
export const CreateCartFromOrderDocument = gql`
    mutation CreateCartFromOrder($orderId: UUID4!) {
  createTemporaryCartFromOrder(orderId: $orderId) {
    id
  }
}
    `;
export type CreateCartFromOrderMutationFn = Apollo.MutationFunction<CreateCartFromOrderMutation, CreateCartFromOrderMutationVariables>;

/**
 * __useCreateCartFromOrderMutation__
 *
 * To run a mutation, you first call `useCreateCartFromOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCartFromOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCartFromOrderMutation, { data, loading, error }] = useCreateCartFromOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCreateCartFromOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCartFromOrderMutation, CreateCartFromOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCartFromOrderMutation, CreateCartFromOrderMutationVariables>(CreateCartFromOrderDocument, options);
      }
export type CreateCartFromOrderMutationHookResult = ReturnType<typeof useCreateCartFromOrderMutation>;
export type CreateCartFromOrderMutationResult = Apollo.MutationResult<CreateCartFromOrderMutation>;
export type CreateCartFromOrderMutationOptions = Apollo.BaseMutationOptions<CreateCartFromOrderMutation, CreateCartFromOrderMutationVariables>;
export const CreatePaymentClientTokenDocument = gql`
    mutation CreatePaymentClientToken {
  createPaymentClientToken {
    token
  }
}
    `;
export type CreatePaymentClientTokenMutationFn = Apollo.MutationFunction<CreatePaymentClientTokenMutation, CreatePaymentClientTokenMutationVariables>;

/**
 * __useCreatePaymentClientTokenMutation__
 *
 * To run a mutation, you first call `useCreatePaymentClientTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentClientTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentClientTokenMutation, { data, loading, error }] = useCreatePaymentClientTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreatePaymentClientTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePaymentClientTokenMutation, CreatePaymentClientTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePaymentClientTokenMutation, CreatePaymentClientTokenMutationVariables>(CreatePaymentClientTokenDocument, options);
      }
export type CreatePaymentClientTokenMutationHookResult = ReturnType<typeof useCreatePaymentClientTokenMutation>;
export type CreatePaymentClientTokenMutationResult = Apollo.MutationResult<CreatePaymentClientTokenMutation>;
export type CreatePaymentClientTokenMutationOptions = Apollo.BaseMutationOptions<CreatePaymentClientTokenMutation, CreatePaymentClientTokenMutationVariables>;
export const CreatePaymentMethodDocument = gql`
    mutation CreatePaymentMethod($input: CreatePaymentMethodInput!) {
  createPaymentMethod(input: $input) {
    __typename
  }
}
    `;
export type CreatePaymentMethodMutationFn = Apollo.MutationFunction<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>;

/**
 * __useCreatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useCreatePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentMethodMutation, { data, loading, error }] = useCreatePaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaymentMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>(CreatePaymentMethodDocument, options);
      }
export type CreatePaymentMethodMutationHookResult = ReturnType<typeof useCreatePaymentMethodMutation>;
export type CreatePaymentMethodMutationResult = Apollo.MutationResult<CreatePaymentMethodMutation>;
export type CreatePaymentMethodMutationOptions = Apollo.BaseMutationOptions<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>;
export const CreateUserAddressDocument = gql`
    mutation CreateUserAddress($input: UserAddressInput!) {
  createUserAddress(input: $input) {
    id
  }
}
    `;
export type CreateUserAddressMutationFn = Apollo.MutationFunction<CreateUserAddressMutation, CreateUserAddressMutationVariables>;

/**
 * __useCreateUserAddressMutation__
 *
 * To run a mutation, you first call `useCreateUserAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserAddressMutation, { data, loading, error }] = useCreateUserAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserAddressMutation, CreateUserAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUserAddressMutation, CreateUserAddressMutationVariables>(CreateUserAddressDocument, options);
      }
export type CreateUserAddressMutationHookResult = ReturnType<typeof useCreateUserAddressMutation>;
export type CreateUserAddressMutationResult = Apollo.MutationResult<CreateUserAddressMutation>;
export type CreateUserAddressMutationOptions = Apollo.BaseMutationOptions<CreateUserAddressMutation, CreateUserAddressMutationVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    id
    email
    firstName
    lastName
    userString
    addresses {
      ...Address
    }
    paymentMethods {
      creditCards {
        billingAddress {
          firstName
          lastName
          line1
          line2
          city
          state
          zip
          countryCode
        }
        cardType
        cardholderName
        expirationMonth
        expirationYear
        isDefault
        isRemovable
        lastFour
        token
      }
      paypalAccounts {
        isDefault
        isRemovable
        email
        token
      }
    }
  }
}
    ${AddressFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const CurrentUserIdDocument = gql`
    query CurrentUserId {
  currentUser {
    id
  }
}
    `;

/**
 * __useCurrentUserIdQuery__
 *
 * To run a query within a React component, call `useCurrentUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentUserIdQuery, CurrentUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentUserIdQuery, CurrentUserIdQueryVariables>(CurrentUserIdDocument, options);
      }
export function useCurrentUserIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentUserIdQuery, CurrentUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentUserIdQuery, CurrentUserIdQueryVariables>(CurrentUserIdDocument, options);
        }
export type CurrentUserIdQueryHookResult = ReturnType<typeof useCurrentUserIdQuery>;
export type CurrentUserIdLazyQueryHookResult = ReturnType<typeof useCurrentUserIdLazyQuery>;
export type CurrentUserIdQueryResult = Apollo.QueryResult<CurrentUserIdQuery, CurrentUserIdQueryVariables>;
export const CurrentUserPaymentMethodsDocument = gql`
    query CurrentUserPaymentMethods {
  currentUser {
    id
    paymentMethods {
      creditCards {
        isDefault
      }
      paypalAccounts {
        isDefault
      }
    }
  }
}
    `;

/**
 * __useCurrentUserPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useCurrentUserPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserPaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserPaymentMethodsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentUserPaymentMethodsQuery, CurrentUserPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentUserPaymentMethodsQuery, CurrentUserPaymentMethodsQueryVariables>(CurrentUserPaymentMethodsDocument, options);
      }
export function useCurrentUserPaymentMethodsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentUserPaymentMethodsQuery, CurrentUserPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentUserPaymentMethodsQuery, CurrentUserPaymentMethodsQueryVariables>(CurrentUserPaymentMethodsDocument, options);
        }
export type CurrentUserPaymentMethodsQueryHookResult = ReturnType<typeof useCurrentUserPaymentMethodsQuery>;
export type CurrentUserPaymentMethodsLazyQueryHookResult = ReturnType<typeof useCurrentUserPaymentMethodsLazyQuery>;
export type CurrentUserPaymentMethodsQueryResult = Apollo.QueryResult<CurrentUserPaymentMethodsQuery, CurrentUserPaymentMethodsQueryVariables>;
export const CurrentUserRegistrationRecordsDocument = gql`
    query CurrentUserRegistrationRecords {
  currentUser {
    registrationRecords {
      id
      purchaseLocation
      purchaseDate
      warrantyExpirationDate
      status
      item {
        title
        imgUrl
        itemLinks {
          type
          url
        }
      }
    }
  }
}
    `;

/**
 * __useCurrentUserRegistrationRecordsQuery__
 *
 * To run a query within a React component, call `useCurrentUserRegistrationRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserRegistrationRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserRegistrationRecordsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserRegistrationRecordsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentUserRegistrationRecordsQuery, CurrentUserRegistrationRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentUserRegistrationRecordsQuery, CurrentUserRegistrationRecordsQueryVariables>(CurrentUserRegistrationRecordsDocument, options);
      }
export function useCurrentUserRegistrationRecordsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentUserRegistrationRecordsQuery, CurrentUserRegistrationRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentUserRegistrationRecordsQuery, CurrentUserRegistrationRecordsQueryVariables>(CurrentUserRegistrationRecordsDocument, options);
        }
export type CurrentUserRegistrationRecordsQueryHookResult = ReturnType<typeof useCurrentUserRegistrationRecordsQuery>;
export type CurrentUserRegistrationRecordsLazyQueryHookResult = ReturnType<typeof useCurrentUserRegistrationRecordsLazyQuery>;
export type CurrentUserRegistrationRecordsQueryResult = Apollo.QueryResult<CurrentUserRegistrationRecordsQuery, CurrentUserRegistrationRecordsQueryVariables>;
export const CurrentUserWithCartDocument = gql`
    query CurrentUserWithCart {
  currentUser {
    cart {
      id
    }
    id
  }
}
    `;

/**
 * __useCurrentUserWithCartQuery__
 *
 * To run a query within a React component, call `useCurrentUserWithCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserWithCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserWithCartQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserWithCartQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentUserWithCartQuery, CurrentUserWithCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentUserWithCartQuery, CurrentUserWithCartQueryVariables>(CurrentUserWithCartDocument, options);
      }
export function useCurrentUserWithCartLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentUserWithCartQuery, CurrentUserWithCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentUserWithCartQuery, CurrentUserWithCartQueryVariables>(CurrentUserWithCartDocument, options);
        }
export type CurrentUserWithCartQueryHookResult = ReturnType<typeof useCurrentUserWithCartQuery>;
export type CurrentUserWithCartLazyQueryHookResult = ReturnType<typeof useCurrentUserWithCartLazyQuery>;
export type CurrentUserWithCartQueryResult = Apollo.QueryResult<CurrentUserWithCartQuery, CurrentUserWithCartQueryVariables>;
export const DeleteCreditCardDocument = gql`
    mutation DeleteCreditCard($input: DeleteCreditCardInput!) {
  deleteCreditCard(input: $input)
}
    `;
export type DeleteCreditCardMutationFn = Apollo.MutationFunction<DeleteCreditCardMutation, DeleteCreditCardMutationVariables>;

/**
 * __useDeleteCreditCardMutation__
 *
 * To run a mutation, you first call `useDeleteCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCreditCardMutation, { data, loading, error }] = useDeleteCreditCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCreditCardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCreditCardMutation, DeleteCreditCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCreditCardMutation, DeleteCreditCardMutationVariables>(DeleteCreditCardDocument, options);
      }
export type DeleteCreditCardMutationHookResult = ReturnType<typeof useDeleteCreditCardMutation>;
export type DeleteCreditCardMutationResult = Apollo.MutationResult<DeleteCreditCardMutation>;
export type DeleteCreditCardMutationOptions = Apollo.BaseMutationOptions<DeleteCreditCardMutation, DeleteCreditCardMutationVariables>;
export const DeleteUserAddressDocument = gql`
    mutation DeleteUserAddress($id: UUID4!) {
  deleteUserAddress(id: $id) {
    id
  }
}
    `;
export type DeleteUserAddressMutationFn = Apollo.MutationFunction<DeleteUserAddressMutation, DeleteUserAddressMutationVariables>;

/**
 * __useDeleteUserAddressMutation__
 *
 * To run a mutation, you first call `useDeleteUserAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserAddressMutation, { data, loading, error }] = useDeleteUserAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserAddressMutation, DeleteUserAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserAddressMutation, DeleteUserAddressMutationVariables>(DeleteUserAddressDocument, options);
      }
export type DeleteUserAddressMutationHookResult = ReturnType<typeof useDeleteUserAddressMutation>;
export type DeleteUserAddressMutationResult = Apollo.MutationResult<DeleteUserAddressMutation>;
export type DeleteUserAddressMutationOptions = Apollo.BaseMutationOptions<DeleteUserAddressMutation, DeleteUserAddressMutationVariables>;
export const ExtendDueDateDocument = gql`
    mutation extendDueDate($input: ExtendDueDateInput!) {
  extendDueDate(input: $input) {
    id
  }
}
    `;
export type ExtendDueDateMutationFn = Apollo.MutationFunction<ExtendDueDateMutation, ExtendDueDateMutationVariables>;

/**
 * __useExtendDueDateMutation__
 *
 * To run a mutation, you first call `useExtendDueDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtendDueDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extendDueDateMutation, { data, loading, error }] = useExtendDueDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExtendDueDateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ExtendDueDateMutation, ExtendDueDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ExtendDueDateMutation, ExtendDueDateMutationVariables>(ExtendDueDateDocument, options);
      }
export type ExtendDueDateMutationHookResult = ReturnType<typeof useExtendDueDateMutation>;
export type ExtendDueDateMutationResult = Apollo.MutationResult<ExtendDueDateMutation>;
export type ExtendDueDateMutationOptions = Apollo.BaseMutationOptions<ExtendDueDateMutation, ExtendDueDateMutationVariables>;
export const FinalizePriceDocument = gql`
    mutation finalizePrice($id: UUID4!) {
  finalizePrice(id: $id) {
    ...CheckoutSession
  }
}
    ${CheckoutSessionFragmentDoc}`;
export type FinalizePriceMutationFn = Apollo.MutationFunction<FinalizePriceMutation, FinalizePriceMutationVariables>;

/**
 * __useFinalizePriceMutation__
 *
 * To run a mutation, you first call `useFinalizePriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizePriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizePriceMutation, { data, loading, error }] = useFinalizePriceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFinalizePriceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FinalizePriceMutation, FinalizePriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FinalizePriceMutation, FinalizePriceMutationVariables>(FinalizePriceDocument, options);
      }
export type FinalizePriceMutationHookResult = ReturnType<typeof useFinalizePriceMutation>;
export type FinalizePriceMutationResult = Apollo.MutationResult<FinalizePriceMutation>;
export type FinalizePriceMutationOptions = Apollo.BaseMutationOptions<FinalizePriceMutation, FinalizePriceMutationVariables>;
export const FinalizeSessionDocument = gql`
    mutation finalizeSession($id: UUID4!) {
  finalizeSession(id: $id) {
    bazaarvoice {
      encryptedEmail
      encryptionKeyId
    }
    contactInfo {
      email
      emailOptIn
      phone
      shippingAddress {
        addressId
      }
    }
    id
    paymentRequest {
      paymentMethod
    }
    price {
      discount
      lineItems {
        ...LineItem
      }
      shipping
      subtotal
      taxSalesTotal
      total
    }
    submissionUid
    user {
      id
    }
  }
}
    ${LineItemFragmentDoc}`;
export type FinalizeSessionMutationFn = Apollo.MutationFunction<FinalizeSessionMutation, FinalizeSessionMutationVariables>;

/**
 * __useFinalizeSessionMutation__
 *
 * To run a mutation, you first call `useFinalizeSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeSessionMutation, { data, loading, error }] = useFinalizeSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFinalizeSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FinalizeSessionMutation, FinalizeSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FinalizeSessionMutation, FinalizeSessionMutationVariables>(FinalizeSessionDocument, options);
      }
export type FinalizeSessionMutationHookResult = ReturnType<typeof useFinalizeSessionMutation>;
export type FinalizeSessionMutationResult = Apollo.MutationResult<FinalizeSessionMutation>;
export type FinalizeSessionMutationOptions = Apollo.BaseMutationOptions<FinalizeSessionMutation, FinalizeSessionMutationVariables>;
export const FindAddressDocument = gql`
    query FindAddress($input: FindAddressInput!) {
  findAddress(input: $input) {
    items {
      id
      value
      description
      type
    }
  }
}
    `;

/**
 * __useFindAddressQuery__
 *
 * To run a query within a React component, call `useFindAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAddressQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindAddressQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FindAddressQuery, FindAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FindAddressQuery, FindAddressQueryVariables>(FindAddressDocument, options);
      }
export function useFindAddressLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindAddressQuery, FindAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FindAddressQuery, FindAddressQueryVariables>(FindAddressDocument, options);
        }
export type FindAddressQueryHookResult = ReturnType<typeof useFindAddressQuery>;
export type FindAddressLazyQueryHookResult = ReturnType<typeof useFindAddressLazyQuery>;
export type FindAddressQueryResult = Apollo.QueryResult<FindAddressQuery, FindAddressQueryVariables>;
export const GasExchangeListDocument = gql`
    query GasExchangeList($page: Int!, $status: GasExchangeRecordsStatus!) {
  gasExchangeRecords(
    opts: {pagination: {page: $page, limit: 10}, search: {status: $status}}
  ) {
    pagination {
      page
      totalPages
    }
    gasExchangeRecords {
      lastGasExchangeReturn {
        returnDate
      }
      id
      dueDate
      qty
      returnedQty
      status
      noOfDaysTillDueDate
      lineItem {
        title
      }
      order {
        orderId
        submittedAt
      }
    }
  }
}
    `;

/**
 * __useGasExchangeListQuery__
 *
 * To run a query within a React component, call `useGasExchangeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGasExchangeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGasExchangeListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGasExchangeListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GasExchangeListQuery, GasExchangeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GasExchangeListQuery, GasExchangeListQueryVariables>(GasExchangeListDocument, options);
      }
export function useGasExchangeListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GasExchangeListQuery, GasExchangeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GasExchangeListQuery, GasExchangeListQueryVariables>(GasExchangeListDocument, options);
        }
export type GasExchangeListQueryHookResult = ReturnType<typeof useGasExchangeListQuery>;
export type GasExchangeListLazyQueryHookResult = ReturnType<typeof useGasExchangeListLazyQuery>;
export type GasExchangeListQueryResult = Apollo.QueryResult<GasExchangeListQuery, GasExchangeListQueryVariables>;
export const GasExchangeRecordDocument = gql`
    query GasExchangeRecord($id: UUID4!) {
  gasExchangeRecord(id: $id) {
    id
    status
    dueDate
    initialDueDate
    qty
    returnedQty
    deadlineIsExtendable
    noOfDaysTillDueDate
    warnUserAboutDepositFees
    lastGasExchangeReturn {
      returnDate
    }
    order {
      id
      submittedAt
      contactInfo {
        email
        phone
        shippingAddress {
          addressId
          city
          company
          countryCode
          firstName
          isAddressValidated
          lastName
          line1
          line2
          state
          zip
        }
      }
      paymentInfo {
        cardExpirationDate
        cardExpiryMonth
        cardExpiryYear
        cardType
        email
        last4
      }
      paymentRequest {
        billingAddress {
          city
          company
          countryCode
          firstName
          lastName
          line1
          line2
          state
          zip
        }
        isBillingEqualShipping
        paymentMethod
      }
    }
    missingOrder {
      price {
        total
      }
    }
    lineItem {
      subtotal
      item {
        title
        imgUrl
      }
      perUnitPrice
      strikethroughUnitPrice
      quantity
    }
  }
}
    `;

/**
 * __useGasExchangeRecordQuery__
 *
 * To run a query within a React component, call `useGasExchangeRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGasExchangeRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGasExchangeRecordQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGasExchangeRecordQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GasExchangeRecordQuery, GasExchangeRecordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GasExchangeRecordQuery, GasExchangeRecordQueryVariables>(GasExchangeRecordDocument, options);
      }
export function useGasExchangeRecordLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GasExchangeRecordQuery, GasExchangeRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GasExchangeRecordQuery, GasExchangeRecordQueryVariables>(GasExchangeRecordDocument, options);
        }
export type GasExchangeRecordQueryHookResult = ReturnType<typeof useGasExchangeRecordQuery>;
export type GasExchangeRecordLazyQueryHookResult = ReturnType<typeof useGasExchangeRecordLazyQuery>;
export type GasExchangeRecordQueryResult = Apollo.QueryResult<GasExchangeRecordQuery, GasExchangeRecordQueryVariables>;
export const IsAddressValidForTaxDocument = gql`
    query IsAddressValidForTax($input: IsAddressValidForTaxInput!) {
  isAddressValidForTax(input: $input) {
    isValid
  }
}
    `;

/**
 * __useIsAddressValidForTaxQuery__
 *
 * To run a query within a React component, call `useIsAddressValidForTaxQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsAddressValidForTaxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsAddressValidForTaxQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIsAddressValidForTaxQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IsAddressValidForTaxQuery, IsAddressValidForTaxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IsAddressValidForTaxQuery, IsAddressValidForTaxQueryVariables>(IsAddressValidForTaxDocument, options);
      }
export function useIsAddressValidForTaxLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IsAddressValidForTaxQuery, IsAddressValidForTaxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IsAddressValidForTaxQuery, IsAddressValidForTaxQueryVariables>(IsAddressValidForTaxDocument, options);
        }
export type IsAddressValidForTaxQueryHookResult = ReturnType<typeof useIsAddressValidForTaxQuery>;
export type IsAddressValidForTaxLazyQueryHookResult = ReturnType<typeof useIsAddressValidForTaxLazyQuery>;
export type IsAddressValidForTaxQueryResult = Apollo.QueryResult<IsAddressValidForTaxQuery, IsAddressValidForTaxQueryVariables>;
export const LocalizationDocument = gql`
    query Localization {
  localization {
    currentLocale
    defaultLocale
    checkout {
      pageTitlesInHead {
        checkout
        status
      }
      reviewStep {
        editButtonText
        emailNote
        giftEmailNote
        giftMessageNote
        giftShippingHeadingText
        headingText
        paymentHeadingText
        shippingHeadingText
        submitOrderButtonText
      }
      breadcrumbs {
        address
        payment
        review
        shipping
      }
      shippingStep {
        addAddressButtonText
        addAddressHeadingText
        additionalPhoneNumberLabel
        addressHeadingText
        contactNoteText
        continueToPaymentButtonText
        continueToShippingMethodButtonText
        savedAddressHeadingText
        shipAlertText
        shippingHeadingText
      }
      shippingMethodStep {
        headingText
        selectShippingMethodText
        freeText
      }
      paymentStep {
        addCardHeadingText
        addPaymentButtonText
        addPaymentHeadingText
        billingAddressHeadingText
        billingSameAsShippingText
        continueToReviewButtonText
        headingText
        sectionHeadingText
        shippingAddressHeadingText
        giftCardCoversFullAmountTitle
        giftCardCoversFullAmountDescription
      }
      reviewStep {
        editButtonText
        emailNote
        giftEmailNote
        giftMessageNote
        giftShippingHeadingText
        headingText
        paymentHeadingText
        shippingHeadingText
        submitOrderButtonText
        agreeToTermsText
      }
      orderStatusPage {
        continueShoppingButtonText
        headingText
        notFoundMsg
        orderConfirmationShipmentText
        orderDateText
        orderDetailsHeadingText
        orderDetailsNote
        orderDetailsText
        paymentHeadingText
        printButtonText
        shippingHeadingText
      }
      orderDetails {
        billingSameAsShippingText
        cardholderNameText
        expiresText
        invoiceTermsText
        invoiceText
        poNumberText
        shippingMethodText
      }
      orderSummary {
        bulkDiscountText
        bundleDiscountText
        bundleItemDefaultText
        cartHeadingText
        yourOrderText
        freeShipLabel
        itemPlural
        itemSingular
        regulatoryTaxLabel
        salesTaxLabel
        shippingLabel
        subtotalLabel
        totalLabel
        whatsIncludedText
      }
      couponCode {
        addCouponButtonText
        applyCouponButtonText
        couponLabel
        couponCodeLabel
        couponPlaceholderText
        removeCouponButtonText
        cancelCouponButtonText
        editCouponButtonText
      }
      giftCard {
        addCouponGiftButtonText
        addGiftButtonText
        giftNumberPlaceholderText
        giftNumberLabel
        giftPinPlaceholderText
        giftPinLabel
        giftCardEndingIn
      }
      rdd {
        changeDateText
        headingText
        needOrderSoonerText
        noteText
        selectDateText
        yourRequestedDateText
      }
      giftForm {
        emailFieldLabel
        gifteeFieldLabel
        infoText
        messageFieldLabel
        sendAsGiftText
        shippingAddressHeadingText
      }
      errors {
        genericErrorMsg
        guestCartContainsSubscription {
          cartText
          itemHeadingText
          itemNoteText
        }
        lowStock {
          cartText
          itemHeadingText
          itemNoteText
        }
        purchaseQtyLimit {
          cartText
        }
        outOfStock {
          cartText
          itemHeadingText
          itemNoteText
        }
        itemUnavailable {
          cartText
          itemHeadingText
          itemNoteText
        }
        insufficientLoyaltyBalance {
          itemHeadingText
          itemNoteText
        }
        invalidLoyaltyReward {
          itemHeadingText
          itemNoteText
        }
        invalidGiftCard {
          itemHeadingText
          itemNoteText
        }
        minimumPurchaseAmount
        minimumPurchaseQuantity
        zipCodeRestriction {
          itemHeadingText
          itemNoteText
        }
        unverifiedEmail
        paymentNotAccepted
        unableToUsePoBox
        discount {
          discountCannotApplyToSubscription
          discountExceedsSubtotal
          discountHeadingText
          discountNoteText
          discountNotFound
          discountPromoCodeRequiresEmail
          discountPromoCodeRequiresEmailOrLogin
          discountTooLarge
        }
        paymentFailureErrorText
      }
    }
    forms {
      account {
        firstNameLabel
        lastNameLabel
      }
      address {
        cardholderNameLabel
        cityLabel
        companyLabel
        countryLabel
        emailLabel
        firstNameLabel
        isDefaultLabel
        lastNameLabel
        line1Label
        line2Label
        manuallyEnterAddressText
        nicknameLabel
        phoneLabel
        phoneNumberLabel
        requiredFieldsText
        regionText
        requiredText
        specialInstructionsLabel
        stateLabel
        taxIdLabel
        zipLabel
        autocompletePlaceholderText
      }
      creditCard {
        cardholderNameLabel
        cardNumberLabel
        cardSavedForGasExchangeNote
        cardSavedForSubsNote
        cvvLabel
        cvvTooltip {
          cardsWith3DigitsNote
          cardsWith3DigitsText
          cardsWith4DigitsNote
          cardsWith4DigitsText
          cvv3DigitAlt
          cvv4DigitAlt
          headingText
        }
        expirationDateLabel
        saveCardForLaterText
        securityNote
      }
      forgotPassword {
        backToLoginText
        contactLinkContentText
        contactLinkText
        emailLabelText
        formDescriptionText
        headingText
        submitButtonText
        submittedText
      }
      resetPassword {
        contactLinkContentText
        contactLinkText
        headingText
        passwordInputLabelText
        requestNewLinkContentText
        requestNewLinkText
        resetTokenDefaultErrorText
        resetTokenExpiredErrorText
        resetTokenIdErrorText
        resetTokenMismatchErrorText
        resetTokenNotFoundErrorText
        resetTokenUnableToDecodeErrorText
        submitText
      }
      signIn {
        accountLockedErrorText
        emailInputPlaceholderText
        forgotPasswordButtonText
        genericErrorText
        headingDefaultText
        headingText
        loginButtonText
        passwordInputPlaceholderText
        signUpButtonText
        signUpDefaultHeadingText
        signUpHeadingText
      }
      signup {
        accountLogoAltText
        ageRequirementErrorText
        birthdayLabelText
        createAccountPageHeadingText
        dayLabelText
        emailLabelText
        emailPlaceholderText
        errorResetPasswordLinkText
        errorText
        firstNameLabelText
        firstNamePlaceholderText
        headingText
        lastNameLabelText
        lastNamePlaceholderText
        monthLabelText
        passwordLabelText
        passwordPlaceholderText
        submitText
        yearLabelText
        emailOptIn {
          body
          defaultLabelText
          privacyPolicyLinkText
          termsOfUseLinkText
        }
      }
      tos {
        body
        errorText
        tosLinkText
      }
      validation {
        dayRequiredErrorText
        emailRequiredErrorText
        fieldRequiredErrorText
        invalidDateErrorText
        invalidPasswordErrorText
        invalidPhoneErrorText
        invalidTaxIdErrorText
        invalidTaxIdLengthErrorText
        monthRequiredErrorText
        newPasswordRequiredErrorText
        passwordRequiredErrorText
        requiredErrorText
        signupPasswordRequiredErrorText
        wrongEmailErrorText
        yearRequiredErrorText
        companyRequiredWithTaxIdErrorText
        taxIdRequiredWithCompanyErrorText
      }
    }
    portal {
      exchangeDetailPage {
        avoidDepositFeesWarningTextFractional
        avoidDepositFeesWarningTextMany
        avoidDepositFeesWarningTextPlural
        avoidDepositFeesWarningTextSingular
        daysLeftToReturnHeadingText
        daysLeftToReturnTextPlural
        daysLeftToReturnTextSingular
        depositFeeAddedAlertText
        depositFeeAddedText
        exchangeDetailsText
        expectedReturnDateText
        extendReturnDeadlineText
        missedReturnDateText
        notFoundMsg
        orderDetailsHeadingText
        orderedText
        paymentHeadingText
        returnByText
        returnDateExtendedText
        returnDateText
        returnedOnText
        returnedOutOfTotalText
        returnedText
        shippingHeadingText
        statusText
        yourOrderText
      }
      header {
        signOutLinkText
      }
      accountVerification {
        heading
        body
        buttonText
        contactSupportText
        emailSentText
        tokenExpiredText
        invalidLinkText
        verifySuccessText
      }
      accountPage {
        activeAccountHeadingText
        addressesHeadingText
        defaultTitleText
        emailHeadingText
        nameHeadingText
        nameUpdateButtonText
        nameUpdateCancelButtonText
        nameUpdateSubmitButtonText
        passwordChangeButtonText
        passwordHeadingText
        paymentsHeadingText
      }
      address {
        addHeadingText
        addSubmitButtonText
        cancelButtonText
        editHeadingText
        makeDefaultText
        updateSubmitButtonText
      }
      breadcrumbs {
        account
        accountDetails
        addAddress
        addPayment
        editAddress
        exchange
        exchangeDetails
        machines
        notFound
        orders
        shippingAddresses
        subscriptions
        changePassword
      }
      card {
        addAddressLabel
        addPaymentLabel
        allocationText
        creditCardNumberText
        currentLabel
        defaultAddressLabel
        defaultPaymentLabel
        deleteButtonText
        editButtonText
        makeDefaultButtonText
        numRemainingLabel
        selectLabel
        subscriptionAddressButtonText
        viewAllButtonText
      }
      password {
        backButtonText
        cancelButtonText
        changePasswordCancelButtonText
        changePasswordHeadingText
        changePasswordSubmitButtonText
        checkYourEmailContentText
        checkYourEmailHeadingText
        currentPasswordLabelText
        forgotPasswordHeadingText
        forgotPasswordHeadingWithTenantText
        newPasswordLabelText
        passwordUpdatedBannerText
        resetPasswordHeadingText
        resetPasswordHeadingWithTenantText
        updatePasswordHeadingText
        minCharactersText {
          boldText
          bodyText
        }
        oneUppercaseOneLowercaseAlphaText {
          bodyText
          boldText1
          boldText2
        }
        twoNumericDigitsText {
          boldText
          bodyText
        }
        oneSpecialCharText {
          bodyText
          boldText
        }
      }
      errors {
        geoBlock {
          apiError
          zipBlocked
        }
        addressVerification {
          checkoutSpecificConfirmSuggestedText
          confirmSuggestedAddressText
          confirmText
          doYouWantToProceedText
          editEnteredAddressText
          editText
          enteredAddressText
          goBackText
          invalidZipCodeText
          keepEnteredAddressText
          notAbleToVerifyShippingAddressText
          recommendChangesText
          shippingAddressText
          suggestedAddressText
          useSuggestedAddressText
          verifyText
        }
      }
      machinesPage {
        addMachinesText
        areYouSureDeleteThisMachineText
        cancelText
        confirmDeletionText
        deleteMachineText
        getGasText
        learnAboutSparklingWaterMakersText
        machinesText
        machineText
        registerYourMachineNowText
        troubleshootingGuideText
        unlockWarrantyText
        userManualText
        warrantyExpiredText
        warrantyExpiresText
        yesDeleteThisMachineText
      }
      exchangeList {
        active
        closed
        cylinderText
        dueInDaysTextPlural
        dueInDaysTextSingular
        gasExchangeListTitle
        gasExchangePageListTitle
        orderDate
        returnByDate
        returnedDate
        returnPastDue
        viewDetails
      }
      orderDetailPage {
        dateText
        invoiceNote
        notFoundErrorText
        orderIdHeadingText
        orderSummaryHeadingText
        paymentHeadingText
        printButtonText
        shippingAddressHeadingText
        trackingText
        questionAboutOrderText
        questionAboutOrderNumberText
      }
      orderSummary {
        estimatedFeeLabel
        estimatedTaxLabel
        feeLabel
        freeShipLabel
        shippingLabel
        subtotalLabel
        totalLabel
      }
      ordersPage {
        dateHeadingText
        exchangeText
        orderIdHeadingText
        ordersHeadingText
        receiptButtonText
        reorderButtonText
        reorderErrorNote
        shippingAddressHeadingText
        totalHeadingText
      }
      subscriptionDetailPage {
        addressHeadingText
        backButtonText
        canceledText
        cancelHeadingSubText
        cancelHeadingText
        cancelLabel
        cancelSubscriptionButtonText
        closeButtonText
        editAddressButtonText
        editPaymentButtonText
        intervalHeadingText
        intervalText
        manageSubscriptionLabel
        needToStartNewLabel
        nextDeliveryDateHeadingText
        nextShipmentDateText
        noLongerNeedLabel
        orderedAtHeadingText
        otherLabel
        pausedBannerText
        pausedText
        paymentHeadingText
        paymentUpdateButtonText
        paymentUpdateNeededText
        priceNoteText
        reasonForCancelingLabel
        reasonForCancelingPlaceholder
        renameLabel
        resumedBannerText
        resumeLabel
        shippingIssueLabel
        skipHeadingText
        skipLabel
        skipNextShipmentButtonText
        skippedBannerText
        skippedShipmentDateText
        subscriptionNotFoundText
        subscriptionText
      }
      subscriptionsPage {
        actionRequiredLabel
        canceledLabel
        headingText
        intervalText
        nextDeliveryDateText
        noSubscriptionsFoundText
        pausedLabel
      }
      payment {
        addHeadingText
        billingSameAsShippingText
        cancelButtonText
        creditCardSelectorText
        makeDefaultText
        paypalSelectorText
        submitButtonText
      }
      notAvailable {
        headingText
        naAbbreviationText
        linkContentText
        linkText
        orders
        subscriptions
        exchanges
      }
      alts {
        accountAltText
        shopLogoAltText
      }
      pageTitlesInHead {
        verifyAccount
      }
    }
    components {
      addressVerification {
        addressErrorBoldText
        addressErrorText
        editManuallyText
        editOnlyText
        editOrSuggestionText
        enteredAddressText
        invalidZipCodeText
        keepEnteredButtonText
        reviewAddressText
        suggestedAddressText
        titleText
        useSuggestedButtonText
        zipErrorBoldText
        zipErrorText
      }
      customNotFound {
        cartButtonText
        headingText
        homeButtonText
        subHeadingText
      }
      errorModal {
        errorHeadingText
        okText
        visitOurLinkForAssistanceText
      }
      orderProcessing {
        headingText
        subHeadingText
      }
      exchangeReturnByDate {
        exchangeText
        returnByText
      }
      footer {
        allRightsReserved
      }
      price {
        eachPriceText
        regularPriceText
      }
    }
  }
}
    `;

/**
 * __useLocalizationQuery__
 *
 * To run a query within a React component, call `useLocalizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocalizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocalizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocalizationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LocalizationQuery, LocalizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LocalizationQuery, LocalizationQueryVariables>(LocalizationDocument, options);
      }
export function useLocalizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LocalizationQuery, LocalizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LocalizationQuery, LocalizationQueryVariables>(LocalizationDocument, options);
        }
export type LocalizationQueryHookResult = ReturnType<typeof useLocalizationQuery>;
export type LocalizationLazyQueryHookResult = ReturnType<typeof useLocalizationLazyQuery>;
export type LocalizationQueryResult = Apollo.QueryResult<LocalizationQuery, LocalizationQueryVariables>;
export const LoginUserDocument = gql`
    mutation LoginUser($email: String!, $password: String!) {
  loginUser(input: {email: $email, password: $password}) {
    id
  }
}
    `;
export type LoginUserMutationFn = Apollo.MutationFunction<LoginUserMutation, LoginUserMutationVariables>;

/**
 * __useLoginUserMutation__
 *
 * To run a mutation, you first call `useLoginUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginUserMutation, { data, loading, error }] = useLoginUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginUserMutation, LoginUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LoginUserMutation, LoginUserMutationVariables>(LoginUserDocument, options);
      }
export type LoginUserMutationHookResult = ReturnType<typeof useLoginUserMutation>;
export type LoginUserMutationResult = Apollo.MutationResult<LoginUserMutation>;
export type LoginUserMutationOptions = Apollo.BaseMutationOptions<LoginUserMutation, LoginUserMutationVariables>;
export const LogoutUserDocument = gql`
    mutation logoutUser {
  logoutUser {
    __typename
  }
}
    `;
export type LogoutUserMutationFn = Apollo.MutationFunction<LogoutUserMutation, LogoutUserMutationVariables>;

/**
 * __useLogoutUserMutation__
 *
 * To run a mutation, you first call `useLogoutUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutUserMutation, { data, loading, error }] = useLogoutUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LogoutUserMutation, LogoutUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LogoutUserMutation, LogoutUserMutationVariables>(LogoutUserDocument, options);
      }
export type LogoutUserMutationHookResult = ReturnType<typeof useLogoutUserMutation>;
export type LogoutUserMutationResult = Apollo.MutationResult<LogoutUserMutation>;
export type LogoutUserMutationOptions = Apollo.BaseMutationOptions<LogoutUserMutation, LogoutUserMutationVariables>;
export const MergeCartsDocument = gql`
    mutation MergeCarts($destCartId: UUID4!, $srcCartId: UUID4!) {
  mergeCarts(destCartId: $destCartId, srcCartId: $srcCartId) {
    id
  }
}
    `;
export type MergeCartsMutationFn = Apollo.MutationFunction<MergeCartsMutation, MergeCartsMutationVariables>;

/**
 * __useMergeCartsMutation__
 *
 * To run a mutation, you first call `useMergeCartsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeCartsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeCartsMutation, { data, loading, error }] = useMergeCartsMutation({
 *   variables: {
 *      destCartId: // value for 'destCartId'
 *      srcCartId: // value for 'srcCartId'
 *   },
 * });
 */
export function useMergeCartsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MergeCartsMutation, MergeCartsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MergeCartsMutation, MergeCartsMutationVariables>(MergeCartsDocument, options);
      }
export type MergeCartsMutationHookResult = ReturnType<typeof useMergeCartsMutation>;
export type MergeCartsMutationResult = Apollo.MutationResult<MergeCartsMutation>;
export type MergeCartsMutationOptions = Apollo.BaseMutationOptions<MergeCartsMutation, MergeCartsMutationVariables>;
export const PersistTemporaryCartDocument = gql`
    mutation PersistTemporaryCart($srcCartId: UUID4!) {
  persistTemporaryCart(srcCartId: $srcCartId) {
    id
  }
}
    `;
export type PersistTemporaryCartMutationFn = Apollo.MutationFunction<PersistTemporaryCartMutation, PersistTemporaryCartMutationVariables>;

/**
 * __usePersistTemporaryCartMutation__
 *
 * To run a mutation, you first call `usePersistTemporaryCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersistTemporaryCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [persistTemporaryCartMutation, { data, loading, error }] = usePersistTemporaryCartMutation({
 *   variables: {
 *      srcCartId: // value for 'srcCartId'
 *   },
 * });
 */
export function usePersistTemporaryCartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PersistTemporaryCartMutation, PersistTemporaryCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PersistTemporaryCartMutation, PersistTemporaryCartMutationVariables>(PersistTemporaryCartDocument, options);
      }
export type PersistTemporaryCartMutationHookResult = ReturnType<typeof usePersistTemporaryCartMutation>;
export type PersistTemporaryCartMutationResult = Apollo.MutationResult<PersistTemporaryCartMutation>;
export type PersistTemporaryCartMutationOptions = Apollo.BaseMutationOptions<PersistTemporaryCartMutation, PersistTemporaryCartMutationVariables>;
export const RemoveDiscountDocument = gql`
    mutation removeDiscount($id: UUID4!) {
  removeDiscount(id: $id) {
    ...CheckoutSession
  }
}
    ${CheckoutSessionFragmentDoc}`;
export type RemoveDiscountMutationFn = Apollo.MutationFunction<RemoveDiscountMutation, RemoveDiscountMutationVariables>;

/**
 * __useRemoveDiscountMutation__
 *
 * To run a mutation, you first call `useRemoveDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDiscountMutation, { data, loading, error }] = useRemoveDiscountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveDiscountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveDiscountMutation, RemoveDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveDiscountMutation, RemoveDiscountMutationVariables>(RemoveDiscountDocument, options);
      }
export type RemoveDiscountMutationHookResult = ReturnType<typeof useRemoveDiscountMutation>;
export type RemoveDiscountMutationResult = Apollo.MutationResult<RemoveDiscountMutation>;
export type RemoveDiscountMutationOptions = Apollo.BaseMutationOptions<RemoveDiscountMutation, RemoveDiscountMutationVariables>;
export const RemoveGiftCardDocument = gql`
    mutation removeGiftCard($id: UUID4!) {
  removeGiftCard(id: $id) {
    ...CheckoutSession
  }
}
    ${CheckoutSessionFragmentDoc}`;
export type RemoveGiftCardMutationFn = Apollo.MutationFunction<RemoveGiftCardMutation, RemoveGiftCardMutationVariables>;

/**
 * __useRemoveGiftCardMutation__
 *
 * To run a mutation, you first call `useRemoveGiftCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGiftCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGiftCardMutation, { data, loading, error }] = useRemoveGiftCardMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveGiftCardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveGiftCardMutation, RemoveGiftCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveGiftCardMutation, RemoveGiftCardMutationVariables>(RemoveGiftCardDocument, options);
      }
export type RemoveGiftCardMutationHookResult = ReturnType<typeof useRemoveGiftCardMutation>;
export type RemoveGiftCardMutationResult = Apollo.MutationResult<RemoveGiftCardMutation>;
export type RemoveGiftCardMutationOptions = Apollo.BaseMutationOptions<RemoveGiftCardMutation, RemoveGiftCardMutationVariables>;
export const RemoveGiftInfoDocument = gql`
    mutation RemoveGiftInfo($id: UUID4!) {
  removeGiftInfo(id: $id) {
    ...CheckoutSession
  }
}
    ${CheckoutSessionFragmentDoc}`;
export type RemoveGiftInfoMutationFn = Apollo.MutationFunction<RemoveGiftInfoMutation, RemoveGiftInfoMutationVariables>;

/**
 * __useRemoveGiftInfoMutation__
 *
 * To run a mutation, you first call `useRemoveGiftInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGiftInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGiftInfoMutation, { data, loading, error }] = useRemoveGiftInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveGiftInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveGiftInfoMutation, RemoveGiftInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveGiftInfoMutation, RemoveGiftInfoMutationVariables>(RemoveGiftInfoDocument, options);
      }
export type RemoveGiftInfoMutationHookResult = ReturnType<typeof useRemoveGiftInfoMutation>;
export type RemoveGiftInfoMutationResult = Apollo.MutationResult<RemoveGiftInfoMutation>;
export type RemoveGiftInfoMutationOptions = Apollo.BaseMutationOptions<RemoveGiftInfoMutation, RemoveGiftInfoMutationVariables>;
export const RequestPasswordResetForUserDocument = gql`
    mutation RequestPasswordResetForUser($input: RequestPasswordResetForUserInput!) {
  requestPasswordResetForUser(input: $input) {
    email
  }
}
    `;
export type RequestPasswordResetForUserMutationFn = Apollo.MutationFunction<RequestPasswordResetForUserMutation, RequestPasswordResetForUserMutationVariables>;

/**
 * __useRequestPasswordResetForUserMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetForUserMutation, { data, loading, error }] = useRequestPasswordResetForUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestPasswordResetForUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestPasswordResetForUserMutation, RequestPasswordResetForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestPasswordResetForUserMutation, RequestPasswordResetForUserMutationVariables>(RequestPasswordResetForUserDocument, options);
      }
export type RequestPasswordResetForUserMutationHookResult = ReturnType<typeof useRequestPasswordResetForUserMutation>;
export type RequestPasswordResetForUserMutationResult = Apollo.MutationResult<RequestPasswordResetForUserMutation>;
export type RequestPasswordResetForUserMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetForUserMutation, RequestPasswordResetForUserMutationVariables>;
export const ResetUserPasswordDocument = gql`
    mutation ResetUserPassword($input: ResetUserPasswordInput!) {
  resetUserPassword(input: $input) {
    id
  }
}
    `;
export type ResetUserPasswordMutationFn = Apollo.MutationFunction<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;

/**
 * __useResetUserPasswordMutation__
 *
 * To run a mutation, you first call `useResetUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserPasswordMutation, { data, loading, error }] = useResetUserPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetUserPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>(ResetUserPasswordDocument, options);
      }
export type ResetUserPasswordMutationHookResult = ReturnType<typeof useResetUserPasswordMutation>;
export type ResetUserPasswordMutationResult = Apollo.MutationResult<ResetUserPasswordMutation>;
export type ResetUserPasswordMutationOptions = Apollo.BaseMutationOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;
export const RestrictedItemsByZipCodeDocument = gql`
    query RestrictedItemsByZipCode($zip: String!) {
  restrictedItemsByZipCode(zip: $zip) {
    restrictedItems {
      id
    }
  }
}
    `;

/**
 * __useRestrictedItemsByZipCodeQuery__
 *
 * To run a query within a React component, call `useRestrictedItemsByZipCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestrictedItemsByZipCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestrictedItemsByZipCodeQuery({
 *   variables: {
 *      zip: // value for 'zip'
 *   },
 * });
 */
export function useRestrictedItemsByZipCodeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RestrictedItemsByZipCodeQuery, RestrictedItemsByZipCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RestrictedItemsByZipCodeQuery, RestrictedItemsByZipCodeQueryVariables>(RestrictedItemsByZipCodeDocument, options);
      }
export function useRestrictedItemsByZipCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RestrictedItemsByZipCodeQuery, RestrictedItemsByZipCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RestrictedItemsByZipCodeQuery, RestrictedItemsByZipCodeQueryVariables>(RestrictedItemsByZipCodeDocument, options);
        }
export type RestrictedItemsByZipCodeQueryHookResult = ReturnType<typeof useRestrictedItemsByZipCodeQuery>;
export type RestrictedItemsByZipCodeLazyQueryHookResult = ReturnType<typeof useRestrictedItemsByZipCodeLazyQuery>;
export type RestrictedItemsByZipCodeQueryResult = Apollo.QueryResult<RestrictedItemsByZipCodeQuery, RestrictedItemsByZipCodeQueryVariables>;
export const RetrieveAddressDocument = gql`
    query RetrieveAddress($id: String!) {
  retrieveAddress(id: $id) {
    items {
      line1
      line2
      city
      state
      zip
      country
      subBuilding
    }
  }
}
    `;

/**
 * __useRetrieveAddressQuery__
 *
 * To run a query within a React component, call `useRetrieveAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetrieveAddressQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRetrieveAddressQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RetrieveAddressQuery, RetrieveAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RetrieveAddressQuery, RetrieveAddressQueryVariables>(RetrieveAddressDocument, options);
      }
export function useRetrieveAddressLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RetrieveAddressQuery, RetrieveAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RetrieveAddressQuery, RetrieveAddressQueryVariables>(RetrieveAddressDocument, options);
        }
export type RetrieveAddressQueryHookResult = ReturnType<typeof useRetrieveAddressQuery>;
export type RetrieveAddressLazyQueryHookResult = ReturnType<typeof useRetrieveAddressLazyQuery>;
export type RetrieveAddressQueryResult = Apollo.QueryResult<RetrieveAddressQuery, RetrieveAddressQueryVariables>;
export const SaveEnteredContactInfoDocument = gql`
    mutation saveEnteredContactInfo($id: UUID4!, $input: SaveEnteredContactInfoInput!) {
  saveEnteredContactInfo(id: $id, input: $input) {
    ...CheckoutSession
  }
}
    ${CheckoutSessionFragmentDoc}`;
export type SaveEnteredContactInfoMutationFn = Apollo.MutationFunction<SaveEnteredContactInfoMutation, SaveEnteredContactInfoMutationVariables>;

/**
 * __useSaveEnteredContactInfoMutation__
 *
 * To run a mutation, you first call `useSaveEnteredContactInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEnteredContactInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEnteredContactInfoMutation, { data, loading, error }] = useSaveEnteredContactInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveEnteredContactInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveEnteredContactInfoMutation, SaveEnteredContactInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveEnteredContactInfoMutation, SaveEnteredContactInfoMutationVariables>(SaveEnteredContactInfoDocument, options);
      }
export type SaveEnteredContactInfoMutationHookResult = ReturnType<typeof useSaveEnteredContactInfoMutation>;
export type SaveEnteredContactInfoMutationResult = Apollo.MutationResult<SaveEnteredContactInfoMutation>;
export type SaveEnteredContactInfoMutationOptions = Apollo.BaseMutationOptions<SaveEnteredContactInfoMutation, SaveEnteredContactInfoMutationVariables>;
export const SaveGiftInfoDocument = gql`
    mutation SaveGiftInfo($id: UUID4!, $input: GiftInfoInput!) {
  saveGiftInfo(id: $id, input: $input) {
    ...CheckoutSession
  }
}
    ${CheckoutSessionFragmentDoc}`;
export type SaveGiftInfoMutationFn = Apollo.MutationFunction<SaveGiftInfoMutation, SaveGiftInfoMutationVariables>;

/**
 * __useSaveGiftInfoMutation__
 *
 * To run a mutation, you first call `useSaveGiftInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGiftInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGiftInfoMutation, { data, loading, error }] = useSaveGiftInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveGiftInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveGiftInfoMutation, SaveGiftInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveGiftInfoMutation, SaveGiftInfoMutationVariables>(SaveGiftInfoDocument, options);
      }
export type SaveGiftInfoMutationHookResult = ReturnType<typeof useSaveGiftInfoMutation>;
export type SaveGiftInfoMutationResult = Apollo.MutationResult<SaveGiftInfoMutation>;
export type SaveGiftInfoMutationOptions = Apollo.BaseMutationOptions<SaveGiftInfoMutation, SaveGiftInfoMutationVariables>;
export const SavePaymentDocument = gql`
    mutation savePayment($id: UUID4!, $input: SavePaymentInput!) {
  savePayment(id: $id, input: $input) {
    ...CheckoutSession
  }
}
    ${CheckoutSessionFragmentDoc}`;
export type SavePaymentMutationFn = Apollo.MutationFunction<SavePaymentMutation, SavePaymentMutationVariables>;

/**
 * __useSavePaymentMutation__
 *
 * To run a mutation, you first call `useSavePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePaymentMutation, { data, loading, error }] = useSavePaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePaymentMutation, SavePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SavePaymentMutation, SavePaymentMutationVariables>(SavePaymentDocument, options);
      }
export type SavePaymentMutationHookResult = ReturnType<typeof useSavePaymentMutation>;
export type SavePaymentMutationResult = Apollo.MutationResult<SavePaymentMutation>;
export type SavePaymentMutationOptions = Apollo.BaseMutationOptions<SavePaymentMutation, SavePaymentMutationVariables>;
export const SavePaymentOptionsDocument = gql`
    mutation SavePaymentOptions($id: UUID4!, $input: SavePaymentOptionsInput!) {
  savePaymentOptions(id: $id, input: $input) {
    ...CheckoutSession
  }
}
    ${CheckoutSessionFragmentDoc}`;
export type SavePaymentOptionsMutationFn = Apollo.MutationFunction<SavePaymentOptionsMutation, SavePaymentOptionsMutationVariables>;

/**
 * __useSavePaymentOptionsMutation__
 *
 * To run a mutation, you first call `useSavePaymentOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePaymentOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePaymentOptionsMutation, { data, loading, error }] = useSavePaymentOptionsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePaymentOptionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePaymentOptionsMutation, SavePaymentOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SavePaymentOptionsMutation, SavePaymentOptionsMutationVariables>(SavePaymentOptionsDocument, options);
      }
export type SavePaymentOptionsMutationHookResult = ReturnType<typeof useSavePaymentOptionsMutation>;
export type SavePaymentOptionsMutationResult = Apollo.MutationResult<SavePaymentOptionsMutation>;
export type SavePaymentOptionsMutationOptions = Apollo.BaseMutationOptions<SavePaymentOptionsMutation, SavePaymentOptionsMutationVariables>;
export const SaveShippingMethodDocument = gql`
    mutation SaveShippingMethod($id: UUID4!, $input: SaveShippingMethodInput!) {
  saveShippingMethod(id: $id, input: $input) {
    ...CheckoutSession
  }
}
    ${CheckoutSessionFragmentDoc}`;
export type SaveShippingMethodMutationFn = Apollo.MutationFunction<SaveShippingMethodMutation, SaveShippingMethodMutationVariables>;

/**
 * __useSaveShippingMethodMutation__
 *
 * To run a mutation, you first call `useSaveShippingMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveShippingMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveShippingMethodMutation, { data, loading, error }] = useSaveShippingMethodMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveShippingMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveShippingMethodMutation, SaveShippingMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveShippingMethodMutation, SaveShippingMethodMutationVariables>(SaveShippingMethodDocument, options);
      }
export type SaveShippingMethodMutationHookResult = ReturnType<typeof useSaveShippingMethodMutation>;
export type SaveShippingMethodMutationResult = Apollo.MutationResult<SaveShippingMethodMutation>;
export type SaveShippingMethodMutationOptions = Apollo.BaseMutationOptions<SaveShippingMethodMutation, SaveShippingMethodMutationVariables>;
export const SaveShippingOptionsDocument = gql`
    mutation SaveShippingOptions($id: UUID4!, $input: SaveShippingOptionsInput!) {
  saveShippingOptions(id: $id, input: $input) {
    ...CheckoutSession
  }
}
    ${CheckoutSessionFragmentDoc}`;
export type SaveShippingOptionsMutationFn = Apollo.MutationFunction<SaveShippingOptionsMutation, SaveShippingOptionsMutationVariables>;

/**
 * __useSaveShippingOptionsMutation__
 *
 * To run a mutation, you first call `useSaveShippingOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveShippingOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveShippingOptionsMutation, { data, loading, error }] = useSaveShippingOptionsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveShippingOptionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveShippingOptionsMutation, SaveShippingOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveShippingOptionsMutation, SaveShippingOptionsMutationVariables>(SaveShippingOptionsDocument, options);
      }
export type SaveShippingOptionsMutationHookResult = ReturnType<typeof useSaveShippingOptionsMutation>;
export type SaveShippingOptionsMutationResult = Apollo.MutationResult<SaveShippingOptionsMutation>;
export type SaveShippingOptionsMutationOptions = Apollo.BaseMutationOptions<SaveShippingOptionsMutation, SaveShippingOptionsMutationVariables>;
export const SaveSuggestedAddressDocument = gql`
    mutation saveSuggestedAddress($id: UUID4!, $input: SaveSuggestedAddressInput!) {
  saveSuggestedAddress(id: $id, input: $input) {
    ...CheckoutSession
  }
}
    ${CheckoutSessionFragmentDoc}`;
export type SaveSuggestedAddressMutationFn = Apollo.MutationFunction<SaveSuggestedAddressMutation, SaveSuggestedAddressMutationVariables>;

/**
 * __useSaveSuggestedAddressMutation__
 *
 * To run a mutation, you first call `useSaveSuggestedAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSuggestedAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSuggestedAddressMutation, { data, loading, error }] = useSaveSuggestedAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSuggestedAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveSuggestedAddressMutation, SaveSuggestedAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveSuggestedAddressMutation, SaveSuggestedAddressMutationVariables>(SaveSuggestedAddressDocument, options);
      }
export type SaveSuggestedAddressMutationHookResult = ReturnType<typeof useSaveSuggestedAddressMutation>;
export type SaveSuggestedAddressMutationResult = Apollo.MutationResult<SaveSuggestedAddressMutation>;
export type SaveSuggestedAddressMutationOptions = Apollo.BaseMutationOptions<SaveSuggestedAddressMutation, SaveSuggestedAddressMutationVariables>;
export const CreateSetupIntentDocument = gql`
    mutation CreateSetupIntent {
  createSetupIntent {
    clientSecret
  }
}
    `;
export type CreateSetupIntentMutationFn = Apollo.MutationFunction<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>;

/**
 * __useCreateSetupIntentMutation__
 *
 * To run a mutation, you first call `useCreateSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSetupIntentMutation, { data, loading, error }] = useCreateSetupIntentMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateSetupIntentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>(CreateSetupIntentDocument, options);
      }
export type CreateSetupIntentMutationHookResult = ReturnType<typeof useCreateSetupIntentMutation>;
export type CreateSetupIntentMutationResult = Apollo.MutationResult<CreateSetupIntentMutation>;
export type CreateSetupIntentMutationOptions = Apollo.BaseMutationOptions<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>;
export const SetupTransactionDocument = gql`
    mutation setupTransaction($id: UUID4!) {
  setupTransaction(id: $id) {
    id
    payment {
      token
      clientConfirmationToken
    }
  }
}
    `;
export type SetupTransactionMutationFn = Apollo.MutationFunction<SetupTransactionMutation, SetupTransactionMutationVariables>;

/**
 * __useSetupTransactionMutation__
 *
 * To run a mutation, you first call `useSetupTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupTransactionMutation, { data, loading, error }] = useSetupTransactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetupTransactionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetupTransactionMutation, SetupTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetupTransactionMutation, SetupTransactionMutationVariables>(SetupTransactionDocument, options);
      }
export type SetupTransactionMutationHookResult = ReturnType<typeof useSetupTransactionMutation>;
export type SetupTransactionMutationResult = Apollo.MutationResult<SetupTransactionMutation>;
export type SetupTransactionMutationOptions = Apollo.BaseMutationOptions<SetupTransactionMutation, SetupTransactionMutationVariables>;
export const ShopToCheckoutDocument = gql`
    mutation shopToCheckout($cartId: UUID4!) {
  shopToCheckout(cartId: $cartId) {
    ...CheckoutSession
  }
}
    ${CheckoutSessionFragmentDoc}`;
export type ShopToCheckoutMutationFn = Apollo.MutationFunction<ShopToCheckoutMutation, ShopToCheckoutMutationVariables>;

/**
 * __useShopToCheckoutMutation__
 *
 * To run a mutation, you first call `useShopToCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopToCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopToCheckoutMutation, { data, loading, error }] = useShopToCheckoutMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useShopToCheckoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShopToCheckoutMutation, ShopToCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ShopToCheckoutMutation, ShopToCheckoutMutationVariables>(ShopToCheckoutDocument, options);
      }
export type ShopToCheckoutMutationHookResult = ReturnType<typeof useShopToCheckoutMutation>;
export type ShopToCheckoutMutationResult = Apollo.MutationResult<ShopToCheckoutMutation>;
export type ShopToCheckoutMutationOptions = Apollo.BaseMutationOptions<ShopToCheckoutMutation, ShopToCheckoutMutationVariables>;
export const SignUpUserDocument = gql`
    mutation SignUpUser($input: SignupUserInput!) {
  signupUser(input: $input) {
    id
    hashedEmail
  }
}
    `;
export type SignUpUserMutationFn = Apollo.MutationFunction<SignUpUserMutation, SignUpUserMutationVariables>;

/**
 * __useSignUpUserMutation__
 *
 * To run a mutation, you first call `useSignUpUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpUserMutation, { data, loading, error }] = useSignUpUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SignUpUserMutation, SignUpUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SignUpUserMutation, SignUpUserMutationVariables>(SignUpUserDocument, options);
      }
export type SignUpUserMutationHookResult = ReturnType<typeof useSignUpUserMutation>;
export type SignUpUserMutationResult = Apollo.MutationResult<SignUpUserMutation>;
export type SignUpUserMutationOptions = Apollo.BaseMutationOptions<SignUpUserMutation, SignUpUserMutationVariables>;
export const SkipOrderSubscriptionDocument = gql`
    mutation SkipOrderSubscription($id: UUID4!) {
  skipOrderSubscription(id: $id) {
    id
  }
}
    `;
export type SkipOrderSubscriptionMutationFn = Apollo.MutationFunction<SkipOrderSubscriptionMutation, SkipOrderSubscriptionMutationVariables>;

/**
 * __useSkipOrderSubscriptionMutation__
 *
 * To run a mutation, you first call `useSkipOrderSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipOrderSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipOrderSubscriptionMutation, { data, loading, error }] = useSkipOrderSubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSkipOrderSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SkipOrderSubscriptionMutation, SkipOrderSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SkipOrderSubscriptionMutation, SkipOrderSubscriptionMutationVariables>(SkipOrderSubscriptionDocument, options);
      }
export type SkipOrderSubscriptionMutationHookResult = ReturnType<typeof useSkipOrderSubscriptionMutation>;
export type SkipOrderSubscriptionMutationResult = Apollo.MutationResult<SkipOrderSubscriptionMutation>;
export type SkipOrderSubscriptionMutationOptions = Apollo.BaseMutationOptions<SkipOrderSubscriptionMutation, SkipOrderSubscriptionMutationVariables>;
export const SubmitOrderDocument = gql`
    mutation submitOrder($id: UUID4!, $input: SubmitOrderInput!) {
  submitOrder(id: $id, input: $input) {
    bazaarvoice {
      encryptedEmail
      encryptionKeyId
    }
    contactInfo {
      email
      emailOptIn
      phone
      shippingAddress {
        addressId
      }
      shippingMethod {
        code
        title
        phone
      }
    }
    id
    paymentRequest {
      paymentMethod
    }
    price {
      discount
      lineItems {
        ...LineItem
      }
      shipping
      subtotal
      taxSalesTotal
      total
    }
    submissionUid
    user {
      id
    }
  }
}
    ${LineItemFragmentDoc}`;
export type SubmitOrderMutationFn = Apollo.MutationFunction<SubmitOrderMutation, SubmitOrderMutationVariables>;

/**
 * __useSubmitOrderMutation__
 *
 * To run a mutation, you first call `useSubmitOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitOrderMutation, { data, loading, error }] = useSubmitOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitOrderMutation, SubmitOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubmitOrderMutation, SubmitOrderMutationVariables>(SubmitOrderDocument, options);
      }
export type SubmitOrderMutationHookResult = ReturnType<typeof useSubmitOrderMutation>;
export type SubmitOrderMutationResult = Apollo.MutationResult<SubmitOrderMutation>;
export type SubmitOrderMutationOptions = Apollo.BaseMutationOptions<SubmitOrderMutation, SubmitOrderMutationVariables>;
export const SubmittedOrderDocument = gql`
    query SubmittedOrder($orderId: UUID4!) {
  submittedOrder(orderId: $orderId) {
    contactInfo {
      email
      phone
      shippingAddress {
        addressId
        city
        company
        countryCode
        firstName
        isAddressValidated
        lastName
        line1
        line2
        nickname
        specialInstructions
        state
        zip
        taxId
      }
      shippingMethod {
        code
        title
        phone
      }
    }
    customerPo
    displayName
    fulfillments {
      id
      insertedAt
      tracking {
        carrierName
        status
        trackingNumber
        trackingUrl
      }
      status
      items {
        quantity
        item {
          id
          imgUrl
          title
        }
      }
    }
    giftorName
    id
    isExternalOrder
    orderType
    paymentInfo {
      cardExpirationDate
      cardExpiryMonth
      cardExpiryYear
      cardType
      email
      last4
    }
    paymentRequest {
      billingAddress {
        city
        company
        countryCode
        firstName
        lastName
        line1
        line2
        state
        zip
      }
      isBillingEqualShipping
      paymentMethod
    }
    price {
      ...Price
    }
    requestedDeliveryDate
    shippingMethodConfig {
      name
    }
    submittedAt
  }
}
    ${PriceFragmentDoc}`;

/**
 * __useSubmittedOrderQuery__
 *
 * To run a query within a React component, call `useSubmittedOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmittedOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmittedOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSubmittedOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SubmittedOrderQuery, SubmittedOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubmittedOrderQuery, SubmittedOrderQueryVariables>(SubmittedOrderDocument, options);
      }
export function useSubmittedOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubmittedOrderQuery, SubmittedOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubmittedOrderQuery, SubmittedOrderQueryVariables>(SubmittedOrderDocument, options);
        }
export type SubmittedOrderQueryHookResult = ReturnType<typeof useSubmittedOrderQuery>;
export type SubmittedOrderLazyQueryHookResult = ReturnType<typeof useSubmittedOrderLazyQuery>;
export type SubmittedOrderQueryResult = Apollo.QueryResult<SubmittedOrderQuery, SubmittedOrderQueryVariables>;
export const SubmittedOrdersDocument = gql`
    query SubmittedOrders($pagination: PaginationInput = {limit: 1000, page: 1}) {
  submittedOrders(pagination: $pagination) {
    pagination {
      totalPages
    }
    submittedOrders {
      id
      isExternalOrder
      orderSubscriptionRelationship
      displayName
      submittedAt
      requestedDeliveryDate
      price {
        total
        items {
          item {
            gasExchangeInfo {
              enabled
            }
          }
        }
      }
      contactInfo {
        shippingAddress {
          nickname
          line1
          line2
          firstName
          lastName
          city
          state
          zip
        }
      }
      fulfillments {
        id
      }
      userId
    }
  }
}
    `;

/**
 * __useSubmittedOrdersQuery__
 *
 * To run a query within a React component, call `useSubmittedOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmittedOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmittedOrdersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSubmittedOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SubmittedOrdersQuery, SubmittedOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubmittedOrdersQuery, SubmittedOrdersQueryVariables>(SubmittedOrdersDocument, options);
      }
export function useSubmittedOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubmittedOrdersQuery, SubmittedOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubmittedOrdersQuery, SubmittedOrdersQueryVariables>(SubmittedOrdersDocument, options);
        }
export type SubmittedOrdersQueryHookResult = ReturnType<typeof useSubmittedOrdersQuery>;
export type SubmittedOrdersLazyQueryHookResult = ReturnType<typeof useSubmittedOrdersLazyQuery>;
export type SubmittedOrdersQueryResult = Apollo.QueryResult<SubmittedOrdersQuery, SubmittedOrdersQueryVariables>;
export const SubscriptionDocument = gql`
    query Subscription($id: UUID4!) {
  orderSubscription(id: $id) {
    address {
      city
      countryCode
      firstName
      id
      lastName
      line1
      line2
      state
      zip
    }
    id
    insertedAt
    intervalInDays
    nextOrderCreationDates
    paymentInfo {
      cardExpiryMonth
      cardExpiryYear
      cardType
      cardholderName
      email
      last4
      paymentMethod
      paymentToken
    }
    price {
      lineItems {
        ... on LineItem {
          item {
            imgUrl
            title
            fluidOzPerPack
            productsPerPack
          }
          perUnitPrice
          quantity
          strikethroughUnitPrice
          subtotal
        }
      }
      shipping
      subtotal
      taxRegulatoryTotal
      taxSalesTotal
      total
    }
    status
    statusReason
    title
  }
}
    `;

/**
 * __useSubscriptionQuery__
 *
 * To run a query within a React component, call `useSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubscriptionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SubscriptionQuery, SubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, options);
      }
export function useSubscriptionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscriptionQuery, SubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, options);
        }
export type SubscriptionQueryHookResult = ReturnType<typeof useSubscriptionQuery>;
export type SubscriptionLazyQueryHookResult = ReturnType<typeof useSubscriptionLazyQuery>;
export type SubscriptionQueryResult = Apollo.QueryResult<SubscriptionQuery, SubscriptionQueryVariables>;
export const SubscriptionAddressesDocument = gql`
    query SubscriptionAddresses {
  orderSubscriptions {
    address {
      id
    }
    orderSubscriptionItems {
      currentItem {
        id
      }
    }
  }
}
    `;

/**
 * __useSubscriptionAddressesQuery__
 *
 * To run a query within a React component, call `useSubscriptionAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionAddressesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionAddressesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SubscriptionAddressesQuery, SubscriptionAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubscriptionAddressesQuery, SubscriptionAddressesQueryVariables>(SubscriptionAddressesDocument, options);
      }
export function useSubscriptionAddressesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscriptionAddressesQuery, SubscriptionAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubscriptionAddressesQuery, SubscriptionAddressesQueryVariables>(SubscriptionAddressesDocument, options);
        }
export type SubscriptionAddressesQueryHookResult = ReturnType<typeof useSubscriptionAddressesQuery>;
export type SubscriptionAddressesLazyQueryHookResult = ReturnType<typeof useSubscriptionAddressesLazyQuery>;
export type SubscriptionAddressesQueryResult = Apollo.QueryResult<SubscriptionAddressesQuery, SubscriptionAddressesQueryVariables>;
export const SubscriptionForAddressUpdateDocument = gql`
    query SubscriptionForAddressUpdate($id: UUID4!) {
  orderSubscription(id: $id) {
    id
    title
    address {
      id
    }
    orderSubscriptionItems {
      currentItem {
        id
      }
    }
  }
}
    `;

/**
 * __useSubscriptionForAddressUpdateQuery__
 *
 * To run a query within a React component, call `useSubscriptionForAddressUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionForAddressUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionForAddressUpdateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubscriptionForAddressUpdateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SubscriptionForAddressUpdateQuery, SubscriptionForAddressUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubscriptionForAddressUpdateQuery, SubscriptionForAddressUpdateQueryVariables>(SubscriptionForAddressUpdateDocument, options);
      }
export function useSubscriptionForAddressUpdateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscriptionForAddressUpdateQuery, SubscriptionForAddressUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubscriptionForAddressUpdateQuery, SubscriptionForAddressUpdateQueryVariables>(SubscriptionForAddressUpdateDocument, options);
        }
export type SubscriptionForAddressUpdateQueryHookResult = ReturnType<typeof useSubscriptionForAddressUpdateQuery>;
export type SubscriptionForAddressUpdateLazyQueryHookResult = ReturnType<typeof useSubscriptionForAddressUpdateLazyQuery>;
export type SubscriptionForAddressUpdateQueryResult = Apollo.QueryResult<SubscriptionForAddressUpdateQuery, SubscriptionForAddressUpdateQueryVariables>;
export const SubscriptionsDocument = gql`
    query Subscriptions {
  orderSubscriptions {
    id
    insertedAt
    intervalInDays
    nextOrderCreationDates
    orderSubscriptionItems {
      currentItem {
        imgUrl
      }
    }
    status
    statusReason
    title
  }
}
    `;

/**
 * __useSubscriptionsQuery__
 *
 * To run a query within a React component, call `useSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(SubscriptionsDocument, options);
      }
export function useSubscriptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(SubscriptionsDocument, options);
        }
export type SubscriptionsQueryHookResult = ReturnType<typeof useSubscriptionsQuery>;
export type SubscriptionsLazyQueryHookResult = ReturnType<typeof useSubscriptionsLazyQuery>;
export type SubscriptionsQueryResult = Apollo.QueryResult<SubscriptionsQuery, SubscriptionsQueryVariables>;
export const TenantDocument = gql`
    query Tenant {
  tenant {
    analyticsConfig {
      gtm {
        containerId
      }
      projectId
      writeKey
    }
    botProtection {
      active
      provider
      siteKey {
        web
      }
    }
    id
    giftCardConfig {
      giftCardsEnabled
    }
    brandConfig {
      customCss
      audience
      copyright
      optInTextLocalized
      contactUrl
      supportEmail
      customizations {
        account {
          signinPageTitle
          signupPageTitle
          profilePageTitle
          valueprops {
            imgUrl
            text
          }
        }
        contacts {
          city
          countryCode
          line1
          line2
          phoneNumber
          showCountry
          state
          type
          zip
        }
        fonts {
          name
          style
          urls {
            format
            local
            url
          }
          weight
          meta {
            key
            value
          }
        }
        images {
          name
          src
          alt
        }
        links {
          location
          position
          title
          url
          newTab
        }
      }
      email
      logoUrl
      supportEmail
      title
      trackingFonts {
        isTrackingRequired
        resource
      }
      yearsAgeGate
      customTexts {
        body
        links {
          type
          key
          linkValue
          displayValue
        }
        location
        position
        type
      }
    }
    capabilities {
      signUp {
        enabled
      }
    }
    checkout {
      paymentOptions {
        defaultCurrencyCode
      }
      shippingOptions {
        shippingMethodsEnabled
      }
      vatInclusivePricing
      showCouponCodeCta
      version
    }
    giftConfig {
      giftingEnabled
    }
    contactConfig {
      shippingAddressConfig {
        requireValidation
        countriesAllowed {
          id
          name
        }
        note
        statesConfig {
          countryId
          statesAllowed {
            id
            name
          }
        }
        isStateRequired
        taxId
        companyName
        phoneNumberCountryCodesAllowed {
          code
          country
        }
      }
    }
    domain
    fallbackUrl
    paymentConfig {
      billingAddressConfig {
        requireValidation
        countriesAllowed {
          id
          name
        }
        note
        statesConfig {
          countryId
          statesAllowed {
            id
            name
          }
        }
      }
      paymentTypes {
        brandImgUrl
        id
        name
      }
      processor
      publicPaymentToken
    }
    shippingConfig {
      maxDeliveryWindowInDays
    }
    shoppingBagConfig {
      maxAmountForSelect
      minimumPurchaseAmount
      minimumPurchaseQty
      availableSubscriptionIntervalsInDays
      orderSubscriptionsEnabled
      subscriptionIntervalsInDays
    }
    userExperience {
      hasRequestedDeliveryDate
    }
    checkout {
      version
    }
  }
}
    `;

/**
 * __useTenantQuery__
 *
 * To run a query within a React component, call `useTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantQuery({
 *   variables: {
 *   },
 * });
 */
export function useTenantQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TenantQuery, TenantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TenantQuery, TenantQueryVariables>(TenantDocument, options);
      }
export function useTenantLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TenantQuery, TenantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TenantQuery, TenantQueryVariables>(TenantDocument, options);
        }
export type TenantQueryHookResult = ReturnType<typeof useTenantQuery>;
export type TenantLazyQueryHookResult = ReturnType<typeof useTenantLazyQuery>;
export type TenantQueryResult = Apollo.QueryResult<TenantQuery, TenantQueryVariables>;
export const UpdateCreditCardDefaultDocument = gql`
    mutation UpdateCreditCardDefault($input: UpdateCreditCardDefaultInput!) {
  updateCreditCardDefault(input: $input) {
    isDefault
  }
}
    `;
export type UpdateCreditCardDefaultMutationFn = Apollo.MutationFunction<UpdateCreditCardDefaultMutation, UpdateCreditCardDefaultMutationVariables>;

/**
 * __useUpdateCreditCardDefaultMutation__
 *
 * To run a mutation, you first call `useUpdateCreditCardDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreditCardDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreditCardDefaultMutation, { data, loading, error }] = useUpdateCreditCardDefaultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCreditCardDefaultMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCreditCardDefaultMutation, UpdateCreditCardDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCreditCardDefaultMutation, UpdateCreditCardDefaultMutationVariables>(UpdateCreditCardDefaultDocument, options);
      }
export type UpdateCreditCardDefaultMutationHookResult = ReturnType<typeof useUpdateCreditCardDefaultMutation>;
export type UpdateCreditCardDefaultMutationResult = Apollo.MutationResult<UpdateCreditCardDefaultMutation>;
export type UpdateCreditCardDefaultMutationOptions = Apollo.BaseMutationOptions<UpdateCreditCardDefaultMutation, UpdateCreditCardDefaultMutationVariables>;
export const UpdateUserFirstLastNameDocument = gql`
    mutation UpdateUserFirstLastName($input: UpdateUserFirstLastNameInput!) {
  updateUserFirstLastName(input: $input) {
    id
  }
}
    `;
export type UpdateUserFirstLastNameMutationFn = Apollo.MutationFunction<UpdateUserFirstLastNameMutation, UpdateUserFirstLastNameMutationVariables>;

/**
 * __useUpdateUserFirstLastNameMutation__
 *
 * To run a mutation, you first call `useUpdateUserFirstLastNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserFirstLastNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserFirstLastNameMutation, { data, loading, error }] = useUpdateUserFirstLastNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserFirstLastNameMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserFirstLastNameMutation, UpdateUserFirstLastNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserFirstLastNameMutation, UpdateUserFirstLastNameMutationVariables>(UpdateUserFirstLastNameDocument, options);
      }
export type UpdateUserFirstLastNameMutationHookResult = ReturnType<typeof useUpdateUserFirstLastNameMutation>;
export type UpdateUserFirstLastNameMutationResult = Apollo.MutationResult<UpdateUserFirstLastNameMutation>;
export type UpdateUserFirstLastNameMutationOptions = Apollo.BaseMutationOptions<UpdateUserFirstLastNameMutation, UpdateUserFirstLastNameMutationVariables>;
export const UpdateOrderSubscriptionAddressDocument = gql`
    mutation UpdateOrderSubscriptionAddress($subscriptionId: UUID4!, $input: UpdateOrderSubscriptionAddressInput!) {
  updateOrderSubscriptionAddress(id: $subscriptionId, input: $input) {
    id
  }
}
    `;
export type UpdateOrderSubscriptionAddressMutationFn = Apollo.MutationFunction<UpdateOrderSubscriptionAddressMutation, UpdateOrderSubscriptionAddressMutationVariables>;

/**
 * __useUpdateOrderSubscriptionAddressMutation__
 *
 * To run a mutation, you first call `useUpdateOrderSubscriptionAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderSubscriptionAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderSubscriptionAddressMutation, { data, loading, error }] = useUpdateOrderSubscriptionAddressMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderSubscriptionAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrderSubscriptionAddressMutation, UpdateOrderSubscriptionAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrderSubscriptionAddressMutation, UpdateOrderSubscriptionAddressMutationVariables>(UpdateOrderSubscriptionAddressDocument, options);
      }
export type UpdateOrderSubscriptionAddressMutationHookResult = ReturnType<typeof useUpdateOrderSubscriptionAddressMutation>;
export type UpdateOrderSubscriptionAddressMutationResult = Apollo.MutationResult<UpdateOrderSubscriptionAddressMutation>;
export type UpdateOrderSubscriptionAddressMutationOptions = Apollo.BaseMutationOptions<UpdateOrderSubscriptionAddressMutation, UpdateOrderSubscriptionAddressMutationVariables>;
export const UpdateOrderSubscriptionPaymentDocument = gql`
    mutation UpdateOrderSubscriptionPayment($id: UUID4!, $input: UpdateOrderSubscriptionPaymentInput!) {
  updateOrderSubscriptionPayment(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateOrderSubscriptionPaymentMutationFn = Apollo.MutationFunction<UpdateOrderSubscriptionPaymentMutation, UpdateOrderSubscriptionPaymentMutationVariables>;

/**
 * __useUpdateOrderSubscriptionPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateOrderSubscriptionPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderSubscriptionPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderSubscriptionPaymentMutation, { data, loading, error }] = useUpdateOrderSubscriptionPaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderSubscriptionPaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrderSubscriptionPaymentMutation, UpdateOrderSubscriptionPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrderSubscriptionPaymentMutation, UpdateOrderSubscriptionPaymentMutationVariables>(UpdateOrderSubscriptionPaymentDocument, options);
      }
export type UpdateOrderSubscriptionPaymentMutationHookResult = ReturnType<typeof useUpdateOrderSubscriptionPaymentMutation>;
export type UpdateOrderSubscriptionPaymentMutationResult = Apollo.MutationResult<UpdateOrderSubscriptionPaymentMutation>;
export type UpdateOrderSubscriptionPaymentMutationOptions = Apollo.BaseMutationOptions<UpdateOrderSubscriptionPaymentMutation, UpdateOrderSubscriptionPaymentMutationVariables>;
export const UpdateSubscriptionDocument = gql`
    mutation UpdateSubscription($id: UUID4!, $input: UpdateOrderSubscriptionInput!) {
  updateOrderSubscription(id: $id, input: $input) {
    id
    title
  }
}
    `;
export type UpdateSubscriptionMutationFn = Apollo.MutationFunction<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;

/**
 * __useUpdateSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionMutation, { data, loading, error }] = useUpdateSubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>(UpdateSubscriptionDocument, options);
      }
export type UpdateSubscriptionMutationHookResult = ReturnType<typeof useUpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationResult = Apollo.MutationResult<UpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;
export const UpdateSubscriptionStatusDocument = gql`
    mutation UpdateSubscriptionStatus($id: UUID4!, $input: UpdateOrderSubscriptionStatusInput!) {
  updateOrderSubscriptionStatus(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateSubscriptionStatusMutationFn = Apollo.MutationFunction<UpdateSubscriptionStatusMutation, UpdateSubscriptionStatusMutationVariables>;

/**
 * __useUpdateSubscriptionStatusMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionStatusMutation, { data, loading, error }] = useUpdateSubscriptionStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubscriptionStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSubscriptionStatusMutation, UpdateSubscriptionStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSubscriptionStatusMutation, UpdateSubscriptionStatusMutationVariables>(UpdateSubscriptionStatusDocument, options);
      }
export type UpdateSubscriptionStatusMutationHookResult = ReturnType<typeof useUpdateSubscriptionStatusMutation>;
export type UpdateSubscriptionStatusMutationResult = Apollo.MutationResult<UpdateSubscriptionStatusMutation>;
export type UpdateSubscriptionStatusMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionStatusMutation, UpdateSubscriptionStatusMutationVariables>;
export const UpdateUserAddressDocument = gql`
    mutation UpdateUserAddress($id: UUID4!, $input: UserAddressUpdateInput!) {
  updateUserAddress(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateUserAddressMutationFn = Apollo.MutationFunction<UpdateUserAddressMutation, UpdateUserAddressMutationVariables>;

/**
 * __useUpdateUserAddressMutation__
 *
 * To run a mutation, you first call `useUpdateUserAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAddressMutation, { data, loading, error }] = useUpdateUserAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserAddressMutation, UpdateUserAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserAddressMutation, UpdateUserAddressMutationVariables>(UpdateUserAddressDocument, options);
      }
export type UpdateUserAddressMutationHookResult = ReturnType<typeof useUpdateUserAddressMutation>;
export type UpdateUserAddressMutationResult = Apollo.MutationResult<UpdateUserAddressMutation>;
export type UpdateUserAddressMutationOptions = Apollo.BaseMutationOptions<UpdateUserAddressMutation, UpdateUserAddressMutationVariables>;
export const UpdateUserAddressDefaultDocument = gql`
    mutation UpdateUserAddressDefault($id: UUID4!, $input: UserAddressIsDefaultInput!) {
  updateUserAddressIsDefault(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateUserAddressDefaultMutationFn = Apollo.MutationFunction<UpdateUserAddressDefaultMutation, UpdateUserAddressDefaultMutationVariables>;

/**
 * __useUpdateUserAddressDefaultMutation__
 *
 * To run a mutation, you first call `useUpdateUserAddressDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAddressDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAddressDefaultMutation, { data, loading, error }] = useUpdateUserAddressDefaultMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserAddressDefaultMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserAddressDefaultMutation, UpdateUserAddressDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserAddressDefaultMutation, UpdateUserAddressDefaultMutationVariables>(UpdateUserAddressDefaultDocument, options);
      }
export type UpdateUserAddressDefaultMutationHookResult = ReturnType<typeof useUpdateUserAddressDefaultMutation>;
export type UpdateUserAddressDefaultMutationResult = Apollo.MutationResult<UpdateUserAddressDefaultMutation>;
export type UpdateUserAddressDefaultMutationOptions = Apollo.BaseMutationOptions<UpdateUserAddressDefaultMutation, UpdateUserAddressDefaultMutationVariables>;
export const UserAddressVerificationDocument = gql`
    mutation UserAddressVerification($input: VerifyAddressInput!) {
  userAddressVerification(input: $input) {
    ...VerifiedAddress
  }
}
    ${VerifiedAddressFragmentDoc}`;
export type UserAddressVerificationMutationFn = Apollo.MutationFunction<UserAddressVerificationMutation, UserAddressVerificationMutationVariables>;

/**
 * __useUserAddressVerificationMutation__
 *
 * To run a mutation, you first call `useUserAddressVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAddressVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAddressVerificationMutation, { data, loading, error }] = useUserAddressVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserAddressVerificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserAddressVerificationMutation, UserAddressVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserAddressVerificationMutation, UserAddressVerificationMutationVariables>(UserAddressVerificationDocument, options);
      }
export type UserAddressVerificationMutationHookResult = ReturnType<typeof useUserAddressVerificationMutation>;
export type UserAddressVerificationMutationResult = Apollo.MutationResult<UserAddressVerificationMutation>;
export type UserAddressVerificationMutationOptions = Apollo.BaseMutationOptions<UserAddressVerificationMutation, UserAddressVerificationMutationVariables>;
export const ValidatePasswordDocument = gql`
    query ValidatePassword($password: String!) {
  validatePassword(password: $password) {
    msg
    satisfied
  }
}
    `;

/**
 * __useValidatePasswordQuery__
 *
 * To run a query within a React component, call `useValidatePasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidatePasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidatePasswordQuery({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useValidatePasswordQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ValidatePasswordQuery, ValidatePasswordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ValidatePasswordQuery, ValidatePasswordQueryVariables>(ValidatePasswordDocument, options);
      }
export function useValidatePasswordLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ValidatePasswordQuery, ValidatePasswordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ValidatePasswordQuery, ValidatePasswordQueryVariables>(ValidatePasswordDocument, options);
        }
export type ValidatePasswordQueryHookResult = ReturnType<typeof useValidatePasswordQuery>;
export type ValidatePasswordLazyQueryHookResult = ReturnType<typeof useValidatePasswordLazyQuery>;
export type ValidatePasswordQueryResult = Apollo.QueryResult<ValidatePasswordQuery, ValidatePasswordQueryVariables>;
export const ValidateSessionDocument = gql`
    mutation validateSession($id: UUID4!) {
  validateSession(id: $id) {
    ...CheckoutSession
  }
}
    ${CheckoutSessionFragmentDoc}`;
export type ValidateSessionMutationFn = Apollo.MutationFunction<ValidateSessionMutation, ValidateSessionMutationVariables>;

/**
 * __useValidateSessionMutation__
 *
 * To run a mutation, you first call `useValidateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateSessionMutation, { data, loading, error }] = useValidateSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useValidateSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ValidateSessionMutation, ValidateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ValidateSessionMutation, ValidateSessionMutationVariables>(ValidateSessionDocument, options);
      }
export type ValidateSessionMutationHookResult = ReturnType<typeof useValidateSessionMutation>;
export type ValidateSessionMutationResult = Apollo.MutationResult<ValidateSessionMutation>;
export type ValidateSessionMutationOptions = Apollo.BaseMutationOptions<ValidateSessionMutation, ValidateSessionMutationVariables>;
export const VerifyAddressDocument = gql`
    mutation VerifyAddress($id: UUID4!) {
  verifyAddress(id: $id) {
    id
  }
}
    `;
export type VerifyAddressMutationFn = Apollo.MutationFunction<VerifyAddressMutation, VerifyAddressMutationVariables>;

/**
 * __useVerifyAddressMutation__
 *
 * To run a mutation, you first call `useVerifyAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAddressMutation, { data, loading, error }] = useVerifyAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVerifyAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VerifyAddressMutation, VerifyAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<VerifyAddressMutation, VerifyAddressMutationVariables>(VerifyAddressDocument, options);
      }
export type VerifyAddressMutationHookResult = ReturnType<typeof useVerifyAddressMutation>;
export type VerifyAddressMutationResult = Apollo.MutationResult<VerifyAddressMutation>;
export type VerifyAddressMutationOptions = Apollo.BaseMutationOptions<VerifyAddressMutation, VerifyAddressMutationVariables>;
export const VerifyUserDocument = gql`
    mutation verifyUser($input: VerifyUserInput!) {
  verifyUser(input: $input) {
    id
    firstName
    lastName
  }
}
    `;
export type VerifyUserMutationFn = Apollo.MutationFunction<VerifyUserMutation, VerifyUserMutationVariables>;

/**
 * __useVerifyUserMutation__
 *
 * To run a mutation, you first call `useVerifyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyUserMutation, { data, loading, error }] = useVerifyUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VerifyUserMutation, VerifyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<VerifyUserMutation, VerifyUserMutationVariables>(VerifyUserDocument, options);
      }
export type VerifyUserMutationHookResult = ReturnType<typeof useVerifyUserMutation>;
export type VerifyUserMutationResult = Apollo.MutationResult<VerifyUserMutation>;
export type VerifyUserMutationOptions = Apollo.BaseMutationOptions<VerifyUserMutation, VerifyUserMutationVariables>;